
const fips = [
        {
            "Code": "01001",
            "County": "Autauga",
            "State": "AL"
        },
        {
            "Code": "01003",
            "County": "Baldwin",
            "State": "AL"
        },
        {
            "Code": "01005",
            "County": "Barbour",
            "State": "AL"
        },
        {
            "Code": "01007",
            "County": "Bibb",
            "State": "AL"
        },
        {
            "Code": "01009",
            "County": "Blount",
            "State": "AL"
        },
        {
            "Code": "01011",
            "County": "Bullock",
            "State": "AL"
        },
        {
            "Code": "01013",
            "County": "Butler",
            "State": "AL"
        },
        {
            "Code": "01015",
            "County": "Calhoun",
            "State": "AL"
        },
        {
            "Code": "01017",
            "County": "Chambers",
            "State": "AL"
        },
        {
            "Code": "01019",
            "County": "Cherokee",
            "State": "AL"
        },
        {
            "Code": "01021",
            "County": "Chilton",
            "State": "AL"
        },
        {
            "Code": "01023",
            "County": "Choctaw",
            "State": "AL"
        },
        {
            "Code": "01025",
            "County": "Clarke",
            "State": "AL"
        },
        {
            "Code": "01027",
            "County": "Clay",
            "State": "AL"
        },
        {
            "Code": "01029",
            "County": "Cleburne",
            "State": "AL"
        },
        {
            "Code": "01031",
            "County": "Coffee",
            "State": "AL"
        },
        {
            "Code": "01033",
            "County": "Colbert",
            "State": "AL"
        },
        {
            "Code": "01035",
            "County": "Conecuh",
            "State": "AL"
        },
        {
            "Code": "01037",
            "County": "Coosa",
            "State": "AL"
        },
        {
            "Code": "01039",
            "County": "Covington",
            "State": "AL"
        },
        {
            "Code": "01041",
            "County": "Crenshaw",
            "State": "AL"
        },
        {
            "Code": "01043",
            "County": "Cullman",
            "State": "AL"
        },
        {
            "Code": "01045",
            "County": "Dale",
            "State": "AL"
        },
        {
            "Code": "01047",
            "County": "Dallas",
            "State": "AL"
        },
        {
            "Code": "01049",
            "County": "De Kalb",
            "State": "AL"
        },
        {
            "Code": "01051",
            "County": "Elmore",
            "State": "AL"
        },
        {
            "Code": "01053",
            "County": "Escambia",
            "State": "AL"
        },
        {
            "Code": "01055",
            "County": "Etowah",
            "State": "AL"
        },
        {
            "Code": "01057",
            "County": "Fayette",
            "State": "AL"
        },
        {
            "Code": "01059",
            "County": "Franklin",
            "State": "AL"
        },
        {
            "Code": "01061",
            "County": "Geneva",
            "State": "AL"
        },
        {
            "Code": "01063",
            "County": "Greene",
            "State": "AL"
        },
        {
            "Code": "01065",
            "County": "Hale",
            "State": "AL"
        },
        {
            "Code": "01067",
            "County": "Henry",
            "State": "AL"
        },
        {
            "Code": "01069",
            "County": "Houston",
            "State": "AL"
        },
        {
            "Code": "01071",
            "County": "Jackson",
            "State": "AL"
        },
        {
            "Code": "01073",
            "County": "Jefferson",
            "State": "AL"
        },
        {
            "Code": "01075",
            "County": "Lamar",
            "State": "AL"
        },
        {
            "Code": "01077",
            "County": "Lauderdale",
            "State": "AL"
        },
        {
            "Code": "01079",
            "County": "Lawrence",
            "State": "AL"
        },
        {
            "Code": "01081",
            "County": "Lee",
            "State": "AL"
        },
        {
            "Code": "01083",
            "County": "Limestone",
            "State": "AL"
        },
        {
            "Code": "01085",
            "County": "Lowndes",
            "State": "AL"
        },
        {
            "Code": "01087",
            "County": "Macon",
            "State": "AL"
        },
        {
            "Code": "01089",
            "County": "Madison",
            "State": "AL"
        },
        {
            "Code": "01091",
            "County": "Marengo",
            "State": "AL"
        },
        {
            "Code": "01093",
            "County": "Marion",
            "State": "AL"
        },
        {
            "Code": "01095",
            "County": "Marshall",
            "State": "AL"
        },
        {
            "Code": "01097",
            "County": "Mobile",
            "State": "AL"
        },
        {
            "Code": "01099",
            "County": "Monroe",
            "State": "AL"
        },
        {
            "Code": "01101",
            "County": "Montgomery",
            "State": "AL"
        },
        {
            "Code": "01103",
            "County": "Morgan",
            "State": "AL"
        },
        {
            "Code": "01105",
            "County": "Perry",
            "State": "AL"
        },
        {
            "Code": "01107",
            "County": "Pickens",
            "State": "AL"
        },
        {
            "Code": "01109",
            "County": "Pike",
            "State": "AL"
        },
        {
            "Code": "01111",
            "County": "Randolph",
            "State": "AL"
        },
        {
            "Code": "01113",
            "County": "Russell",
            "State": "AL"
        },
        {
            "Code": "01115",
            "County": "St Clair",
            "State": "AL"
        },
        {
            "Code": "01117",
            "County": "Shelby",
            "State": "AL"
        },
        {
            "Code": "01119",
            "County": "Sumter",
            "State": "AL"
        },
        {
            "Code": "01121",
            "County": "Talladega",
            "State": "AL"
        },
        {
            "Code": "01123",
            "County": "Tallapoosa",
            "State": "AL"
        },
        {
            "Code": "01125",
            "County": "Tuscaloosa",
            "State": "AL"
        },
        {
            "Code": "01127",
            "County": "Walker",
            "State": "AL"
        },
        {
            "Code": "01129",
            "County": "Washington",
            "State": "AL"
        },
        {
            "Code": "01131",
            "County": "Wilcox",
            "State": "AL"
        },
        {
            "Code": "01133",
            "County": "Winston",
            "State": "AL"
        },
        {
            "Code": "02013",
            "County": "Aleutians East",
            "State": "AK"
        },
        {
            "Code": "02016",
            "County": "Aleutians West",
            "State": "AK"
        },
        {
            "Code": "02020",
            "County": "Anchorage",
            "State": "AK"
        },
        {
            "Code": "02050",
            "County": "Bethel",
            "State": "AK"
        },
        {
            "Code": "02060",
            "County": "Bristol Bay",
            "State": "AK"
        },
        {
            "Code": "02068",
            "County": "Denali",
            "State": "AK"
        },
        {
            "Code": "02070",
            "County": "Dillingham",
            "State": "AK"
        },
        {
            "Code": "02090",
            "County": "Fairbanks North Star",
            "State": "AK"
        },
        {
            "Code": "02100",
            "County": "Haines",
            "State": "AK"
        },
        {
            "Code": "02110",
            "County": "Juneau",
            "State": "AK"
        },
        {
            "Code": "02122",
            "County": "Kenai Peninsula",
            "State": "AK"
        },
        {
            "Code": "02130",
            "County": "Ketchikan Gateway",
            "State": "AK"
        },
        {
            "Code": "02150",
            "County": "Kodiak Island",
            "State": "AK"
        },
        {
            "Code": "02164",
            "County": "Lake and Peninsula",
            "State": "AK"
        },
        {
            "Code": "02170",
            "County": "Matanuska-Susitna",
            "State": "AK"
        },
        {
            "Code": "02180",
            "County": "Nome",
            "State": "AK"
        },
        {
            "Code": "02185",
            "County": "North Slope",
            "State": "AK"
        },
        {
            "Code": "02188",
            "County": "Northwest Arctic",
            "State": "AK"
        },
        {
            "Code": "02201",
            "County": "Prince of Wales-Outer Ketchikan",
            "State": "AK"
        },
        {
            "Code": "02220",
            "County": "Sitka",
            "State": "AK"
        },
        {
            "Code": "02232",
            "County": "Skagway-Hoonah-Angoon",
            "State": "AK"
        },
        {
            "Code": "02240",
            "County": "Southeast Fairbanks",
            "State": "AK"
        },
        {
            "Code": "02261",
            "County": "Valdez-Cordova",
            "State": "AK"
        },
        {
            "Code": "02270",
            "County": "Wade Hampton",
            "State": "AK"
        },
        {
            "Code": "02280",
            "County": "Wrangell-Petersburg",
            "State": "AK"
        },
        {
            "Code": "02282",
            "County": "Yakutat",
            "State": "AK"
        },
        {
            "Code": "02290",
            "County": "Yukon-Koyukuk",
            "State": "AK"
        },
        {
            "Code": "04001",
            "County": "Apache",
            "State": "AZ"
        },
        {
            "Code": "04003",
            "County": "Cochise",
            "State": "AZ"
        },
        {
            "Code": "04005",
            "County": "Coconino",
            "State": "AZ"
        },
        {
            "Code": "04007",
            "County": "Gila",
            "State": "AZ"
        },
        {
            "Code": "04009",
            "County": "Graham",
            "State": "AZ"
        },
        {
            "Code": "04011",
            "County": "Greenlee",
            "State": "AZ"
        },
        {
            "Code": "04012",
            "County": "La Paz",
            "State": "AZ"
        },
        {
            "Code": "04013",
            "County": "Maricopa",
            "State": "AZ"
        },
        {
            "Code": "04015",
            "County": "Mohave",
            "State": "AZ"
        },
        {
            "Code": "04017",
            "County": "Navajo",
            "State": "AZ"
        },
        {
            "Code": "04019",
            "County": "Pima",
            "State": "AZ"
        },
        {
            "Code": "04021",
            "County": "Pinal",
            "State": "AZ"
        },
        {
            "Code": "04023",
            "County": "Santa Cruz",
            "State": "AZ"
        },
        {
            "Code": "04025",
            "County": "Yavapai",
            "State": "AZ"
        },
        {
            "Code": "04027",
            "County": "Yuma",
            "State": "AZ"
        },
        {
            "Code": "05001",
            "County": "Arkansas",
            "State": "AR"
        },
        {
            "Code": "05003",
            "County": "Ashley",
            "State": "AR"
        },
        {
            "Code": "05005",
            "County": "Baxter",
            "State": "AR"
        },
        {
            "Code": "05007",
            "County": "Benton",
            "State": "AR"
        },
        {
            "Code": "05009",
            "County": "Boone",
            "State": "AR"
        },
        {
            "Code": "05011",
            "County": "Bradley",
            "State": "AR"
        },
        {
            "Code": "05013",
            "County": "Calhoun",
            "State": "AR"
        },
        {
            "Code": "05015",
            "County": "Carroll",
            "State": "AR"
        },
        {
            "Code": "05017",
            "County": "Chicot",
            "State": "AR"
        },
        {
            "Code": "05019",
            "County": "Clark",
            "State": "AR"
        },
        {
            "Code": "05021",
            "County": "Clay",
            "State": "AR"
        },
        {
            "Code": "05023",
            "County": "Cleburne",
            "State": "AR"
        },
        {
            "Code": "05025",
            "County": "Cleveland",
            "State": "AR"
        },
        {
            "Code": "05027",
            "County": "Columbia",
            "State": "AR"
        },
        {
            "Code": "05029",
            "County": "Conway",
            "State": "AR"
        },
        {
            "Code": "05031",
            "County": "Craighead",
            "State": "AR"
        },
        {
            "Code": "05033",
            "County": "Crawford",
            "State": "AR"
        },
        {
            "Code": "05035",
            "County": "Crittenden",
            "State": "AR"
        },
        {
            "Code": "05037",
            "County": "Cross",
            "State": "AR"
        },
        {
            "Code": "05039",
            "County": "Dallas",
            "State": "AR"
        },
        {
            "Code": "05041",
            "County": "Desha",
            "State": "AR"
        },
        {
            "Code": "05043",
            "County": "Drew",
            "State": "AR"
        },
        {
            "Code": "05045",
            "County": "Faulkner",
            "State": "AR"
        },
        {
            "Code": "05047",
            "County": "Franklin",
            "State": "AR"
        },
        {
            "Code": "05049",
            "County": "Fulton",
            "State": "AR"
        },
        {
            "Code": "05051",
            "County": "Garland",
            "State": "AR"
        },
        {
            "Code": "05053",
            "County": "Grant",
            "State": "AR"
        },
        {
            "Code": "05055",
            "County": "Greene",
            "State": "AR"
        },
        {
            "Code": "05057",
            "County": "Hempstead",
            "State": "AR"
        },
        {
            "Code": "05059",
            "County": "Hot Spring",
            "State": "AR"
        },
        {
            "Code": "05061",
            "County": "Howard",
            "State": "AR"
        },
        {
            "Code": "05063",
            "County": "Independence",
            "State": "AR"
        },
        {
            "Code": "05065",
            "County": "Izard",
            "State": "AR"
        },
        {
            "Code": "05067",
            "County": "Jackson",
            "State": "AR"
        },
        {
            "Code": "05069",
            "County": "Jefferson",
            "State": "AR"
        },
        {
            "Code": "05071",
            "County": "Johnson",
            "State": "AR"
        },
        {
            "Code": "05073",
            "County": "Lafayette",
            "State": "AR"
        },
        {
            "Code": "05075",
            "County": "Lawrence",
            "State": "AR"
        },
        {
            "Code": "05077",
            "County": "Lee",
            "State": "AR"
        },
        {
            "Code": "05079",
            "County": "Lincoln",
            "State": "AR"
        },
        {
            "Code": "05081",
            "County": "Little River",
            "State": "AR"
        },
        {
            "Code": "05083",
            "County": "Logan",
            "State": "AR"
        },
        {
            "Code": "05085",
            "County": "Lonoke",
            "State": "AR"
        },
        {
            "Code": "05087",
            "County": "Madison",
            "State": "AR"
        },
        {
            "Code": "05089",
            "County": "Marion",
            "State": "AR"
        },
        {
            "Code": "05091",
            "County": "Miller",
            "State": "AR"
        },
        {
            "Code": "05093",
            "County": "Mississippi",
            "State": "AR"
        },
        {
            "Code": "05095",
            "County": "Monroe",
            "State": "AR"
        },
        {
            "Code": "05097",
            "County": "Montgomery",
            "State": "AR"
        },
        {
            "Code": "05099",
            "County": "Nevada",
            "State": "AR"
        },
        {
            "Code": "05101",
            "County": "Newton",
            "State": "AR"
        },
        {
            "Code": "05103",
            "County": "Ouachita",
            "State": "AR"
        },
        {
            "Code": "05105",
            "County": "Perry",
            "State": "AR"
        },
        {
            "Code": "05107",
            "County": "Phillips",
            "State": "AR"
        },
        {
            "Code": "05109",
            "County": "Pike",
            "State": "AR"
        },
        {
            "Code": "05111",
            "County": "Poinsett",
            "State": "AR"
        },
        {
            "Code": "05113",
            "County": "Polk",
            "State": "AR"
        },
        {
            "Code": "05115",
            "County": "Pope",
            "State": "AR"
        },
        {
            "Code": "05117",
            "County": "Prairie",
            "State": "AR"
        },
        {
            "Code": "05119",
            "County": "Pulaski",
            "State": "AR"
        },
        {
            "Code": "05121",
            "County": "Randolph",
            "State": "AR"
        },
        {
            "Code": "05123",
            "County": "St Francis",
            "State": "AR"
        },
        {
            "Code": "05125",
            "County": "Saline",
            "State": "AR"
        },
        {
            "Code": "05127",
            "County": "Scott",
            "State": "AR"
        },
        {
            "Code": "05129",
            "County": "Searcy",
            "State": "AR"
        },
        {
            "Code": "05131",
            "County": "Sebastian",
            "State": "AR"
        },
        {
            "Code": "05133",
            "County": "Sevier",
            "State": "AR"
        },
        {
            "Code": "05135",
            "County": "Sharp",
            "State": "AR"
        },
        {
            "Code": "05137",
            "County": "Stone",
            "State": "AR"
        },
        {
            "Code": "05139",
            "County": "Union",
            "State": "AR"
        },
        {
            "Code": "05141",
            "County": "Van Buren",
            "State": "AR"
        },
        {
            "Code": "05143",
            "County": "Washington",
            "State": "AR"
        },
        {
            "Code": "05145",
            "County": "White",
            "State": "AR"
        },
        {
            "Code": "05147",
            "County": "Woodruff",
            "State": "AR"
        },
        {
            "Code": "05149",
            "County": "Yell",
            "State": "AR"
        },
        {
            "Code": "06001",
            "County": "Alameda",
            "State": "CA"
        },
        {
            "Code": "06003",
            "County": "Alpine",
            "State": "CA"
        },
        {
            "Code": "06005",
            "County": "Amador",
            "State": "CA"
        },
        {
            "Code": "06007",
            "County": "Butte",
            "State": "CA"
        },
        {
            "Code": "06009",
            "County": "Calaveras",
            "State": "CA"
        },
        {
            "Code": "06011",
            "County": "Colusa",
            "State": "CA"
        },
        {
            "Code": "06013",
            "County": "Contra Costa",
            "State": "CA"
        },
        {
            "Code": "06015",
            "County": "Del Norte",
            "State": "CA"
        },
        {
            "Code": "06017",
            "County": "El Dorado",
            "State": "CA"
        },
        {
            "Code": "06019",
            "County": "Fresno",
            "State": "CA"
        },
        {
            "Code": "06021",
            "County": "Glenn",
            "State": "CA"
        },
        {
            "Code": "06023",
            "County": "Humboldt",
            "State": "CA"
        },
        {
            "Code": "06025",
            "County": "Imperial",
            "State": "CA"
        },
        {
            "Code": "06027",
            "County": "Inyo",
            "State": "CA"
        },
        {
            "Code": "06029",
            "County": "Kern",
            "State": "CA"
        },
        {
            "Code": "06031",
            "County": "Kings",
            "State": "CA"
        },
        {
            "Code": "06033",
            "County": "Lake",
            "State": "CA"
        },
        {
            "Code": "06035",
            "County": "Lassen",
            "State": "CA"
        },
        {
            "Code": "06037",
            "County": "Los Angeles",
            "State": "CA"
        },
        {
            "Code": "06039",
            "County": "Madera",
            "State": "CA"
        },
        {
            "Code": "06041",
            "County": "Marin",
            "State": "CA"
        },
        {
            "Code": "06043",
            "County": "Mariposa",
            "State": "CA"
        },
        {
            "Code": "06045",
            "County": "Mendocino",
            "State": "CA"
        },
        {
            "Code": "06047",
            "County": "Merced",
            "State": "CA"
        },
        {
            "Code": "06049",
            "County": "Modoc",
            "State": "CA"
        },
        {
            "Code": "06051",
            "County": "Mono",
            "State": "CA"
        },
        {
            "Code": "06053",
            "County": "Monterey",
            "State": "CA"
        },
        {
            "Code": "06055",
            "County": "Napa",
            "State": "CA"
        },
        {
            "Code": "06057",
            "County": "Nevada",
            "State": "CA"
        },
        {
            "Code": "06059",
            "County": "Orange",
            "State": "CA"
        },
        {
            "Code": "06061",
            "County": "Placer",
            "State": "CA"
        },
        {
            "Code": "06063",
            "County": "Plumas",
            "State": "CA"
        },
        {
            "Code": "06065",
            "County": "Riverside",
            "State": "CA"
        },
        {
            "Code": "06067",
            "County": "Sacramento",
            "State": "CA"
        },
        {
            "Code": "06069",
            "County": "San Benito",
            "State": "CA"
        },
        {
            "Code": "06071",
            "County": "San Bernardino",
            "State": "CA"
        },
        {
            "Code": "06073",
            "County": "San Diego",
            "State": "CA"
        },
        {
            "Code": "06075",
            "County": "San Francisco",
            "State": "CA"
        },
        {
            "Code": "06077",
            "County": "San Joaquin",
            "State": "CA"
        },
        {
            "Code": "06079",
            "County": "San Luis Obispo",
            "State": "CA"
        },
        {
            "Code": "06081",
            "County": "San Mateo",
            "State": "CA"
        },
        {
            "Code": "06083",
            "County": "Santa Barbara",
            "State": "CA"
        },
        {
            "Code": "06085",
            "County": "Santa Clara",
            "State": "CA"
        },
        {
            "Code": "06087",
            "County": "Santa Cruz",
            "State": "CA"
        },
        {
            "Code": "06089",
            "County": "Shasta",
            "State": "CA"
        },
        {
            "Code": "06091",
            "County": "Sierra",
            "State": "CA"
        },
        {
            "Code": "06093",
            "County": "Siskiyou",
            "State": "CA"
        },
        {
            "Code": "06095",
            "County": "Solano",
            "State": "CA"
        },
        {
            "Code": "06097",
            "County": "Sonoma",
            "State": "CA"
        },
        {
            "Code": "06099",
            "County": "Stanislaus",
            "State": "CA"
        },
        {
            "Code": "06101",
            "County": "Sutter",
            "State": "CA"
        },
        {
            "Code": "06103",
            "County": "Tehama",
            "State": "CA"
        },
        {
            "Code": "06105",
            "County": "Trinity",
            "State": "CA"
        },
        {
            "Code": "06107",
            "County": "Tulare",
            "State": "CA"
        },
        {
            "Code": "06109",
            "County": "Tuolumne",
            "State": "CA"
        },
        {
            "Code": "06111",
            "County": "Ventura",
            "State": "CA"
        },
        {
            "Code": "06113",
            "County": "Yolo",
            "State": "CA"
        },
        {
            "Code": "06115",
            "County": "Yuba",
            "State": "CA"
        },
        {
            "Code": "08001",
            "County": "Adams",
            "State": "CO"
        },
        {
            "Code": "08003",
            "County": "Alamosa",
            "State": "CO"
        },
        {
            "Code": "08005",
            "County": "Arapahoe",
            "State": "CO"
        },
        {
            "Code": "08007",
            "County": "Archuleta",
            "State": "CO"
        },
        {
            "Code": "08009",
            "County": "Baca",
            "State": "CO"
        },
        {
            "Code": "08011",
            "County": "Bent",
            "State": "CO"
        },
        {
            "Code": "08013",
            "County": "Boulder",
            "State": "CO"
        },
        {
            "Code": "08015",
            "County": "Chaffee",
            "State": "CO"
        },
        {
            "Code": "08017",
            "County": "Cheyenne",
            "State": "CO"
        },
        {
            "Code": "08019",
            "County": "Clear Creek",
            "State": "CO"
        },
        {
            "Code": "08021",
            "County": "Conejos",
            "State": "CO"
        },
        {
            "Code": "08023",
            "County": "Costilla",
            "State": "CO"
        },
        {
            "Code": "08025",
            "County": "Crowley",
            "State": "CO"
        },
        {
            "Code": "08027",
            "County": "Custer",
            "State": "CO"
        },
        {
            "Code": "08029",
            "County": "Delta",
            "State": "CO"
        },
        {
            "Code": "08031",
            "County": "Denver",
            "State": "CO"
        },
        {
            "Code": "08033",
            "County": "Dolores",
            "State": "CO"
        },
        {
            "Code": "08035",
            "County": "Douglas",
            "State": "CO"
        },
        {
            "Code": "08037",
            "County": "Eagle",
            "State": "CO"
        },
        {
            "Code": "08039",
            "County": "Elbert",
            "State": "CO"
        },
        {
            "Code": "08041",
            "County": "El Paso",
            "State": "CO"
        },
        {
            "Code": "08043",
            "County": "Fremont",
            "State": "CO"
        },
        {
            "Code": "08045",
            "County": "Garfield",
            "State": "CO"
        },
        {
            "Code": "08047",
            "County": "Gilpin",
            "State": "CO"
        },
        {
            "Code": "08049",
            "County": "Grand",
            "State": "CO"
        },
        {
            "Code": "08051",
            "County": "Gunnison",
            "State": "CO"
        },
        {
            "Code": "08053",
            "County": "Hinsdale",
            "State": "CO"
        },
        {
            "Code": "08055",
            "County": "Huerfano",
            "State": "CO"
        },
        {
            "Code": "08057",
            "County": "Jackson",
            "State": "CO"
        },
        {
            "Code": "08059",
            "County": "Jefferson",
            "State": "CO"
        },
        {
            "Code": "08061",
            "County": "Kiowa",
            "State": "CO"
        },
        {
            "Code": "08063",
            "County": "Kit Carson",
            "State": "CO"
        },
        {
            "Code": "08065",
            "County": "Lake",
            "State": "CO"
        },
        {
            "Code": "08067",
            "County": "La Plata",
            "State": "CO"
        },
        {
            "Code": "08069",
            "County": "Larimer",
            "State": "CO"
        },
        {
            "Code": "08071",
            "County": "Las Animas",
            "State": "CO"
        },
        {
            "Code": "08073",
            "County": "Lincoln",
            "State": "CO"
        },
        {
            "Code": "08075",
            "County": "Logan",
            "State": "CO"
        },
        {
            "Code": "08077",
            "County": "Mesa",
            "State": "CO"
        },
        {
            "Code": "08079",
            "County": "Mineral",
            "State": "CO"
        },
        {
            "Code": "08081",
            "County": "Moffat",
            "State": "CO"
        },
        {
            "Code": "08083",
            "County": "Montezuma",
            "State": "CO"
        },
        {
            "Code": "08085",
            "County": "Montrose",
            "State": "CO"
        },
        {
            "Code": "08087",
            "County": "Morgan",
            "State": "CO"
        },
        {
            "Code": "08089",
            "County": "Otero",
            "State": "CO"
        },
        {
            "Code": "08091",
            "County": "Ouray",
            "State": "CO"
        },
        {
            "Code": "08093",
            "County": "Park",
            "State": "CO"
        },
        {
            "Code": "08095",
            "County": "Phillips",
            "State": "CO"
        },
        {
            "Code": "08097",
            "County": "Pitkin",
            "State": "CO"
        },
        {
            "Code": "08099",
            "County": "Prowers",
            "State": "CO"
        },
        {
            "Code": "08101",
            "County": "Pueblo",
            "State": "CO"
        },
        {
            "Code": "08103",
            "County": "Rio Blanco",
            "State": "CO"
        },
        {
            "Code": "08105",
            "County": "Rio Grande",
            "State": "CO"
        },
        {
            "Code": "08107",
            "County": "Routt",
            "State": "CO"
        },
        {
            "Code": "08109",
            "County": "Saguache",
            "State": "CO"
        },
        {
            "Code": "08111",
            "County": "San Juan",
            "State": "CO"
        },
        {
            "Code": "08113",
            "County": "San Miguel",
            "State": "CO"
        },
        {
            "Code": "08115",
            "County": "Sedgwick",
            "State": "CO"
        },
        {
            "Code": "08117",
            "County": "Summit",
            "State": "CO"
        },
        {
            "Code": "08119",
            "County": "Teller",
            "State": "CO"
        },
        {
            "Code": "08121",
            "County": "Washington",
            "State": "CO"
        },
        {
            "Code": "08123",
            "County": "Weld",
            "State": "CO"
        },
        {
            "Code": "08125",
            "County": "Yuma",
            "State": "CO"
        },
        {
            "Code": "09001",
            "County": "Fairfield",
            "State": "CT"
        },
        {
            "Code": "09003",
            "County": "Hartford",
            "State": "CT"
        },
        {
            "Code": "09005",
            "County": "Litchfield",
            "State": "CT"
        },
        {
            "Code": "09007",
            "County": "Middlesex",
            "State": "CT"
        },
        {
            "Code": "09009",
            "County": "New Haven",
            "State": "CT"
        },
        {
            "Code": "09011",
            "County": "New London",
            "State": "CT"
        },
        {
            "Code": "09013",
            "County": "Tolland",
            "State": "CT"
        },
        {
            "Code": "09015",
            "County": "Windham",
            "State": "CT"
        },
        {
            "Code": "10001",
            "County": "Kent",
            "State": "DE"
        },
        {
            "Code": "10003",
            "County": "New Castle",
            "State": "DE"
        },
        {
            "Code": "10005",
            "County": "Sussex",
            "State": "DE"
        },
        {
            "Code": "11001",
            "County": "Washington",
            "State": "DC"
        },
        {
            "Code": "12001",
            "County": "Alachua",
            "State": "FL"
        },
        {
            "Code": "12003",
            "County": "Baker",
            "State": "FL"
        },
        {
            "Code": "12005",
            "County": "Bay",
            "State": "FL"
        },
        {
            "Code": "12007",
            "County": "Bradford",
            "State": "FL"
        },
        {
            "Code": "12009",
            "County": "Brevard",
            "State": "FL"
        },
        {
            "Code": "12011",
            "County": "Broward",
            "State": "FL"
        },
        {
            "Code": "12013",
            "County": "Calhoun",
            "State": "FL"
        },
        {
            "Code": "12015",
            "County": "Charlotte",
            "State": "FL"
        },
        {
            "Code": "12017",
            "County": "Citrus",
            "State": "FL"
        },
        {
            "Code": "12019",
            "County": "Clay",
            "State": "FL"
        },
        {
            "Code": "12021",
            "County": "Collier",
            "State": "FL"
        },
        {
            "Code": "12023",
            "County": "Columbia",
            "State": "FL"
        },
        {
            "Code": "12027",
            "County": "De Soto",
            "State": "FL"
        },
        {
            "Code": "12029",
            "County": "Dixie",
            "State": "FL"
        },
        {
            "Code": "12031",
            "County": "Duval",
            "State": "FL"
        },
        {
            "Code": "12033",
            "County": "Escambia",
            "State": "FL"
        },
        {
            "Code": "12035",
            "County": "Flagler",
            "State": "FL"
        },
        {
            "Code": "12037",
            "County": "Franklin",
            "State": "FL"
        },
        {
            "Code": "12039",
            "County": "Gadsden",
            "State": "FL"
        },
        {
            "Code": "12041",
            "County": "Gilchrist",
            "State": "FL"
        },
        {
            "Code": "12043",
            "County": "Glades",
            "State": "FL"
        },
        {
            "Code": "12045",
            "County": "Gulf",
            "State": "FL"
        },
        {
            "Code": "12047",
            "County": "Hamilton",
            "State": "FL"
        },
        {
            "Code": "12049",
            "County": "Hardee",
            "State": "FL"
        },
        {
            "Code": "12051",
            "County": "Hendry",
            "State": "FL"
        },
        {
            "Code": "12053",
            "County": "Hernando",
            "State": "FL"
        },
        {
            "Code": "12055",
            "County": "Highlands",
            "State": "FL"
        },
        {
            "Code": "12057",
            "County": "Hillsborough",
            "State": "FL"
        },
        {
            "Code": "12059",
            "County": "Holmes",
            "State": "FL"
        },
        {
            "Code": "12061",
            "County": "Indian River",
            "State": "FL"
        },
        {
            "Code": "12063",
            "County": "Jackson",
            "State": "FL"
        },
        {
            "Code": "12065",
            "County": "Jefferson",
            "State": "FL"
        },
        {
            "Code": "12067",
            "County": "Lafayette",
            "State": "FL"
        },
        {
            "Code": "12069",
            "County": "Lake",
            "State": "FL"
        },
        {
            "Code": "12071",
            "County": "Lee",
            "State": "FL"
        },
        {
            "Code": "12073",
            "County": "Leon",
            "State": "FL"
        },
        {
            "Code": "12075",
            "County": "Levy",
            "State": "FL"
        },
        {
            "Code": "12077",
            "County": "Liberty",
            "State": "FL"
        },
        {
            "Code": "12079",
            "County": "Madison",
            "State": "FL"
        },
        {
            "Code": "12081",
            "County": "Manatee",
            "State": "FL"
        },
        {
            "Code": "12083",
            "County": "Marion",
            "State": "FL"
        },
        {
            "Code": "12085",
            "County": "Martin",
            "State": "FL"
        },
        {
            "Code": "12086",
            "County": "Miami-Dade",
            "State": "FL"
        },
        {
            "Code": "12087",
            "County": "Monroe",
            "State": "FL"
        },
        {
            "Code": "12089",
            "County": "Nassau",
            "State": "FL"
        },
        {
            "Code": "12091",
            "County": "Okaloosa",
            "State": "FL"
        },
        {
            "Code": "12093",
            "County": "Okeechobee",
            "State": "FL"
        },
        {
            "Code": "12095",
            "County": "Orange",
            "State": "FL"
        },
        {
            "Code": "12097",
            "County": "Osceola",
            "State": "FL"
        },
        {
            "Code": "12099",
            "County": "Palm Beach",
            "State": "FL"
        },
        {
            "Code": "12101",
            "County": "Pasco",
            "State": "FL"
        },
        {
            "Code": "12103",
            "County": "Pinellas",
            "State": "FL"
        },
        {
            "Code": "12105",
            "County": "Polk",
            "State": "FL"
        },
        {
            "Code": "12107",
            "County": "Putnam",
            "State": "FL"
        },
        {
            "Code": "12109",
            "County": "St Johns",
            "State": "FL"
        },
        {
            "Code": "12111",
            "County": "St Lucie",
            "State": "FL"
        },
        {
            "Code": "12113",
            "County": "Santa Rosa",
            "State": "FL"
        },
        {
            "Code": "12115",
            "County": "Sarasota",
            "State": "FL"
        },
        {
            "Code": "12117",
            "County": "Seminole",
            "State": "FL"
        },
        {
            "Code": "12119",
            "County": "Sumter",
            "State": "FL"
        },
        {
            "Code": "12121",
            "County": "Suwannee",
            "State": "FL"
        },
        {
            "Code": "12123",
            "County": "Taylor",
            "State": "FL"
        },
        {
            "Code": "12125",
            "County": "Union",
            "State": "FL"
        },
        {
            "Code": "12127",
            "County": "Volusia",
            "State": "FL"
        },
        {
            "Code": "12129",
            "County": "Wakulla",
            "State": "FL"
        },
        {
            "Code": "12131",
            "County": "Walton",
            "State": "FL"
        },
        {
            "Code": "12133",
            "County": "Washington",
            "State": "FL"
        },
        {
            "Code": "13001",
            "County": "Appling",
            "State": "GA"
        },
        {
            "Code": "13003",
            "County": "Atkinson",
            "State": "GA"
        },
        {
            "Code": "13005",
            "County": "Bacon",
            "State": "GA"
        },
        {
            "Code": "13007",
            "County": "Baker",
            "State": "GA"
        },
        {
            "Code": "13009",
            "County": "Baldwin",
            "State": "GA"
        },
        {
            "Code": "13011",
            "County": "Banks",
            "State": "GA"
        },
        {
            "Code": "13013",
            "County": "Barrow",
            "State": "GA"
        },
        {
            "Code": "13015",
            "County": "Bartow",
            "State": "GA"
        },
        {
            "Code": "13017",
            "County": "Ben Hill",
            "State": "GA"
        },
        {
            "Code": "13019",
            "County": "Berrien",
            "State": "GA"
        },
        {
            "Code": "13021",
            "County": "Bibb",
            "State": "GA"
        },
        {
            "Code": "13023",
            "County": "Bleckley",
            "State": "GA"
        },
        {
            "Code": "13025",
            "County": "Brantley",
            "State": "GA"
        },
        {
            "Code": "13027",
            "County": "Brooks",
            "State": "GA"
        },
        {
            "Code": "13029",
            "County": "Bryan",
            "State": "GA"
        },
        {
            "Code": "13031",
            "County": "Bulloch",
            "State": "GA"
        },
        {
            "Code": "13033",
            "County": "Burke",
            "State": "GA"
        },
        {
            "Code": "13035",
            "County": "Butts",
            "State": "GA"
        },
        {
            "Code": "13037",
            "County": "Calhoun",
            "State": "GA"
        },
        {
            "Code": "13039",
            "County": "Camden",
            "State": "GA"
        },
        {
            "Code": "13043",
            "County": "Candler",
            "State": "GA"
        },
        {
            "Code": "13045",
            "County": "Carroll",
            "State": "GA"
        },
        {
            "Code": "13047",
            "County": "Catoosa",
            "State": "GA"
        },
        {
            "Code": "13049",
            "County": "Charlton",
            "State": "GA"
        },
        {
            "Code": "13051",
            "County": "Chatham",
            "State": "GA"
        },
        {
            "Code": "13053",
            "County": "Chattahoochee",
            "State": "GA"
        },
        {
            "Code": "13055",
            "County": "Chattooga",
            "State": "GA"
        },
        {
            "Code": "13057",
            "County": "Cherokee",
            "State": "GA"
        },
        {
            "Code": "13059",
            "County": "Clarke",
            "State": "GA"
        },
        {
            "Code": "13061",
            "County": "Clay",
            "State": "GA"
        },
        {
            "Code": "13063",
            "County": "Clayton",
            "State": "GA"
        },
        {
            "Code": "13065",
            "County": "Clinch",
            "State": "GA"
        },
        {
            "Code": "13067",
            "County": "Cobb",
            "State": "GA"
        },
        {
            "Code": "13069",
            "County": "Coffee",
            "State": "GA"
        },
        {
            "Code": "13071",
            "County": "Colquitt",
            "State": "GA"
        },
        {
            "Code": "13073",
            "County": "Columbia",
            "State": "GA"
        },
        {
            "Code": "13075",
            "County": "Cook",
            "State": "GA"
        },
        {
            "Code": "13077",
            "County": "Coweta",
            "State": "GA"
        },
        {
            "Code": "13079",
            "County": "Crawford",
            "State": "GA"
        },
        {
            "Code": "13081",
            "County": "Crisp",
            "State": "GA"
        },
        {
            "Code": "13083",
            "County": "Dade",
            "State": "GA"
        },
        {
            "Code": "13085",
            "County": "Dawson",
            "State": "GA"
        },
        {
            "Code": "13087",
            "County": "Decatur",
            "State": "GA"
        },
        {
            "Code": "13089",
            "County": "De Kalb",
            "State": "GA"
        },
        {
            "Code": "13091",
            "County": "Dodge",
            "State": "GA"
        },
        {
            "Code": "13093",
            "County": "Dooly",
            "State": "GA"
        },
        {
            "Code": "13095",
            "County": "Dougherty",
            "State": "GA"
        },
        {
            "Code": "13097",
            "County": "Douglas",
            "State": "GA"
        },
        {
            "Code": "13099",
            "County": "Early",
            "State": "GA"
        },
        {
            "Code": "13101",
            "County": "Echols",
            "State": "GA"
        },
        {
            "Code": "13103",
            "County": "Effingham",
            "State": "GA"
        },
        {
            "Code": "13105",
            "County": "Elbert",
            "State": "GA"
        },
        {
            "Code": "13107",
            "County": "Emanuel",
            "State": "GA"
        },
        {
            "Code": "13109",
            "County": "Evans",
            "State": "GA"
        },
        {
            "Code": "13111",
            "County": "Fannin",
            "State": "GA"
        },
        {
            "Code": "13113",
            "County": "Fayette",
            "State": "GA"
        },
        {
            "Code": "13115",
            "County": "Floyd",
            "State": "GA"
        },
        {
            "Code": "13117",
            "County": "Forsyth",
            "State": "GA"
        },
        {
            "Code": "13119",
            "County": "Franklin",
            "State": "GA"
        },
        {
            "Code": "13121",
            "County": "Fulton",
            "State": "GA"
        },
        {
            "Code": "13123",
            "County": "Gilmer",
            "State": "GA"
        },
        {
            "Code": "13125",
            "County": "Glascock",
            "State": "GA"
        },
        {
            "Code": "13127",
            "County": "Glynn",
            "State": "GA"
        },
        {
            "Code": "13129",
            "County": "Gordon",
            "State": "GA"
        },
        {
            "Code": "13131",
            "County": "Grady",
            "State": "GA"
        },
        {
            "Code": "13133",
            "County": "Greene",
            "State": "GA"
        },
        {
            "Code": "13135",
            "County": "Gwinnett",
            "State": "GA"
        },
        {
            "Code": "13137",
            "County": "Habersham",
            "State": "GA"
        },
        {
            "Code": "13139",
            "County": "Hall",
            "State": "GA"
        },
        {
            "Code": "13141",
            "County": "Hancock",
            "State": "GA"
        },
        {
            "Code": "13143",
            "County": "Haralson",
            "State": "GA"
        },
        {
            "Code": "13145",
            "County": "Harris",
            "State": "GA"
        },
        {
            "Code": "13147",
            "County": "Hart",
            "State": "GA"
        },
        {
            "Code": "13149",
            "County": "Heard",
            "State": "GA"
        },
        {
            "Code": "13151",
            "County": "Henry",
            "State": "GA"
        },
        {
            "Code": "13153",
            "County": "Houston",
            "State": "GA"
        },
        {
            "Code": "13155",
            "County": "Irwin",
            "State": "GA"
        },
        {
            "Code": "13157",
            "County": "Jackson",
            "State": "GA"
        },
        {
            "Code": "13159",
            "County": "Jasper",
            "State": "GA"
        },
        {
            "Code": "13161",
            "County": "Jeff Davis",
            "State": "GA"
        },
        {
            "Code": "13163",
            "County": "Jefferson",
            "State": "GA"
        },
        {
            "Code": "13165",
            "County": "Jenkins",
            "State": "GA"
        },
        {
            "Code": "13167",
            "County": "Johnson",
            "State": "GA"
        },
        {
            "Code": "13169",
            "County": "Jones",
            "State": "GA"
        },
        {
            "Code": "13171",
            "County": "Lamar",
            "State": "GA"
        },
        {
            "Code": "13173",
            "County": "Lanier",
            "State": "GA"
        },
        {
            "Code": "13175",
            "County": "Laurens",
            "State": "GA"
        },
        {
            "Code": "13177",
            "County": "Lee",
            "State": "GA"
        },
        {
            "Code": "13179",
            "County": "Liberty",
            "State": "GA"
        },
        {
            "Code": "13181",
            "County": "Lincoln",
            "State": "GA"
        },
        {
            "Code": "13183",
            "County": "Long",
            "State": "GA"
        },
        {
            "Code": "13185",
            "County": "Lowndes",
            "State": "GA"
        },
        {
            "Code": "13187",
            "County": "Lumpkin",
            "State": "GA"
        },
        {
            "Code": "13189",
            "County": "McDuffie",
            "State": "GA"
        },
        {
            "Code": "13191",
            "County": "McIntosh",
            "State": "GA"
        },
        {
            "Code": "13193",
            "County": "Macon",
            "State": "GA"
        },
        {
            "Code": "13195",
            "County": "Madison",
            "State": "GA"
        },
        {
            "Code": "13197",
            "County": "Marion",
            "State": "GA"
        },
        {
            "Code": "13199",
            "County": "Meriwether",
            "State": "GA"
        },
        {
            "Code": "13201",
            "County": "Miller",
            "State": "GA"
        },
        {
            "Code": "13205",
            "County": "Mitchell",
            "State": "GA"
        },
        {
            "Code": "13207",
            "County": "Monroe",
            "State": "GA"
        },
        {
            "Code": "13209",
            "County": "Montgomery",
            "State": "GA"
        },
        {
            "Code": "13211",
            "County": "Morgan",
            "State": "GA"
        },
        {
            "Code": "13213",
            "County": "Murray",
            "State": "GA"
        },
        {
            "Code": "13215",
            "County": "Muscogee",
            "State": "GA"
        },
        {
            "Code": "13217",
            "County": "Newton",
            "State": "GA"
        },
        {
            "Code": "13219",
            "County": "Oconee",
            "State": "GA"
        },
        {
            "Code": "13221",
            "County": "Oglethorpe",
            "State": "GA"
        },
        {
            "Code": "13223",
            "County": "Paulding",
            "State": "GA"
        },
        {
            "Code": "13225",
            "County": "Peach",
            "State": "GA"
        },
        {
            "Code": "13227",
            "County": "Pickens",
            "State": "GA"
        },
        {
            "Code": "13229",
            "County": "Pierce",
            "State": "GA"
        },
        {
            "Code": "13231",
            "County": "Pike",
            "State": "GA"
        },
        {
            "Code": "13233",
            "County": "Polk",
            "State": "GA"
        },
        {
            "Code": "13235",
            "County": "Pulaski",
            "State": "GA"
        },
        {
            "Code": "13237",
            "County": "Putnam",
            "State": "GA"
        },
        {
            "Code": "13239",
            "County": "Quitman",
            "State": "GA"
        },
        {
            "Code": "13241",
            "County": "Rabun",
            "State": "GA"
        },
        {
            "Code": "13243",
            "County": "Randolph",
            "State": "GA"
        },
        {
            "Code": "13245",
            "County": "Richmond",
            "State": "GA"
        },
        {
            "Code": "13247",
            "County": "Rockdale",
            "State": "GA"
        },
        {
            "Code": "13249",
            "County": "Schley",
            "State": "GA"
        },
        {
            "Code": "13251",
            "County": "Screven",
            "State": "GA"
        },
        {
            "Code": "13253",
            "County": "Seminole",
            "State": "GA"
        },
        {
            "Code": "13255",
            "County": "Spalding",
            "State": "GA"
        },
        {
            "Code": "13257",
            "County": "Stephens",
            "State": "GA"
        },
        {
            "Code": "13259",
            "County": "Stewart",
            "State": "GA"
        },
        {
            "Code": "13261",
            "County": "Sumter",
            "State": "GA"
        },
        {
            "Code": "13263",
            "County": "Talbot",
            "State": "GA"
        },
        {
            "Code": "13265",
            "County": "Taliaferro",
            "State": "GA"
        },
        {
            "Code": "13267",
            "County": "Tattnall",
            "State": "GA"
        },
        {
            "Code": "13269",
            "County": "Taylor",
            "State": "GA"
        },
        {
            "Code": "13271",
            "County": "Telfair",
            "State": "GA"
        },
        {
            "Code": "13273",
            "County": "Terrell",
            "State": "GA"
        },
        {
            "Code": "13275",
            "County": "Thomas",
            "State": "GA"
        },
        {
            "Code": "13277",
            "County": "Tift",
            "State": "GA"
        },
        {
            "Code": "13279",
            "County": "Toombs",
            "State": "GA"
        },
        {
            "Code": "13281",
            "County": "Towns",
            "State": "GA"
        },
        {
            "Code": "13283",
            "County": "Treutlen",
            "State": "GA"
        },
        {
            "Code": "13285",
            "County": "Troup",
            "State": "GA"
        },
        {
            "Code": "13287",
            "County": "Turner",
            "State": "GA"
        },
        {
            "Code": "13289",
            "County": "Twiggs",
            "State": "GA"
        },
        {
            "Code": "13291",
            "County": "Union",
            "State": "GA"
        },
        {
            "Code": "13293",
            "County": "Upson",
            "State": "GA"
        },
        {
            "Code": "13295",
            "County": "Walker",
            "State": "GA"
        },
        {
            "Code": "13297",
            "County": "Walton",
            "State": "GA"
        },
        {
            "Code": "13299",
            "County": "Ware",
            "State": "GA"
        },
        {
            "Code": "13301",
            "County": "Warren",
            "State": "GA"
        },
        {
            "Code": "13303",
            "County": "Washington",
            "State": "GA"
        },
        {
            "Code": "13305",
            "County": "Wayne",
            "State": "GA"
        },
        {
            "Code": "13307",
            "County": "Webster",
            "State": "GA"
        },
        {
            "Code": "13309",
            "County": "Wheeler",
            "State": "GA"
        },
        {
            "Code": "13311",
            "County": "White",
            "State": "GA"
        },
        {
            "Code": "13313",
            "County": "Whitfield",
            "State": "GA"
        },
        {
            "Code": "13315",
            "County": "Wilcox",
            "State": "GA"
        },
        {
            "Code": "13317",
            "County": "Wilkes",
            "State": "GA"
        },
        {
            "Code": "13319",
            "County": "Wilkinson",
            "State": "GA"
        },
        {
            "Code": "13321",
            "County": "Worth",
            "State": "GA"
        },
        {
            "Code": "15001",
            "County": "Hawaii",
            "State": "HI"
        },
        {
            "Code": "15003",
            "County": "Honolulu",
            "State": "HI"
        },
        {
            "Code": "15007",
            "County": "Kauai",
            "State": "HI"
        },
        {
            "Code": "15009",
            "County": "Maui",
            "State": "HI"
        },
        {
            "Code": "16001",
            "County": "Ada",
            "State": "ID"
        },
        {
            "Code": "16003",
            "County": "Adams",
            "State": "ID"
        },
        {
            "Code": "16005",
            "County": "Bannock",
            "State": "ID"
        },
        {
            "Code": "16007",
            "County": "Bear Lake",
            "State": "ID"
        },
        {
            "Code": "16009",
            "County": "Benewah",
            "State": "ID"
        },
        {
            "Code": "16011",
            "County": "Bingham",
            "State": "ID"
        },
        {
            "Code": "16013",
            "County": "Blaine",
            "State": "ID"
        },
        {
            "Code": "16015",
            "County": "Boise",
            "State": "ID"
        },
        {
            "Code": "16017",
            "County": "Bonner",
            "State": "ID"
        },
        {
            "Code": "16019",
            "County": "Bonneville",
            "State": "ID"
        },
        {
            "Code": "16021",
            "County": "Boundary",
            "State": "ID"
        },
        {
            "Code": "16023",
            "County": "Butte",
            "State": "ID"
        },
        {
            "Code": "16025",
            "County": "Camas",
            "State": "ID"
        },
        {
            "Code": "16027",
            "County": "Canyon",
            "State": "ID"
        },
        {
            "Code": "16029",
            "County": "Caribou",
            "State": "ID"
        },
        {
            "Code": "16031",
            "County": "Cassia",
            "State": "ID"
        },
        {
            "Code": "16033",
            "County": "Clark",
            "State": "ID"
        },
        {
            "Code": "16035",
            "County": "Clearwater",
            "State": "ID"
        },
        {
            "Code": "16037",
            "County": "Custer",
            "State": "ID"
        },
        {
            "Code": "16039",
            "County": "Elmore",
            "State": "ID"
        },
        {
            "Code": "16041",
            "County": "Franklin",
            "State": "ID"
        },
        {
            "Code": "16043",
            "County": "Fremont",
            "State": "ID"
        },
        {
            "Code": "16045",
            "County": "Gem",
            "State": "ID"
        },
        {
            "Code": "16047",
            "County": "Gooding",
            "State": "ID"
        },
        {
            "Code": "16049",
            "County": "Idaho",
            "State": "ID"
        },
        {
            "Code": "16051",
            "County": "Jefferson",
            "State": "ID"
        },
        {
            "Code": "16053",
            "County": "Jerome",
            "State": "ID"
        },
        {
            "Code": "16055",
            "County": "Kootenai",
            "State": "ID"
        },
        {
            "Code": "16057",
            "County": "Latah",
            "State": "ID"
        },
        {
            "Code": "16059",
            "County": "Lemhi",
            "State": "ID"
        },
        {
            "Code": "16061",
            "County": "Lewis",
            "State": "ID"
        },
        {
            "Code": "16063",
            "County": "Lincoln",
            "State": "ID"
        },
        {
            "Code": "16065",
            "County": "Madison",
            "State": "ID"
        },
        {
            "Code": "16067",
            "County": "Minidoka",
            "State": "ID"
        },
        {
            "Code": "16069",
            "County": "Nez Perce",
            "State": "ID"
        },
        {
            "Code": "16071",
            "County": "Oneida",
            "State": "ID"
        },
        {
            "Code": "16073",
            "County": "Owyhee",
            "State": "ID"
        },
        {
            "Code": "16075",
            "County": "Payette",
            "State": "ID"
        },
        {
            "Code": "16077",
            "County": "Power",
            "State": "ID"
        },
        {
            "Code": "16079",
            "County": "Shoshone",
            "State": "ID"
        },
        {
            "Code": "16081",
            "County": "Teton",
            "State": "ID"
        },
        {
            "Code": "16083",
            "County": "Twin Falls",
            "State": "ID"
        },
        {
            "Code": "16085",
            "County": "Valley",
            "State": "ID"
        },
        {
            "Code": "16087",
            "County": "Washington",
            "State": "ID"
        },
        {
            "Code": "17001",
            "County": "Adams",
            "State": "IL"
        },
        {
            "Code": "17003",
            "County": "Alexander",
            "State": "IL"
        },
        {
            "Code": "17005",
            "County": "Bond",
            "State": "IL"
        },
        {
            "Code": "17007",
            "County": "Boone",
            "State": "IL"
        },
        {
            "Code": "17009",
            "County": "Brown",
            "State": "IL"
        },
        {
            "Code": "17011",
            "County": "Bureau",
            "State": "IL"
        },
        {
            "Code": "17013",
            "County": "Calhoun",
            "State": "IL"
        },
        {
            "Code": "17015",
            "County": "Carroll",
            "State": "IL"
        },
        {
            "Code": "17017",
            "County": "Cass",
            "State": "IL"
        },
        {
            "Code": "17019",
            "County": "Champaign",
            "State": "IL"
        },
        {
            "Code": "17021",
            "County": "Christian",
            "State": "IL"
        },
        {
            "Code": "17023",
            "County": "Clark",
            "State": "IL"
        },
        {
            "Code": "17025",
            "County": "Clay",
            "State": "IL"
        },
        {
            "Code": "17027",
            "County": "Clinton",
            "State": "IL"
        },
        {
            "Code": "17029",
            "County": "Coles",
            "State": "IL"
        },
        {
            "Code": "17031",
            "County": "Cook",
            "State": "IL"
        },
        {
            "Code": "17033",
            "County": "Crawford",
            "State": "IL"
        },
        {
            "Code": "17035",
            "County": "Cumberland",
            "State": "IL"
        },
        {
            "Code": "17037",
            "County": "De Kalb",
            "State": "IL"
        },
        {
            "Code": "17039",
            "County": "De Witt",
            "State": "IL"
        },
        {
            "Code": "17041",
            "County": "Douglas",
            "State": "IL"
        },
        {
            "Code": "17043",
            "County": "Du Page",
            "State": "IL"
        },
        {
            "Code": "17045",
            "County": "Edgar",
            "State": "IL"
        },
        {
            "Code": "17047",
            "County": "Edwards",
            "State": "IL"
        },
        {
            "Code": "17049",
            "County": "Effingham",
            "State": "IL"
        },
        {
            "Code": "17051",
            "County": "Fayette",
            "State": "IL"
        },
        {
            "Code": "17053",
            "County": "Ford",
            "State": "IL"
        },
        {
            "Code": "17055",
            "County": "Franklin",
            "State": "IL"
        },
        {
            "Code": "17057",
            "County": "Fulton",
            "State": "IL"
        },
        {
            "Code": "17059",
            "County": "Gallatin",
            "State": "IL"
        },
        {
            "Code": "17061",
            "County": "Greene",
            "State": "IL"
        },
        {
            "Code": "17063",
            "County": "Grundy",
            "State": "IL"
        },
        {
            "Code": "17065",
            "County": "Hamilton",
            "State": "IL"
        },
        {
            "Code": "17067",
            "County": "Hancock",
            "State": "IL"
        },
        {
            "Code": "17069",
            "County": "Hardin",
            "State": "IL"
        },
        {
            "Code": "17071",
            "County": "Henderson",
            "State": "IL"
        },
        {
            "Code": "17073",
            "County": "Henry",
            "State": "IL"
        },
        {
            "Code": "17075",
            "County": "Iroquois",
            "State": "IL"
        },
        {
            "Code": "17077",
            "County": "Jackson",
            "State": "IL"
        },
        {
            "Code": "17079",
            "County": "Jasper",
            "State": "IL"
        },
        {
            "Code": "17081",
            "County": "Jefferson",
            "State": "IL"
        },
        {
            "Code": "17083",
            "County": "Jersey",
            "State": "IL"
        },
        {
            "Code": "17085",
            "County": "Jo Daviess",
            "State": "IL"
        },
        {
            "Code": "17087",
            "County": "Johnson",
            "State": "IL"
        },
        {
            "Code": "17089",
            "County": "Kane",
            "State": "IL"
        },
        {
            "Code": "17091",
            "County": "Kankakee",
            "State": "IL"
        },
        {
            "Code": "17093",
            "County": "Kendall",
            "State": "IL"
        },
        {
            "Code": "17095",
            "County": "Knox",
            "State": "IL"
        },
        {
            "Code": "17097",
            "County": "Lake",
            "State": "IL"
        },
        {
            "Code": "17099",
            "County": "La Salle",
            "State": "IL"
        },
        {
            "Code": "17101",
            "County": "Lawrence",
            "State": "IL"
        },
        {
            "Code": "17103",
            "County": "Lee",
            "State": "IL"
        },
        {
            "Code": "17105",
            "County": "Livingston",
            "State": "IL"
        },
        {
            "Code": "17107",
            "County": "Logan",
            "State": "IL"
        },
        {
            "Code": "17109",
            "County": "McDonough",
            "State": "IL"
        },
        {
            "Code": "17111",
            "County": "McHenry",
            "State": "IL"
        },
        {
            "Code": "17113",
            "County": "McLean",
            "State": "IL"
        },
        {
            "Code": "17115",
            "County": "Macon",
            "State": "IL"
        },
        {
            "Code": "17117",
            "County": "Macoupin",
            "State": "IL"
        },
        {
            "Code": "17119",
            "County": "Madison",
            "State": "IL"
        },
        {
            "Code": "17121",
            "County": "Marion",
            "State": "IL"
        },
        {
            "Code": "17123",
            "County": "Marshall",
            "State": "IL"
        },
        {
            "Code": "17125",
            "County": "Mason",
            "State": "IL"
        },
        {
            "Code": "17127",
            "County": "Massac",
            "State": "IL"
        },
        {
            "Code": "17129",
            "County": "Menard",
            "State": "IL"
        },
        {
            "Code": "17131",
            "County": "Mercer",
            "State": "IL"
        },
        {
            "Code": "17133",
            "County": "Monroe",
            "State": "IL"
        },
        {
            "Code": "17135",
            "County": "Montgomery",
            "State": "IL"
        },
        {
            "Code": "17137",
            "County": "Morgan",
            "State": "IL"
        },
        {
            "Code": "17139",
            "County": "Moultrie",
            "State": "IL"
        },
        {
            "Code": "17141",
            "County": "Ogle",
            "State": "IL"
        },
        {
            "Code": "17143",
            "County": "Peoria",
            "State": "IL"
        },
        {
            "Code": "17145",
            "County": "Perry",
            "State": "IL"
        },
        {
            "Code": "17147",
            "County": "Piatt",
            "State": "IL"
        },
        {
            "Code": "17149",
            "County": "Pike",
            "State": "IL"
        },
        {
            "Code": "17151",
            "County": "Pope",
            "State": "IL"
        },
        {
            "Code": "17153",
            "County": "Pulaski",
            "State": "IL"
        },
        {
            "Code": "17155",
            "County": "Putnam",
            "State": "IL"
        },
        {
            "Code": "17157",
            "County": "Randolph",
            "State": "IL"
        },
        {
            "Code": "17159",
            "County": "Richland",
            "State": "IL"
        },
        {
            "Code": "17161",
            "County": "Rock Island",
            "State": "IL"
        },
        {
            "Code": "17163",
            "County": "St Clair",
            "State": "IL"
        },
        {
            "Code": "17165",
            "County": "Saline",
            "State": "IL"
        },
        {
            "Code": "17167",
            "County": "Sangamon",
            "State": "IL"
        },
        {
            "Code": "17169",
            "County": "Schuyler",
            "State": "IL"
        },
        {
            "Code": "17171",
            "County": "Scott",
            "State": "IL"
        },
        {
            "Code": "17173",
            "County": "Shelby",
            "State": "IL"
        },
        {
            "Code": "17175",
            "County": "Stark",
            "State": "IL"
        },
        {
            "Code": "17177",
            "County": "Stephenson",
            "State": "IL"
        },
        {
            "Code": "17179",
            "County": "Tazewell",
            "State": "IL"
        },
        {
            "Code": "17181",
            "County": "Union",
            "State": "IL"
        },
        {
            "Code": "17183",
            "County": "Vermilion",
            "State": "IL"
        },
        {
            "Code": "17185",
            "County": "Wabash",
            "State": "IL"
        },
        {
            "Code": "17187",
            "County": "Warren",
            "State": "IL"
        },
        {
            "Code": "17189",
            "County": "Washington",
            "State": "IL"
        },
        {
            "Code": "17191",
            "County": "Wayne",
            "State": "IL"
        },
        {
            "Code": "17193",
            "County": "White",
            "State": "IL"
        },
        {
            "Code": "17195",
            "County": "Whiteside",
            "State": "IL"
        },
        {
            "Code": "17197",
            "County": "Will",
            "State": "IL"
        },
        {
            "Code": "17199",
            "County": "Williamson",
            "State": "IL"
        },
        {
            "Code": "17201",
            "County": "Winnebago",
            "State": "IL"
        },
        {
            "Code": "17203",
            "County": "Woodford",
            "State": "IL"
        },
        {
            "Code": "18001",
            "County": "Adams",
            "State": "IN"
        },
        {
            "Code": "18003",
            "County": "Allen",
            "State": "IN"
        },
        {
            "Code": "18005",
            "County": "Bartholomew",
            "State": "IN"
        },
        {
            "Code": "18007",
            "County": "Benton",
            "State": "IN"
        },
        {
            "Code": "18009",
            "County": "Blackford",
            "State": "IN"
        },
        {
            "Code": "18011",
            "County": "Boone",
            "State": "IN"
        },
        {
            "Code": "18013",
            "County": "Brown",
            "State": "IN"
        },
        {
            "Code": "18015",
            "County": "Carroll",
            "State": "IN"
        },
        {
            "Code": "18017",
            "County": "Cass",
            "State": "IN"
        },
        {
            "Code": "18019",
            "County": "Clark",
            "State": "IN"
        },
        {
            "Code": "18021",
            "County": "Clay",
            "State": "IN"
        },
        {
            "Code": "18023",
            "County": "Clinton",
            "State": "IN"
        },
        {
            "Code": "18025",
            "County": "Crawford",
            "State": "IN"
        },
        {
            "Code": "18027",
            "County": "Daviess",
            "State": "IN"
        },
        {
            "Code": "18029",
            "County": "Dearborn",
            "State": "IN"
        },
        {
            "Code": "18031",
            "County": "Decatur",
            "State": "IN"
        },
        {
            "Code": "18033",
            "County": "De Kalb",
            "State": "IN"
        },
        {
            "Code": "18035",
            "County": "Delaware",
            "State": "IN"
        },
        {
            "Code": "18037",
            "County": "Dubois",
            "State": "IN"
        },
        {
            "Code": "18039",
            "County": "Elkhart",
            "State": "IN"
        },
        {
            "Code": "18041",
            "County": "Fayette",
            "State": "IN"
        },
        {
            "Code": "18043",
            "County": "Floyd",
            "State": "IN"
        },
        {
            "Code": "18045",
            "County": "Fountain",
            "State": "IN"
        },
        {
            "Code": "18047",
            "County": "Franklin",
            "State": "IN"
        },
        {
            "Code": "18049",
            "County": "Fulton",
            "State": "IN"
        },
        {
            "Code": "18051",
            "County": "Gibson",
            "State": "IN"
        },
        {
            "Code": "18053",
            "County": "Grant",
            "State": "IN"
        },
        {
            "Code": "18055",
            "County": "Greene",
            "State": "IN"
        },
        {
            "Code": "18057",
            "County": "Hamilton",
            "State": "IN"
        },
        {
            "Code": "18059",
            "County": "Hancock",
            "State": "IN"
        },
        {
            "Code": "18061",
            "County": "Harrison",
            "State": "IN"
        },
        {
            "Code": "18063",
            "County": "Hendricks",
            "State": "IN"
        },
        {
            "Code": "18065",
            "County": "Henry",
            "State": "IN"
        },
        {
            "Code": "18067",
            "County": "Howard",
            "State": "IN"
        },
        {
            "Code": "18069",
            "County": "Huntington",
            "State": "IN"
        },
        {
            "Code": "18071",
            "County": "Jackson",
            "State": "IN"
        },
        {
            "Code": "18073",
            "County": "Jasper",
            "State": "IN"
        },
        {
            "Code": "18075",
            "County": "Jay",
            "State": "IN"
        },
        {
            "Code": "18077",
            "County": "Jefferson",
            "State": "IN"
        },
        {
            "Code": "18079",
            "County": "Jennings",
            "State": "IN"
        },
        {
            "Code": "18081",
            "County": "Johnson",
            "State": "IN"
        },
        {
            "Code": "18083",
            "County": "Knox",
            "State": "IN"
        },
        {
            "Code": "18085",
            "County": "Kosciusko",
            "State": "IN"
        },
        {
            "Code": "18087",
            "County": "La Grange",
            "State": "IN"
        },
        {
            "Code": "18089",
            "County": "Lake",
            "State": "IN"
        },
        {
            "Code": "18091",
            "County": "La Porte",
            "State": "IN"
        },
        {
            "Code": "18093",
            "County": "Lawrence",
            "State": "IN"
        },
        {
            "Code": "18095",
            "County": "Madison",
            "State": "IN"
        },
        {
            "Code": "18097",
            "County": "Marion",
            "State": "IN"
        },
        {
            "Code": "18099",
            "County": "Marshall",
            "State": "IN"
        },
        {
            "Code": "18101",
            "County": "Martin",
            "State": "IN"
        },
        {
            "Code": "18103",
            "County": "Miami",
            "State": "IN"
        },
        {
            "Code": "18105",
            "County": "Monroe",
            "State": "IN"
        },
        {
            "Code": "18107",
            "County": "Montgomery",
            "State": "IN"
        },
        {
            "Code": "18109",
            "County": "Morgan",
            "State": "IN"
        },
        {
            "Code": "18111",
            "County": "Newton",
            "State": "IN"
        },
        {
            "Code": "18113",
            "County": "Noble",
            "State": "IN"
        },
        {
            "Code": "18115",
            "County": "Ohio",
            "State": "IN"
        },
        {
            "Code": "18117",
            "County": "Orange",
            "State": "IN"
        },
        {
            "Code": "18119",
            "County": "Owen",
            "State": "IN"
        },
        {
            "Code": "18121",
            "County": "Parke",
            "State": "IN"
        },
        {
            "Code": "18123",
            "County": "Perry",
            "State": "IN"
        },
        {
            "Code": "18125",
            "County": "Pike",
            "State": "IN"
        },
        {
            "Code": "18127",
            "County": "Porter",
            "State": "IN"
        },
        {
            "Code": "18129",
            "County": "Posey",
            "State": "IN"
        },
        {
            "Code": "18131",
            "County": "Pulaski",
            "State": "IN"
        },
        {
            "Code": "18133",
            "County": "Putnam",
            "State": "IN"
        },
        {
            "Code": "18135",
            "County": "Randolph",
            "State": "IN"
        },
        {
            "Code": "18137",
            "County": "Ripley",
            "State": "IN"
        },
        {
            "Code": "18139",
            "County": "Rush",
            "State": "IN"
        },
        {
            "Code": "18141",
            "County": "St Joseph",
            "State": "IN"
        },
        {
            "Code": "18143",
            "County": "Scott",
            "State": "IN"
        },
        {
            "Code": "18145",
            "County": "Shelby",
            "State": "IN"
        },
        {
            "Code": "18147",
            "County": "Spencer",
            "State": "IN"
        },
        {
            "Code": "18149",
            "County": "Starke",
            "State": "IN"
        },
        {
            "Code": "18151",
            "County": "Steuben",
            "State": "IN"
        },
        {
            "Code": "18153",
            "County": "Sullivan",
            "State": "IN"
        },
        {
            "Code": "18155",
            "County": "Switzerland",
            "State": "IN"
        },
        {
            "Code": "18157",
            "County": "Tippecanoe",
            "State": "IN"
        },
        {
            "Code": "18159",
            "County": "Tipton",
            "State": "IN"
        },
        {
            "Code": "18161",
            "County": "Union",
            "State": "IN"
        },
        {
            "Code": "18163",
            "County": "Vanderburgh",
            "State": "IN"
        },
        {
            "Code": "18165",
            "County": "Vermillion",
            "State": "IN"
        },
        {
            "Code": "18167",
            "County": "Vigo",
            "State": "IN"
        },
        {
            "Code": "18169",
            "County": "Wabash",
            "State": "IN"
        },
        {
            "Code": "18171",
            "County": "Warren",
            "State": "IN"
        },
        {
            "Code": "18173",
            "County": "Warrick",
            "State": "IN"
        },
        {
            "Code": "18175",
            "County": "Washington",
            "State": "IN"
        },
        {
            "Code": "18177",
            "County": "Wayne",
            "State": "IN"
        },
        {
            "Code": "18179",
            "County": "Wells",
            "State": "IN"
        },
        {
            "Code": "18181",
            "County": "White",
            "State": "IN"
        },
        {
            "Code": "18183",
            "County": "Whitley",
            "State": "IN"
        },
        {
            "Code": "19001",
            "County": "Adair",
            "State": "IA"
        },
        {
            "Code": "19003",
            "County": "Adams",
            "State": "IA"
        },
        {
            "Code": "19005",
            "County": "Allamakee",
            "State": "IA"
        },
        {
            "Code": "19007",
            "County": "Appanoose",
            "State": "IA"
        },
        {
            "Code": "19009",
            "County": "Audubon",
            "State": "IA"
        },
        {
            "Code": "19011",
            "County": "Benton",
            "State": "IA"
        },
        {
            "Code": "19013",
            "County": "Black Hawk",
            "State": "IA"
        },
        {
            "Code": "19015",
            "County": "Boone",
            "State": "IA"
        },
        {
            "Code": "19017",
            "County": "Bremer",
            "State": "IA"
        },
        {
            "Code": "19019",
            "County": "Buchanan",
            "State": "IA"
        },
        {
            "Code": "19021",
            "County": "Buena Vista",
            "State": "IA"
        },
        {
            "Code": "19023",
            "County": "Butler",
            "State": "IA"
        },
        {
            "Code": "19025",
            "County": "Calhoun",
            "State": "IA"
        },
        {
            "Code": "19027",
            "County": "Carroll",
            "State": "IA"
        },
        {
            "Code": "19029",
            "County": "Cass",
            "State": "IA"
        },
        {
            "Code": "19031",
            "County": "Cedar",
            "State": "IA"
        },
        {
            "Code": "19033",
            "County": "Cerro Gordo",
            "State": "IA"
        },
        {
            "Code": "19035",
            "County": "Cherokee",
            "State": "IA"
        },
        {
            "Code": "19037",
            "County": "Chickasaw",
            "State": "IA"
        },
        {
            "Code": "19039",
            "County": "Clarke",
            "State": "IA"
        },
        {
            "Code": "19041",
            "County": "Clay",
            "State": "IA"
        },
        {
            "Code": "19043",
            "County": "Clayton",
            "State": "IA"
        },
        {
            "Code": "19045",
            "County": "Clinton",
            "State": "IA"
        },
        {
            "Code": "19047",
            "County": "Crawford",
            "State": "IA"
        },
        {
            "Code": "19049",
            "County": "Dallas",
            "State": "IA"
        },
        {
            "Code": "19051",
            "County": "Davis",
            "State": "IA"
        },
        {
            "Code": "19053",
            "County": "Decatur",
            "State": "IA"
        },
        {
            "Code": "19055",
            "County": "Delaware",
            "State": "IA"
        },
        {
            "Code": "19057",
            "County": "Des Moines",
            "State": "IA"
        },
        {
            "Code": "19059",
            "County": "Dickinson",
            "State": "IA"
        },
        {
            "Code": "19061",
            "County": "Dubuque",
            "State": "IA"
        },
        {
            "Code": "19063",
            "County": "Emmet",
            "State": "IA"
        },
        {
            "Code": "19065",
            "County": "Fayette",
            "State": "IA"
        },
        {
            "Code": "19067",
            "County": "Floyd",
            "State": "IA"
        },
        {
            "Code": "19069",
            "County": "Franklin",
            "State": "IA"
        },
        {
            "Code": "19071",
            "County": "Fremont",
            "State": "IA"
        },
        {
            "Code": "19073",
            "County": "Greene",
            "State": "IA"
        },
        {
            "Code": "19075",
            "County": "Grundy",
            "State": "IA"
        },
        {
            "Code": "19077",
            "County": "Guthrie",
            "State": "IA"
        },
        {
            "Code": "19079",
            "County": "Hamilton",
            "State": "IA"
        },
        {
            "Code": "19081",
            "County": "Hancock",
            "State": "IA"
        },
        {
            "Code": "19083",
            "County": "Hardin",
            "State": "IA"
        },
        {
            "Code": "19085",
            "County": "Harrison",
            "State": "IA"
        },
        {
            "Code": "19087",
            "County": "Henry",
            "State": "IA"
        },
        {
            "Code": "19089",
            "County": "Howard",
            "State": "IA"
        },
        {
            "Code": "19091",
            "County": "Humboldt",
            "State": "IA"
        },
        {
            "Code": "19093",
            "County": "Ida",
            "State": "IA"
        },
        {
            "Code": "19095",
            "County": "Iowa",
            "State": "IA"
        },
        {
            "Code": "19097",
            "County": "Jackson",
            "State": "IA"
        },
        {
            "Code": "19099",
            "County": "Jasper",
            "State": "IA"
        },
        {
            "Code": "19101",
            "County": "Jefferson",
            "State": "IA"
        },
        {
            "Code": "19103",
            "County": "Johnson",
            "State": "IA"
        },
        {
            "Code": "19105",
            "County": "Jones",
            "State": "IA"
        },
        {
            "Code": "19107",
            "County": "Keokuk",
            "State": "IA"
        },
        {
            "Code": "19109",
            "County": "Kossuth",
            "State": "IA"
        },
        {
            "Code": "19111",
            "County": "Lee",
            "State": "IA"
        },
        {
            "Code": "19113",
            "County": "Linn",
            "State": "IA"
        },
        {
            "Code": "19115",
            "County": "Louisa",
            "State": "IA"
        },
        {
            "Code": "19117",
            "County": "Lucas",
            "State": "IA"
        },
        {
            "Code": "19119",
            "County": "Lyon",
            "State": "IA"
        },
        {
            "Code": "19121",
            "County": "Madison",
            "State": "IA"
        },
        {
            "Code": "19123",
            "County": "Mahaska",
            "State": "IA"
        },
        {
            "Code": "19125",
            "County": "Marion",
            "State": "IA"
        },
        {
            "Code": "19127",
            "County": "Marshall",
            "State": "IA"
        },
        {
            "Code": "19129",
            "County": "Mills",
            "State": "IA"
        },
        {
            "Code": "19131",
            "County": "Mitchell",
            "State": "IA"
        },
        {
            "Code": "19133",
            "County": "Monona",
            "State": "IA"
        },
        {
            "Code": "19135",
            "County": "Monroe",
            "State": "IA"
        },
        {
            "Code": "19137",
            "County": "Montgomery",
            "State": "IA"
        },
        {
            "Code": "19139",
            "County": "Muscatine",
            "State": "IA"
        },
        {
            "Code": "19141",
            "County": "O Brien",
            "State": "IA"
        },
        {
            "Code": "19143",
            "County": "Osceola",
            "State": "IA"
        },
        {
            "Code": "19145",
            "County": "Page",
            "State": "IA"
        },
        {
            "Code": "19147",
            "County": "Palo Alto",
            "State": "IA"
        },
        {
            "Code": "19149",
            "County": "Plymouth",
            "State": "IA"
        },
        {
            "Code": "19151",
            "County": "Pocahontas",
            "State": "IA"
        },
        {
            "Code": "19153",
            "County": "Polk",
            "State": "IA"
        },
        {
            "Code": "19155",
            "County": "Pottawattamie",
            "State": "IA"
        },
        {
            "Code": "19157",
            "County": "Poweshiek",
            "State": "IA"
        },
        {
            "Code": "19159",
            "County": "Ringgold",
            "State": "IA"
        },
        {
            "Code": "19161",
            "County": "Sac",
            "State": "IA"
        },
        {
            "Code": "19163",
            "County": "Scott",
            "State": "IA"
        },
        {
            "Code": "19165",
            "County": "Shelby",
            "State": "IA"
        },
        {
            "Code": "19167",
            "County": "Sioux",
            "State": "IA"
        },
        {
            "Code": "19169",
            "County": "Story",
            "State": "IA"
        },
        {
            "Code": "19171",
            "County": "Tama",
            "State": "IA"
        },
        {
            "Code": "19173",
            "County": "Taylor",
            "State": "IA"
        },
        {
            "Code": "19175",
            "County": "Union",
            "State": "IA"
        },
        {
            "Code": "19177",
            "County": "Van Buren",
            "State": "IA"
        },
        {
            "Code": "19179",
            "County": "Wapello",
            "State": "IA"
        },
        {
            "Code": "19181",
            "County": "Warren",
            "State": "IA"
        },
        {
            "Code": "19183",
            "County": "Washington",
            "State": "IA"
        },
        {
            "Code": "19185",
            "County": "Wayne",
            "State": "IA"
        },
        {
            "Code": "19187",
            "County": "Webster",
            "State": "IA"
        },
        {
            "Code": "19189",
            "County": "Winnebago",
            "State": "IA"
        },
        {
            "Code": "19191",
            "County": "Winneshiek",
            "State": "IA"
        },
        {
            "Code": "19193",
            "County": "Woodbury",
            "State": "IA"
        },
        {
            "Code": "19195",
            "County": "Worth",
            "State": "IA"
        },
        {
            "Code": "19197",
            "County": "Wright",
            "State": "IA"
        },
        {
            "Code": "20001",
            "County": "Allen",
            "State": "KS"
        },
        {
            "Code": "20003",
            "County": "Anderson",
            "State": "KS"
        },
        {
            "Code": "20005",
            "County": "Atchison",
            "State": "KS"
        },
        {
            "Code": "20007",
            "County": "Barber",
            "State": "KS"
        },
        {
            "Code": "20009",
            "County": "Barton",
            "State": "KS"
        },
        {
            "Code": "20011",
            "County": "Bourbon",
            "State": "KS"
        },
        {
            "Code": "20013",
            "County": "Brown",
            "State": "KS"
        },
        {
            "Code": "20015",
            "County": "Butler",
            "State": "KS"
        },
        {
            "Code": "20017",
            "County": "Chase",
            "State": "KS"
        },
        {
            "Code": "20019",
            "County": "Chautauqua",
            "State": "KS"
        },
        {
            "Code": "20021",
            "County": "Cherokee",
            "State": "KS"
        },
        {
            "Code": "20023",
            "County": "Cheyenne",
            "State": "KS"
        },
        {
            "Code": "20025",
            "County": "Clark",
            "State": "KS"
        },
        {
            "Code": "20027",
            "County": "Clay",
            "State": "KS"
        },
        {
            "Code": "20029",
            "County": "Cloud",
            "State": "KS"
        },
        {
            "Code": "20031",
            "County": "Coffey",
            "State": "KS"
        },
        {
            "Code": "20033",
            "County": "Comanche",
            "State": "KS"
        },
        {
            "Code": "20035",
            "County": "Cowley",
            "State": "KS"
        },
        {
            "Code": "20037",
            "County": "Crawford",
            "State": "KS"
        },
        {
            "Code": "20039",
            "County": "Decatur",
            "State": "KS"
        },
        {
            "Code": "20041",
            "County": "Dickinson",
            "State": "KS"
        },
        {
            "Code": "20043",
            "County": "Doniphan",
            "State": "KS"
        },
        {
            "Code": "20045",
            "County": "Douglas",
            "State": "KS"
        },
        {
            "Code": "20047",
            "County": "Edwards",
            "State": "KS"
        },
        {
            "Code": "20049",
            "County": "Elk",
            "State": "KS"
        },
        {
            "Code": "20051",
            "County": "Ellis",
            "State": "KS"
        },
        {
            "Code": "20053",
            "County": "Ellsworth",
            "State": "KS"
        },
        {
            "Code": "20055",
            "County": "Finney",
            "State": "KS"
        },
        {
            "Code": "20057",
            "County": "Ford",
            "State": "KS"
        },
        {
            "Code": "20059",
            "County": "Franklin",
            "State": "KS"
        },
        {
            "Code": "20061",
            "County": "Geary",
            "State": "KS"
        },
        {
            "Code": "20063",
            "County": "Gove",
            "State": "KS"
        },
        {
            "Code": "20065",
            "County": "Graham",
            "State": "KS"
        },
        {
            "Code": "20067",
            "County": "Grant",
            "State": "KS"
        },
        {
            "Code": "20069",
            "County": "Gray",
            "State": "KS"
        },
        {
            "Code": "20071",
            "County": "Greeley",
            "State": "KS"
        },
        {
            "Code": "20073",
            "County": "Greenwood",
            "State": "KS"
        },
        {
            "Code": "20075",
            "County": "Hamilton",
            "State": "KS"
        },
        {
            "Code": "20077",
            "County": "Harper",
            "State": "KS"
        },
        {
            "Code": "20079",
            "County": "Harvey",
            "State": "KS"
        },
        {
            "Code": "20081",
            "County": "Haskell",
            "State": "KS"
        },
        {
            "Code": "20083",
            "County": "Hodgeman",
            "State": "KS"
        },
        {
            "Code": "20085",
            "County": "Jackson",
            "State": "KS"
        },
        {
            "Code": "20087",
            "County": "Jefferson",
            "State": "KS"
        },
        {
            "Code": "20089",
            "County": "Jewell",
            "State": "KS"
        },
        {
            "Code": "20091",
            "County": "Johnson",
            "State": "KS"
        },
        {
            "Code": "20093",
            "County": "Kearny",
            "State": "KS"
        },
        {
            "Code": "20095",
            "County": "Kingman",
            "State": "KS"
        },
        {
            "Code": "20097",
            "County": "Kiowa",
            "State": "KS"
        },
        {
            "Code": "20099",
            "County": "Labette",
            "State": "KS"
        },
        {
            "Code": "20101",
            "County": "Lane",
            "State": "KS"
        },
        {
            "Code": "20103",
            "County": "Leavenworth",
            "State": "KS"
        },
        {
            "Code": "20105",
            "County": "Lincoln",
            "State": "KS"
        },
        {
            "Code": "20107",
            "County": "Linn",
            "State": "KS"
        },
        {
            "Code": "20109",
            "County": "Logan",
            "State": "KS"
        },
        {
            "Code": "20111",
            "County": "Lyon",
            "State": "KS"
        },
        {
            "Code": "20113",
            "County": "McPherson",
            "State": "KS"
        },
        {
            "Code": "20115",
            "County": "Marion",
            "State": "KS"
        },
        {
            "Code": "20117",
            "County": "Marshall",
            "State": "KS"
        },
        {
            "Code": "20119",
            "County": "Meade",
            "State": "KS"
        },
        {
            "Code": "20121",
            "County": "Miami",
            "State": "KS"
        },
        {
            "Code": "20123",
            "County": "Mitchell",
            "State": "KS"
        },
        {
            "Code": "20125",
            "County": "Montgomery",
            "State": "KS"
        },
        {
            "Code": "20127",
            "County": "Morris",
            "State": "KS"
        },
        {
            "Code": "20129",
            "County": "Morton",
            "State": "KS"
        },
        {
            "Code": "20131",
            "County": "Nemaha",
            "State": "KS"
        },
        {
            "Code": "20133",
            "County": "Neosho",
            "State": "KS"
        },
        {
            "Code": "20135",
            "County": "Ness",
            "State": "KS"
        },
        {
            "Code": "20137",
            "County": "Norton",
            "State": "KS"
        },
        {
            "Code": "20139",
            "County": "Osage",
            "State": "KS"
        },
        {
            "Code": "20141",
            "County": "Osborne",
            "State": "KS"
        },
        {
            "Code": "20143",
            "County": "Ottawa",
            "State": "KS"
        },
        {
            "Code": "20145",
            "County": "Pawnee",
            "State": "KS"
        },
        {
            "Code": "20147",
            "County": "Phillips",
            "State": "KS"
        },
        {
            "Code": "20149",
            "County": "Pottawatomie",
            "State": "KS"
        },
        {
            "Code": "20151",
            "County": "Pratt",
            "State": "KS"
        },
        {
            "Code": "20153",
            "County": "Rawlins",
            "State": "KS"
        },
        {
            "Code": "20155",
            "County": "Reno",
            "State": "KS"
        },
        {
            "Code": "20157",
            "County": "Republic",
            "State": "KS"
        },
        {
            "Code": "20159",
            "County": "Rice",
            "State": "KS"
        },
        {
            "Code": "20161",
            "County": "Riley",
            "State": "KS"
        },
        {
            "Code": "20163",
            "County": "Rooks",
            "State": "KS"
        },
        {
            "Code": "20165",
            "County": "Rush",
            "State": "KS"
        },
        {
            "Code": "20167",
            "County": "Russell",
            "State": "KS"
        },
        {
            "Code": "20169",
            "County": "Saline",
            "State": "KS"
        },
        {
            "Code": "20171",
            "County": "Scott",
            "State": "KS"
        },
        {
            "Code": "20173",
            "County": "Sedgwick",
            "State": "KS"
        },
        {
            "Code": "20175",
            "County": "Seward",
            "State": "KS"
        },
        {
            "Code": "20177",
            "County": "Shawnee",
            "State": "KS"
        },
        {
            "Code": "20179",
            "County": "Sheridan",
            "State": "KS"
        },
        {
            "Code": "20181",
            "County": "Sherman",
            "State": "KS"
        },
        {
            "Code": "20183",
            "County": "Smith",
            "State": "KS"
        },
        {
            "Code": "20185",
            "County": "Stafford",
            "State": "KS"
        },
        {
            "Code": "20187",
            "County": "Stanton",
            "State": "KS"
        },
        {
            "Code": "20189",
            "County": "Stevens",
            "State": "KS"
        },
        {
            "Code": "20191",
            "County": "Sumner",
            "State": "KS"
        },
        {
            "Code": "20193",
            "County": "Thomas",
            "State": "KS"
        },
        {
            "Code": "20195",
            "County": "Trego",
            "State": "KS"
        },
        {
            "Code": "20197",
            "County": "Wabaunsee",
            "State": "KS"
        },
        {
            "Code": "20199",
            "County": "Wallace",
            "State": "KS"
        },
        {
            "Code": "20201",
            "County": "Washington",
            "State": "KS"
        },
        {
            "Code": "20203",
            "County": "Wichita",
            "State": "KS"
        },
        {
            "Code": "20205",
            "County": "Wilson",
            "State": "KS"
        },
        {
            "Code": "20207",
            "County": "Woodson",
            "State": "KS"
        },
        {
            "Code": "20209",
            "County": "Wyandotte",
            "State": "KS"
        },
        {
            "Code": "21001",
            "County": "Adair",
            "State": "KY"
        },
        {
            "Code": "21003",
            "County": "Allen",
            "State": "KY"
        },
        {
            "Code": "21005",
            "County": "Anderson",
            "State": "KY"
        },
        {
            "Code": "21007",
            "County": "Ballard",
            "State": "KY"
        },
        {
            "Code": "21009",
            "County": "Barren",
            "State": "KY"
        },
        {
            "Code": "21011",
            "County": "Bath",
            "State": "KY"
        },
        {
            "Code": "21013",
            "County": "Bell",
            "State": "KY"
        },
        {
            "Code": "21015",
            "County": "Boone",
            "State": "KY"
        },
        {
            "Code": "21017",
            "County": "Bourbon",
            "State": "KY"
        },
        {
            "Code": "21019",
            "County": "Boyd",
            "State": "KY"
        },
        {
            "Code": "21021",
            "County": "Boyle",
            "State": "KY"
        },
        {
            "Code": "21023",
            "County": "Bracken",
            "State": "KY"
        },
        {
            "Code": "21025",
            "County": "Breathitt",
            "State": "KY"
        },
        {
            "Code": "21027",
            "County": "Breckinridge",
            "State": "KY"
        },
        {
            "Code": "21029",
            "County": "Bullitt",
            "State": "KY"
        },
        {
            "Code": "21031",
            "County": "Butler",
            "State": "KY"
        },
        {
            "Code": "21033",
            "County": "Caldwell",
            "State": "KY"
        },
        {
            "Code": "21035",
            "County": "Calloway",
            "State": "KY"
        },
        {
            "Code": "21037",
            "County": "Campbell",
            "State": "KY"
        },
        {
            "Code": "21039",
            "County": "Carlisle",
            "State": "KY"
        },
        {
            "Code": "21041",
            "County": "Carroll",
            "State": "KY"
        },
        {
            "Code": "21043",
            "County": "Carter",
            "State": "KY"
        },
        {
            "Code": "21045",
            "County": "Casey",
            "State": "KY"
        },
        {
            "Code": "21047",
            "County": "Christian",
            "State": "KY"
        },
        {
            "Code": "21049",
            "County": "Clark",
            "State": "KY"
        },
        {
            "Code": "21051",
            "County": "Clay",
            "State": "KY"
        },
        {
            "Code": "21053",
            "County": "Clinton",
            "State": "KY"
        },
        {
            "Code": "21055",
            "County": "Crittenden",
            "State": "KY"
        },
        {
            "Code": "21057",
            "County": "Cumberland",
            "State": "KY"
        },
        {
            "Code": "21059",
            "County": "Daviess",
            "State": "KY"
        },
        {
            "Code": "21061",
            "County": "Edmonson",
            "State": "KY"
        },
        {
            "Code": "21063",
            "County": "Elliott",
            "State": "KY"
        },
        {
            "Code": "21065",
            "County": "Estill",
            "State": "KY"
        },
        {
            "Code": "21067",
            "County": "Fayette",
            "State": "KY"
        },
        {
            "Code": "21069",
            "County": "Fleming",
            "State": "KY"
        },
        {
            "Code": "21071",
            "County": "Floyd",
            "State": "KY"
        },
        {
            "Code": "21073",
            "County": "Franklin",
            "State": "KY"
        },
        {
            "Code": "21075",
            "County": "Fulton",
            "State": "KY"
        },
        {
            "Code": "21077",
            "County": "Gallatin",
            "State": "KY"
        },
        {
            "Code": "21079",
            "County": "Garrard",
            "State": "KY"
        },
        {
            "Code": "21081",
            "County": "Grant",
            "State": "KY"
        },
        {
            "Code": "21083",
            "County": "Graves",
            "State": "KY"
        },
        {
            "Code": "21085",
            "County": "Grayson",
            "State": "KY"
        },
        {
            "Code": "21087",
            "County": "Green",
            "State": "KY"
        },
        {
            "Code": "21089",
            "County": "Greenup",
            "State": "KY"
        },
        {
            "Code": "21091",
            "County": "Hancock",
            "State": "KY"
        },
        {
            "Code": "21093",
            "County": "Hardin",
            "State": "KY"
        },
        {
            "Code": "21095",
            "County": "Harlan",
            "State": "KY"
        },
        {
            "Code": "21097",
            "County": "Harrison",
            "State": "KY"
        },
        {
            "Code": "21099",
            "County": "Hart",
            "State": "KY"
        },
        {
            "Code": "21101",
            "County": "Henderson",
            "State": "KY"
        },
        {
            "Code": "21103",
            "County": "Henry",
            "State": "KY"
        },
        {
            "Code": "21105",
            "County": "Hickman",
            "State": "KY"
        },
        {
            "Code": "21107",
            "County": "Hopkins",
            "State": "KY"
        },
        {
            "Code": "21109",
            "County": "Jackson",
            "State": "KY"
        },
        {
            "Code": "21111",
            "County": "Jefferson",
            "State": "KY"
        },
        {
            "Code": "21113",
            "County": "Jessamine",
            "State": "KY"
        },
        {
            "Code": "21115",
            "County": "Johnson",
            "State": "KY"
        },
        {
            "Code": "21117",
            "County": "Kenton",
            "State": "KY"
        },
        {
            "Code": "21119",
            "County": "Knott",
            "State": "KY"
        },
        {
            "Code": "21121",
            "County": "Knox",
            "State": "KY"
        },
        {
            "Code": "21123",
            "County": "Larue",
            "State": "KY"
        },
        {
            "Code": "21125",
            "County": "Laurel",
            "State": "KY"
        },
        {
            "Code": "21127",
            "County": "Lawrence",
            "State": "KY"
        },
        {
            "Code": "21129",
            "County": "Lee",
            "State": "KY"
        },
        {
            "Code": "21131",
            "County": "Leslie",
            "State": "KY"
        },
        {
            "Code": "21133",
            "County": "Letcher",
            "State": "KY"
        },
        {
            "Code": "21135",
            "County": "Lewis",
            "State": "KY"
        },
        {
            "Code": "21137",
            "County": "Lincoln",
            "State": "KY"
        },
        {
            "Code": "21139",
            "County": "Livingston",
            "State": "KY"
        },
        {
            "Code": "21141",
            "County": "Logan",
            "State": "KY"
        },
        {
            "Code": "21143",
            "County": "Lyon",
            "State": "KY"
        },
        {
            "Code": "21145",
            "County": "McCracken",
            "State": "KY"
        },
        {
            "Code": "21147",
            "County": "McCreary",
            "State": "KY"
        },
        {
            "Code": "21149",
            "County": "McLean",
            "State": "KY"
        },
        {
            "Code": "21151",
            "County": "Madison",
            "State": "KY"
        },
        {
            "Code": "21153",
            "County": "Magoffin",
            "State": "KY"
        },
        {
            "Code": "21155",
            "County": "Marion",
            "State": "KY"
        },
        {
            "Code": "21157",
            "County": "Marshall",
            "State": "KY"
        },
        {
            "Code": "21159",
            "County": "Martin",
            "State": "KY"
        },
        {
            "Code": "21161",
            "County": "Mason",
            "State": "KY"
        },
        {
            "Code": "21163",
            "County": "Meade",
            "State": "KY"
        },
        {
            "Code": "21165",
            "County": "Menifee",
            "State": "KY"
        },
        {
            "Code": "21167",
            "County": "Mercer",
            "State": "KY"
        },
        {
            "Code": "21169",
            "County": "Metcalfe",
            "State": "KY"
        },
        {
            "Code": "21171",
            "County": "Monroe",
            "State": "KY"
        },
        {
            "Code": "21173",
            "County": "Montgomery",
            "State": "KY"
        },
        {
            "Code": "21175",
            "County": "Morgan",
            "State": "KY"
        },
        {
            "Code": "21177",
            "County": "Muhlenberg",
            "State": "KY"
        },
        {
            "Code": "21179",
            "County": "Nelson",
            "State": "KY"
        },
        {
            "Code": "21181",
            "County": "Nicholas",
            "State": "KY"
        },
        {
            "Code": "21183",
            "County": "Ohio",
            "State": "KY"
        },
        {
            "Code": "21185",
            "County": "Oldham",
            "State": "KY"
        },
        {
            "Code": "21187",
            "County": "Owen",
            "State": "KY"
        },
        {
            "Code": "21189",
            "County": "Owsley",
            "State": "KY"
        },
        {
            "Code": "21191",
            "County": "Pendleton",
            "State": "KY"
        },
        {
            "Code": "21193",
            "County": "Perry",
            "State": "KY"
        },
        {
            "Code": "21195",
            "County": "Pike",
            "State": "KY"
        },
        {
            "Code": "21197",
            "County": "Powell",
            "State": "KY"
        },
        {
            "Code": "21199",
            "County": "Pulaski",
            "State": "KY"
        },
        {
            "Code": "21201",
            "County": "Robertson",
            "State": "KY"
        },
        {
            "Code": "21203",
            "County": "Rockcastle",
            "State": "KY"
        },
        {
            "Code": "21205",
            "County": "Rowan",
            "State": "KY"
        },
        {
            "Code": "21207",
            "County": "Russell",
            "State": "KY"
        },
        {
            "Code": "21209",
            "County": "Scott",
            "State": "KY"
        },
        {
            "Code": "21211",
            "County": "Shelby",
            "State": "KY"
        },
        {
            "Code": "21213",
            "County": "Simpson",
            "State": "KY"
        },
        {
            "Code": "21215",
            "County": "Spencer",
            "State": "KY"
        },
        {
            "Code": "21217",
            "County": "Taylor",
            "State": "KY"
        },
        {
            "Code": "21219",
            "County": "Todd",
            "State": "KY"
        },
        {
            "Code": "21221",
            "County": "Trigg",
            "State": "KY"
        },
        {
            "Code": "21223",
            "County": "Trimble",
            "State": "KY"
        },
        {
            "Code": "21225",
            "County": "Union",
            "State": "KY"
        },
        {
            "Code": "21227",
            "County": "Warren",
            "State": "KY"
        },
        {
            "Code": "21229",
            "County": "Washington",
            "State": "KY"
        },
        {
            "Code": "21231",
            "County": "Wayne",
            "State": "KY"
        },
        {
            "Code": "21233",
            "County": "Webster",
            "State": "KY"
        },
        {
            "Code": "21235",
            "County": "Whitley",
            "State": "KY"
        },
        {
            "Code": "21237",
            "County": "Wolfe",
            "State": "KY"
        },
        {
            "Code": "21239",
            "County": "Woodford",
            "State": "KY"
        },
        {
            "Code": "22001",
            "County": "Acadia",
            "State": "LA"
        },
        {
            "Code": "22003",
            "County": "Allen",
            "State": "LA"
        },
        {
            "Code": "22005",
            "County": "Ascension",
            "State": "LA"
        },
        {
            "Code": "22007",
            "County": "Assumption",
            "State": "LA"
        },
        {
            "Code": "22009",
            "County": "Avoyelles",
            "State": "LA"
        },
        {
            "Code": "22011",
            "County": "Beauregard",
            "State": "LA"
        },
        {
            "Code": "22013",
            "County": "Bienville",
            "State": "LA"
        },
        {
            "Code": "22015",
            "County": "Bossier",
            "State": "LA"
        },
        {
            "Code": "22017",
            "County": "Caddo",
            "State": "LA"
        },
        {
            "Code": "22019",
            "County": "Calcasieu",
            "State": "LA"
        },
        {
            "Code": "22021",
            "County": "Caldwell",
            "State": "LA"
        },
        {
            "Code": "22023",
            "County": "Cameron",
            "State": "LA"
        },
        {
            "Code": "22025",
            "County": "Catahoula",
            "State": "LA"
        },
        {
            "Code": "22027",
            "County": "Claiborne",
            "State": "LA"
        },
        {
            "Code": "22029",
            "County": "Concordia",
            "State": "LA"
        },
        {
            "Code": "22031",
            "County": "De Soto",
            "State": "LA"
        },
        {
            "Code": "22033",
            "County": "East Baton Rouge",
            "State": "LA"
        },
        {
            "Code": "22035",
            "County": "East Carroll",
            "State": "LA"
        },
        {
            "Code": "22037",
            "County": "East Feliciana",
            "State": "LA"
        },
        {
            "Code": "22039",
            "County": "Evangeline",
            "State": "LA"
        },
        {
            "Code": "22041",
            "County": "Franklin",
            "State": "LA"
        },
        {
            "Code": "22043",
            "County": "Grant",
            "State": "LA"
        },
        {
            "Code": "22045",
            "County": "Iberia",
            "State": "LA"
        },
        {
            "Code": "22047",
            "County": "Iberville",
            "State": "LA"
        },
        {
            "Code": "22049",
            "County": "Jackson",
            "State": "LA"
        },
        {
            "Code": "22051",
            "County": "Jefferson",
            "State": "LA"
        },
        {
            "Code": "22053",
            "County": "Jefferson Davis",
            "State": "LA"
        },
        {
            "Code": "22055",
            "County": "Lafayette",
            "State": "LA"
        },
        {
            "Code": "22057",
            "County": "Lafourche",
            "State": "LA"
        },
        {
            "Code": "22059",
            "County": "La Salle",
            "State": "LA"
        },
        {
            "Code": "22061",
            "County": "Lincoln",
            "State": "LA"
        },
        {
            "Code": "22063",
            "County": "Livingston",
            "State": "LA"
        },
        {
            "Code": "22065",
            "County": "Madison",
            "State": "LA"
        },
        {
            "Code": "22067",
            "County": "Morehouse",
            "State": "LA"
        },
        {
            "Code": "22069",
            "County": "Natchitoches",
            "State": "LA"
        },
        {
            "Code": "22071",
            "County": "Orleans",
            "State": "LA"
        },
        {
            "Code": "22073",
            "County": "Ouachita",
            "State": "LA"
        },
        {
            "Code": "22075",
            "County": "Plaquemines",
            "State": "LA"
        },
        {
            "Code": "22077",
            "County": "Pointe Coupee",
            "State": "LA"
        },
        {
            "Code": "22079",
            "County": "Rapides",
            "State": "LA"
        },
        {
            "Code": "22081",
            "County": "Red River",
            "State": "LA"
        },
        {
            "Code": "22083",
            "County": "Richland",
            "State": "LA"
        },
        {
            "Code": "22085",
            "County": "Sabine",
            "State": "LA"
        },
        {
            "Code": "22087",
            "County": "St Bernard",
            "State": "LA"
        },
        {
            "Code": "22089",
            "County": "St Charles",
            "State": "LA"
        },
        {
            "Code": "22091",
            "County": "St Helena",
            "State": "LA"
        },
        {
            "Code": "22093",
            "County": "St James",
            "State": "LA"
        },
        {
            "Code": "22095",
            "County": "St John the Baptist",
            "State": "LA"
        },
        {
            "Code": "22097",
            "County": "St Landry",
            "State": "LA"
        },
        {
            "Code": "22099",
            "County": "St Martin",
            "State": "LA"
        },
        {
            "Code": "22101",
            "County": "St Mary",
            "State": "LA"
        },
        {
            "Code": "22103",
            "County": "St Tammany",
            "State": "LA"
        },
        {
            "Code": "22105",
            "County": "Tangipahoa",
            "State": "LA"
        },
        {
            "Code": "22107",
            "County": "Tensas",
            "State": "LA"
        },
        {
            "Code": "22109",
            "County": "Terrebonne",
            "State": "LA"
        },
        {
            "Code": "22111",
            "County": "Union",
            "State": "LA"
        },
        {
            "Code": "22113",
            "County": "Vermilion",
            "State": "LA"
        },
        {
            "Code": "22115",
            "County": "Vernon",
            "State": "LA"
        },
        {
            "Code": "22117",
            "County": "Washington",
            "State": "LA"
        },
        {
            "Code": "22119",
            "County": "Webster",
            "State": "LA"
        },
        {
            "Code": "22121",
            "County": "West Baton Rouge",
            "State": "LA"
        },
        {
            "Code": "22123",
            "County": "West Carroll",
            "State": "LA"
        },
        {
            "Code": "22125",
            "County": "West Feliciana",
            "State": "LA"
        },
        {
            "Code": "22127",
            "County": "Winn",
            "State": "LA"
        },
        {
            "Code": "23001",
            "County": "Androscoggin",
            "State": "ME"
        },
        {
            "Code": "23003",
            "County": "Aroostook",
            "State": "ME"
        },
        {
            "Code": "23005",
            "County": "Cumberland",
            "State": "ME"
        },
        {
            "Code": "23007",
            "County": "Franklin",
            "State": "ME"
        },
        {
            "Code": "23009",
            "County": "Hancock",
            "State": "ME"
        },
        {
            "Code": "23011",
            "County": "Kennebec",
            "State": "ME"
        },
        {
            "Code": "23013",
            "County": "Knox",
            "State": "ME"
        },
        {
            "Code": "23015",
            "County": "Lincoln",
            "State": "ME"
        },
        {
            "Code": "23017",
            "County": "Oxford",
            "State": "ME"
        },
        {
            "Code": "23019",
            "County": "Penobscot",
            "State": "ME"
        },
        {
            "Code": "23021",
            "County": "Piscataquis",
            "State": "ME"
        },
        {
            "Code": "23023",
            "County": "Sagadahoc",
            "State": "ME"
        },
        {
            "Code": "23025",
            "County": "Somerset",
            "State": "ME"
        },
        {
            "Code": "23027",
            "County": "Waldo",
            "State": "ME"
        },
        {
            "Code": "23029",
            "County": "Washington",
            "State": "ME"
        },
        {
            "Code": "23031",
            "County": "York",
            "State": "ME"
        },
        {
            "Code": "24001",
            "County": "Allegany",
            "State": "MD"
        },
        {
            "Code": "24003",
            "County": "Anne Arundel",
            "State": "MD"
        },
        {
            "Code": "24005",
            "County": "Baltimore",
            "State": "MD"
        },
        {
            "Code": "24009",
            "County": "Calvert",
            "State": "MD"
        },
        {
            "Code": "24011",
            "County": "Caroline",
            "State": "MD"
        },
        {
            "Code": "24013",
            "County": "Carroll",
            "State": "MD"
        },
        {
            "Code": "24015",
            "County": "Cecil",
            "State": "MD"
        },
        {
            "Code": "24017",
            "County": "Charles",
            "State": "MD"
        },
        {
            "Code": "24019",
            "County": "Dorchester",
            "State": "MD"
        },
        {
            "Code": "24021",
            "County": "Frederick",
            "State": "MD"
        },
        {
            "Code": "24023",
            "County": "Garrett",
            "State": "MD"
        },
        {
            "Code": "24025",
            "County": "Harford",
            "State": "MD"
        },
        {
            "Code": "24027",
            "County": "Howard",
            "State": "MD"
        },
        {
            "Code": "24029",
            "County": "Kent",
            "State": "MD"
        },
        {
            "Code": "24031",
            "County": "Montgomery",
            "State": "MD"
        },
        {
            "Code": "24033",
            "County": "Prince Georges",
            "State": "MD"
        },
        {
            "Code": "24035",
            "County": "Queen Annes",
            "State": "MD"
        },
        {
            "Code": "24037",
            "County": "St Marys",
            "State": "MD"
        },
        {
            "Code": "24039",
            "County": "Somerset",
            "State": "MD"
        },
        {
            "Code": "24041",
            "County": "Talbot",
            "State": "MD"
        },
        {
            "Code": "24043",
            "County": "Washington",
            "State": "MD"
        },
        {
            "Code": "24045",
            "County": "Wicomico",
            "State": "MD"
        },
        {
            "Code": "24047",
            "County": "Worcester",
            "State": "MD"
        },
        {
            "Code": "24510",
            "County": "Baltimore City",
            "State": "MD"
        },
        {
            "Code": "25001",
            "County": "Barnstable",
            "State": "MA"
        },
        {
            "Code": "25003",
            "County": "Berkshire",
            "State": "MA"
        },
        {
            "Code": "25005",
            "County": "Bristol",
            "State": "MA"
        },
        {
            "Code": "25007",
            "County": "Dukes",
            "State": "MA"
        },
        {
            "Code": "25009",
            "County": "Essex",
            "State": "MA"
        },
        {
            "Code": "25011",
            "County": "Franklin",
            "State": "MA"
        },
        {
            "Code": "25013",
            "County": "Hampden",
            "State": "MA"
        },
        {
            "Code": "25015",
            "County": "Hampshire",
            "State": "MA"
        },
        {
            "Code": "25017",
            "County": "Middlesex",
            "State": "MA"
        },
        {
            "Code": "25019",
            "County": "Nantucket",
            "State": "MA"
        },
        {
            "Code": "25021",
            "County": "Norfolk",
            "State": "MA"
        },
        {
            "Code": "25023",
            "County": "Plymouth",
            "State": "MA"
        },
        {
            "Code": "25025",
            "County": "Suffolk",
            "State": "MA"
        },
        {
            "Code": "25027",
            "County": "Worcester",
            "State": "MA"
        },
        {
            "Code": "26001",
            "County": "Alcona",
            "State": "MI"
        },
        {
            "Code": "26003",
            "County": "Alger",
            "State": "MI"
        },
        {
            "Code": "26005",
            "County": "Allegan",
            "State": "MI"
        },
        {
            "Code": "26007",
            "County": "Alpena",
            "State": "MI"
        },
        {
            "Code": "26009",
            "County": "Antrim",
            "State": "MI"
        },
        {
            "Code": "26011",
            "County": "Arenac",
            "State": "MI"
        },
        {
            "Code": "26013",
            "County": "Baraga",
            "State": "MI"
        },
        {
            "Code": "26015",
            "County": "Barry",
            "State": "MI"
        },
        {
            "Code": "26017",
            "County": "Bay",
            "State": "MI"
        },
        {
            "Code": "26019",
            "County": "Benzie",
            "State": "MI"
        },
        {
            "Code": "26021",
            "County": "Berrien",
            "State": "MI"
        },
        {
            "Code": "26023",
            "County": "Branch",
            "State": "MI"
        },
        {
            "Code": "26025",
            "County": "Calhoun",
            "State": "MI"
        },
        {
            "Code": "26027",
            "County": "Cass",
            "State": "MI"
        },
        {
            "Code": "26029",
            "County": "Charlevoix",
            "State": "MI"
        },
        {
            "Code": "26031",
            "County": "Cheboygan",
            "State": "MI"
        },
        {
            "Code": "26033",
            "County": "Chippewa",
            "State": "MI"
        },
        {
            "Code": "26035",
            "County": "Clare",
            "State": "MI"
        },
        {
            "Code": "26037",
            "County": "Clinton",
            "State": "MI"
        },
        {
            "Code": "26039",
            "County": "Crawford",
            "State": "MI"
        },
        {
            "Code": "26041",
            "County": "Delta",
            "State": "MI"
        },
        {
            "Code": "26043",
            "County": "Dickinson",
            "State": "MI"
        },
        {
            "Code": "26045",
            "County": "Eaton",
            "State": "MI"
        },
        {
            "Code": "26047",
            "County": "Emmet",
            "State": "MI"
        },
        {
            "Code": "26049",
            "County": "Genesee",
            "State": "MI"
        },
        {
            "Code": "26051",
            "County": "Gladwin",
            "State": "MI"
        },
        {
            "Code": "26053",
            "County": "Gogebic",
            "State": "MI"
        },
        {
            "Code": "26055",
            "County": "Grand Traverse",
            "State": "MI"
        },
        {
            "Code": "26057",
            "County": "Gratiot",
            "State": "MI"
        },
        {
            "Code": "26059",
            "County": "Hillsdale",
            "State": "MI"
        },
        {
            "Code": "26061",
            "County": "Houghton",
            "State": "MI"
        },
        {
            "Code": "26063",
            "County": "Huron",
            "State": "MI"
        },
        {
            "Code": "26065",
            "County": "Ingham",
            "State": "MI"
        },
        {
            "Code": "26067",
            "County": "Ionia",
            "State": "MI"
        },
        {
            "Code": "26069",
            "County": "Iosco",
            "State": "MI"
        },
        {
            "Code": "26071",
            "County": "Iron",
            "State": "MI"
        },
        {
            "Code": "26073",
            "County": "Isabella",
            "State": "MI"
        },
        {
            "Code": "26075",
            "County": "Jackson",
            "State": "MI"
        },
        {
            "Code": "26077",
            "County": "Kalamazoo",
            "State": "MI"
        },
        {
            "Code": "26079",
            "County": "Kalkaska",
            "State": "MI"
        },
        {
            "Code": "26081",
            "County": "Kent",
            "State": "MI"
        },
        {
            "Code": "26083",
            "County": "Keweenaw",
            "State": "MI"
        },
        {
            "Code": "26085",
            "County": "Lake",
            "State": "MI"
        },
        {
            "Code": "26087",
            "County": "Lapeer",
            "State": "MI"
        },
        {
            "Code": "26089",
            "County": "Leelanau",
            "State": "MI"
        },
        {
            "Code": "26091",
            "County": "Lenawee",
            "State": "MI"
        },
        {
            "Code": "26093",
            "County": "Livingston",
            "State": "MI"
        },
        {
            "Code": "26095",
            "County": "Luce",
            "State": "MI"
        },
        {
            "Code": "26097",
            "County": "Mackinac",
            "State": "MI"
        },
        {
            "Code": "26099",
            "County": "Macomb",
            "State": "MI"
        },
        {
            "Code": "26101",
            "County": "Manistee",
            "State": "MI"
        },
        {
            "Code": "26103",
            "County": "Marquette",
            "State": "MI"
        },
        {
            "Code": "26105",
            "County": "Mason",
            "State": "MI"
        },
        {
            "Code": "26107",
            "County": "Mecosta",
            "State": "MI"
        },
        {
            "Code": "26109",
            "County": "Menominee",
            "State": "MI"
        },
        {
            "Code": "26111",
            "County": "Midland",
            "State": "MI"
        },
        {
            "Code": "26113",
            "County": "Missaukee",
            "State": "MI"
        },
        {
            "Code": "26115",
            "County": "Monroe",
            "State": "MI"
        },
        {
            "Code": "26117",
            "County": "Montcalm",
            "State": "MI"
        },
        {
            "Code": "26119",
            "County": "Montmorency",
            "State": "MI"
        },
        {
            "Code": "26121",
            "County": "Muskegon",
            "State": "MI"
        },
        {
            "Code": "26123",
            "County": "Newaygo",
            "State": "MI"
        },
        {
            "Code": "26125",
            "County": "Oakland",
            "State": "MI"
        },
        {
            "Code": "26127",
            "County": "Oceana",
            "State": "MI"
        },
        {
            "Code": "26129",
            "County": "Ogemaw",
            "State": "MI"
        },
        {
            "Code": "26131",
            "County": "Ontonagon",
            "State": "MI"
        },
        {
            "Code": "26133",
            "County": "Osceola",
            "State": "MI"
        },
        {
            "Code": "26135",
            "County": "Oscoda",
            "State": "MI"
        },
        {
            "Code": "26137",
            "County": "Otsego",
            "State": "MI"
        },
        {
            "Code": "26139",
            "County": "Ottawa",
            "State": "MI"
        },
        {
            "Code": "26141",
            "County": "Presque Isle",
            "State": "MI"
        },
        {
            "Code": "26143",
            "County": "Roscommon",
            "State": "MI"
        },
        {
            "Code": "26145",
            "County": "Saginaw",
            "State": "MI"
        },
        {
            "Code": "26147",
            "County": "St Clair",
            "State": "MI"
        },
        {
            "Code": "26149",
            "County": "St Joseph",
            "State": "MI"
        },
        {
            "Code": "26151",
            "County": "Sanilac",
            "State": "MI"
        },
        {
            "Code": "26153",
            "County": "Schoolcraft",
            "State": "MI"
        },
        {
            "Code": "26155",
            "County": "Shiawassee",
            "State": "MI"
        },
        {
            "Code": "26157",
            "County": "Tuscola",
            "State": "MI"
        },
        {
            "Code": "26159",
            "County": "Van Buren",
            "State": "MI"
        },
        {
            "Code": "26161",
            "County": "Washtenaw",
            "State": "MI"
        },
        {
            "Code": "26163",
            "County": "Wayne",
            "State": "MI"
        },
        {
            "Code": "26165",
            "County": "Wexford",
            "State": "MI"
        },
        {
            "Code": "27001",
            "County": "Aitkin",
            "State": "MN"
        },
        {
            "Code": "27003",
            "County": "Anoka",
            "State": "MN"
        },
        {
            "Code": "27005",
            "County": "Becker",
            "State": "MN"
        },
        {
            "Code": "27007",
            "County": "Beltrami",
            "State": "MN"
        },
        {
            "Code": "27009",
            "County": "Benton",
            "State": "MN"
        },
        {
            "Code": "27011",
            "County": "Big Stone",
            "State": "MN"
        },
        {
            "Code": "27013",
            "County": "Blue Earth",
            "State": "MN"
        },
        {
            "Code": "27015",
            "County": "Brown",
            "State": "MN"
        },
        {
            "Code": "27017",
            "County": "Carlton",
            "State": "MN"
        },
        {
            "Code": "27019",
            "County": "Carver",
            "State": "MN"
        },
        {
            "Code": "27021",
            "County": "Cass",
            "State": "MN"
        },
        {
            "Code": "27023",
            "County": "Chippewa",
            "State": "MN"
        },
        {
            "Code": "27025",
            "County": "Chisago",
            "State": "MN"
        },
        {
            "Code": "27027",
            "County": "Clay",
            "State": "MN"
        },
        {
            "Code": "27029",
            "County": "Clearwater",
            "State": "MN"
        },
        {
            "Code": "27031",
            "County": "Cook",
            "State": "MN"
        },
        {
            "Code": "27033",
            "County": "Cottonwood",
            "State": "MN"
        },
        {
            "Code": "27035",
            "County": "Crow Wing",
            "State": "MN"
        },
        {
            "Code": "27037",
            "County": "Dakota",
            "State": "MN"
        },
        {
            "Code": "27039",
            "County": "Dodge",
            "State": "MN"
        },
        {
            "Code": "27041",
            "County": "Douglas",
            "State": "MN"
        },
        {
            "Code": "27043",
            "County": "Faribault",
            "State": "MN"
        },
        {
            "Code": "27045",
            "County": "Fillmore",
            "State": "MN"
        },
        {
            "Code": "27047",
            "County": "Freeborn",
            "State": "MN"
        },
        {
            "Code": "27049",
            "County": "Goodhue",
            "State": "MN"
        },
        {
            "Code": "27051",
            "County": "Grant",
            "State": "MN"
        },
        {
            "Code": "27053",
            "County": "Hennepin",
            "State": "MN"
        },
        {
            "Code": "27055",
            "County": "Houston",
            "State": "MN"
        },
        {
            "Code": "27057",
            "County": "Hubbard",
            "State": "MN"
        },
        {
            "Code": "27059",
            "County": "Isanti",
            "State": "MN"
        },
        {
            "Code": "27061",
            "County": "Itasca",
            "State": "MN"
        },
        {
            "Code": "27063",
            "County": "Jackson",
            "State": "MN"
        },
        {
            "Code": "27065",
            "County": "Kanabec",
            "State": "MN"
        },
        {
            "Code": "27067",
            "County": "Kandiyohi",
            "State": "MN"
        },
        {
            "Code": "27069",
            "County": "Kittson",
            "State": "MN"
        },
        {
            "Code": "27071",
            "County": "Koochiching",
            "State": "MN"
        },
        {
            "Code": "27073",
            "County": "Lac qui Parle",
            "State": "MN"
        },
        {
            "Code": "27075",
            "County": "Lake",
            "State": "MN"
        },
        {
            "Code": "27077",
            "County": "Lake of the Woods",
            "State": "MN"
        },
        {
            "Code": "27079",
            "County": "Le Sueur",
            "State": "MN"
        },
        {
            "Code": "27081",
            "County": "Lincoln",
            "State": "MN"
        },
        {
            "Code": "27083",
            "County": "Lyon",
            "State": "MN"
        },
        {
            "Code": "27085",
            "County": "McLeod",
            "State": "MN"
        },
        {
            "Code": "27087",
            "County": "Mahnomen",
            "State": "MN"
        },
        {
            "Code": "27089",
            "County": "Marshall",
            "State": "MN"
        },
        {
            "Code": "27091",
            "County": "Martin",
            "State": "MN"
        },
        {
            "Code": "27093",
            "County": "Meeker",
            "State": "MN"
        },
        {
            "Code": "27095",
            "County": "Mille Lacs",
            "State": "MN"
        },
        {
            "Code": "27097",
            "County": "Morrison",
            "State": "MN"
        },
        {
            "Code": "27099",
            "County": "Mower",
            "State": "MN"
        },
        {
            "Code": "27101",
            "County": "Murray",
            "State": "MN"
        },
        {
            "Code": "27103",
            "County": "Nicollet",
            "State": "MN"
        },
        {
            "Code": "27105",
            "County": "Nobles",
            "State": "MN"
        },
        {
            "Code": "27107",
            "County": "Norman",
            "State": "MN"
        },
        {
            "Code": "27109",
            "County": "Olmsted",
            "State": "MN"
        },
        {
            "Code": "27111",
            "County": "Otter Tail",
            "State": "MN"
        },
        {
            "Code": "27113",
            "County": "Pennington",
            "State": "MN"
        },
        {
            "Code": "27115",
            "County": "Pine",
            "State": "MN"
        },
        {
            "Code": "27117",
            "County": "Pipestone",
            "State": "MN"
        },
        {
            "Code": "27119",
            "County": "Polk",
            "State": "MN"
        },
        {
            "Code": "27121",
            "County": "Pope",
            "State": "MN"
        },
        {
            "Code": "27123",
            "County": "Ramsey",
            "State": "MN"
        },
        {
            "Code": "27125",
            "County": "Red Lake",
            "State": "MN"
        },
        {
            "Code": "27127",
            "County": "Redwood",
            "State": "MN"
        },
        {
            "Code": "27129",
            "County": "Renville",
            "State": "MN"
        },
        {
            "Code": "27131",
            "County": "Rice",
            "State": "MN"
        },
        {
            "Code": "27133",
            "County": "Rock",
            "State": "MN"
        },
        {
            "Code": "27135",
            "County": "Roseau",
            "State": "MN"
        },
        {
            "Code": "27137",
            "County": "St Louis",
            "State": "MN"
        },
        {
            "Code": "27139",
            "County": "Scott",
            "State": "MN"
        },
        {
            "Code": "27141",
            "County": "Sherburne",
            "State": "MN"
        },
        {
            "Code": "27143",
            "County": "Sibley",
            "State": "MN"
        },
        {
            "Code": "27145",
            "County": "Stearns",
            "State": "MN"
        },
        {
            "Code": "27147",
            "County": "Steele",
            "State": "MN"
        },
        {
            "Code": "27149",
            "County": "Stevens",
            "State": "MN"
        },
        {
            "Code": "27151",
            "County": "Swift",
            "State": "MN"
        },
        {
            "Code": "27153",
            "County": "Todd",
            "State": "MN"
        },
        {
            "Code": "27155",
            "County": "Traverse",
            "State": "MN"
        },
        {
            "Code": "27157",
            "County": "Wabasha",
            "State": "MN"
        },
        {
            "Code": "27159",
            "County": "Wadena",
            "State": "MN"
        },
        {
            "Code": "27161",
            "County": "Waseca",
            "State": "MN"
        },
        {
            "Code": "27163",
            "County": "Washington",
            "State": "MN"
        },
        {
            "Code": "27165",
            "County": "Watonwan",
            "State": "MN"
        },
        {
            "Code": "27167",
            "County": "Wilkin",
            "State": "MN"
        },
        {
            "Code": "27169",
            "County": "Winona",
            "State": "MN"
        },
        {
            "Code": "27171",
            "County": "Wright",
            "State": "MN"
        },
        {
            "Code": "27173",
            "County": "Yellow Medicine",
            "State": "MN"
        },
        {
            "Code": "28001",
            "County": "Adams",
            "State": "MS"
        },
        {
            "Code": "28003",
            "County": "Alcorn",
            "State": "MS"
        },
        {
            "Code": "28005",
            "County": "Amite",
            "State": "MS"
        },
        {
            "Code": "28007",
            "County": "Attala",
            "State": "MS"
        },
        {
            "Code": "28009",
            "County": "Benton",
            "State": "MS"
        },
        {
            "Code": "28011",
            "County": "Bolivar",
            "State": "MS"
        },
        {
            "Code": "28013",
            "County": "Calhoun",
            "State": "MS"
        },
        {
            "Code": "28015",
            "County": "Carroll",
            "State": "MS"
        },
        {
            "Code": "28017",
            "County": "Chickasaw",
            "State": "MS"
        },
        {
            "Code": "28019",
            "County": "Choctaw",
            "State": "MS"
        },
        {
            "Code": "28021",
            "County": "Claiborne",
            "State": "MS"
        },
        {
            "Code": "28023",
            "County": "Clarke",
            "State": "MS"
        },
        {
            "Code": "28025",
            "County": "Clay",
            "State": "MS"
        },
        {
            "Code": "28027",
            "County": "Coahoma",
            "State": "MS"
        },
        {
            "Code": "28029",
            "County": "Copiah",
            "State": "MS"
        },
        {
            "Code": "28031",
            "County": "Covington",
            "State": "MS"
        },
        {
            "Code": "28033",
            "County": "De Soto",
            "State": "MS"
        },
        {
            "Code": "28035",
            "County": "Forrest",
            "State": "MS"
        },
        {
            "Code": "28037",
            "County": "Franklin",
            "State": "MS"
        },
        {
            "Code": "28039",
            "County": "George",
            "State": "MS"
        },
        {
            "Code": "28041",
            "County": "Greene",
            "State": "MS"
        },
        {
            "Code": "28043",
            "County": "Grenada",
            "State": "MS"
        },
        {
            "Code": "28045",
            "County": "Hancock",
            "State": "MS"
        },
        {
            "Code": "28047",
            "County": "Harrison",
            "State": "MS"
        },
        {
            "Code": "28049",
            "County": "Hinds",
            "State": "MS"
        },
        {
            "Code": "28051",
            "County": "Holmes",
            "State": "MS"
        },
        {
            "Code": "28053",
            "County": "Humphreys",
            "State": "MS"
        },
        {
            "Code": "28055",
            "County": "Issaquena",
            "State": "MS"
        },
        {
            "Code": "28057",
            "County": "Itawamba",
            "State": "MS"
        },
        {
            "Code": "28059",
            "County": "Jackson",
            "State": "MS"
        },
        {
            "Code": "28061",
            "County": "Jasper",
            "State": "MS"
        },
        {
            "Code": "28063",
            "County": "Jefferson",
            "State": "MS"
        },
        {
            "Code": "28065",
            "County": "Jefferson Davis",
            "State": "MS"
        },
        {
            "Code": "28067",
            "County": "Jones",
            "State": "MS"
        },
        {
            "Code": "28069",
            "County": "Kemper",
            "State": "MS"
        },
        {
            "Code": "28071",
            "County": "Lafayette",
            "State": "MS"
        },
        {
            "Code": "28073",
            "County": "Lamar",
            "State": "MS"
        },
        {
            "Code": "28075",
            "County": "Lauderdale",
            "State": "MS"
        },
        {
            "Code": "28077",
            "County": "Lawrence",
            "State": "MS"
        },
        {
            "Code": "28079",
            "County": "Leake",
            "State": "MS"
        },
        {
            "Code": "28081",
            "County": "Lee",
            "State": "MS"
        },
        {
            "Code": "28083",
            "County": "Leflore",
            "State": "MS"
        },
        {
            "Code": "28085",
            "County": "Lincoln",
            "State": "MS"
        },
        {
            "Code": "28087",
            "County": "Lowndes",
            "State": "MS"
        },
        {
            "Code": "28089",
            "County": "Madison",
            "State": "MS"
        },
        {
            "Code": "28091",
            "County": "Marion",
            "State": "MS"
        },
        {
            "Code": "28093",
            "County": "Marshall",
            "State": "MS"
        },
        {
            "Code": "28095",
            "County": "Monroe",
            "State": "MS"
        },
        {
            "Code": "28097",
            "County": "Montgomery",
            "State": "MS"
        },
        {
            "Code": "28099",
            "County": "Neshoba",
            "State": "MS"
        },
        {
            "Code": "28101",
            "County": "Newton",
            "State": "MS"
        },
        {
            "Code": "28103",
            "County": "Noxubee",
            "State": "MS"
        },
        {
            "Code": "28105",
            "County": "Oktibbeha",
            "State": "MS"
        },
        {
            "Code": "28107",
            "County": "Panola",
            "State": "MS"
        },
        {
            "Code": "28109",
            "County": "Pearl River",
            "State": "MS"
        },
        {
            "Code": "28111",
            "County": "Perry",
            "State": "MS"
        },
        {
            "Code": "28113",
            "County": "Pike",
            "State": "MS"
        },
        {
            "Code": "28115",
            "County": "Pontotoc",
            "State": "MS"
        },
        {
            "Code": "28117",
            "County": "Prentiss",
            "State": "MS"
        },
        {
            "Code": "28119",
            "County": "Quitman",
            "State": "MS"
        },
        {
            "Code": "28121",
            "County": "Rankin",
            "State": "MS"
        },
        {
            "Code": "28123",
            "County": "Scott",
            "State": "MS"
        },
        {
            "Code": "28125",
            "County": "Sharkey",
            "State": "MS"
        },
        {
            "Code": "28127",
            "County": "Simpson",
            "State": "MS"
        },
        {
            "Code": "28129",
            "County": "Smith",
            "State": "MS"
        },
        {
            "Code": "28131",
            "County": "Stone",
            "State": "MS"
        },
        {
            "Code": "28133",
            "County": "Sunflower",
            "State": "MS"
        },
        {
            "Code": "28135",
            "County": "Tallahatchie",
            "State": "MS"
        },
        {
            "Code": "28137",
            "County": "Tate",
            "State": "MS"
        },
        {
            "Code": "28139",
            "County": "Tippah",
            "State": "MS"
        },
        {
            "Code": "28141",
            "County": "Tishomingo",
            "State": "MS"
        },
        {
            "Code": "28143",
            "County": "Tunica",
            "State": "MS"
        },
        {
            "Code": "28145",
            "County": "Union",
            "State": "MS"
        },
        {
            "Code": "28147",
            "County": "Walthall",
            "State": "MS"
        },
        {
            "Code": "28149",
            "County": "Warren",
            "State": "MS"
        },
        {
            "Code": "28151",
            "County": "Washington",
            "State": "MS"
        },
        {
            "Code": "28153",
            "County": "Wayne",
            "State": "MS"
        },
        {
            "Code": "28155",
            "County": "Webster",
            "State": "MS"
        },
        {
            "Code": "28157",
            "County": "Wilkinson",
            "State": "MS"
        },
        {
            "Code": "28159",
            "County": "Winston",
            "State": "MS"
        },
        {
            "Code": "28161",
            "County": "Yalobusha",
            "State": "MS"
        },
        {
            "Code": "28163",
            "County": "Yazoo",
            "State": "MS"
        },
        {
            "Code": "29001",
            "County": "Adair",
            "State": "MO"
        },
        {
            "Code": "29003",
            "County": "Andrew",
            "State": "MO"
        },
        {
            "Code": "29005",
            "County": "Atchison",
            "State": "MO"
        },
        {
            "Code": "29007",
            "County": "Audrain",
            "State": "MO"
        },
        {
            "Code": "29009",
            "County": "Barry",
            "State": "MO"
        },
        {
            "Code": "29011",
            "County": "Barton",
            "State": "MO"
        },
        {
            "Code": "29013",
            "County": "Bates",
            "State": "MO"
        },
        {
            "Code": "29015",
            "County": "Benton",
            "State": "MO"
        },
        {
            "Code": "29017",
            "County": "Bollinger",
            "State": "MO"
        },
        {
            "Code": "29019",
            "County": "Boone",
            "State": "MO"
        },
        {
            "Code": "29021",
            "County": "Buchanan",
            "State": "MO"
        },
        {
            "Code": "29023",
            "County": "Butler",
            "State": "MO"
        },
        {
            "Code": "29025",
            "County": "Caldwell",
            "State": "MO"
        },
        {
            "Code": "29027",
            "County": "Callaway",
            "State": "MO"
        },
        {
            "Code": "29029",
            "County": "Camden",
            "State": "MO"
        },
        {
            "Code": "29031",
            "County": "Cape Girardeau",
            "State": "MO"
        },
        {
            "Code": "29033",
            "County": "Carroll",
            "State": "MO"
        },
        {
            "Code": "29035",
            "County": "Carter",
            "State": "MO"
        },
        {
            "Code": "29037",
            "County": "Cass",
            "State": "MO"
        },
        {
            "Code": "29039",
            "County": "Cedar",
            "State": "MO"
        },
        {
            "Code": "29041",
            "County": "Chariton",
            "State": "MO"
        },
        {
            "Code": "29043",
            "County": "Christian",
            "State": "MO"
        },
        {
            "Code": "29045",
            "County": "Clark",
            "State": "MO"
        },
        {
            "Code": "29047",
            "County": "Clay",
            "State": "MO"
        },
        {
            "Code": "29049",
            "County": "Clinton",
            "State": "MO"
        },
        {
            "Code": "29051",
            "County": "Cole",
            "State": "MO"
        },
        {
            "Code": "29053",
            "County": "Cooper",
            "State": "MO"
        },
        {
            "Code": "29055",
            "County": "Crawford",
            "State": "MO"
        },
        {
            "Code": "29057",
            "County": "Dade",
            "State": "MO"
        },
        {
            "Code": "29059",
            "County": "Dallas",
            "State": "MO"
        },
        {
            "Code": "29061",
            "County": "Daviess",
            "State": "MO"
        },
        {
            "Code": "29063",
            "County": "De Kalb",
            "State": "MO"
        },
        {
            "Code": "29065",
            "County": "Dent",
            "State": "MO"
        },
        {
            "Code": "29067",
            "County": "Douglas",
            "State": "MO"
        },
        {
            "Code": "29069",
            "County": "Dunklin",
            "State": "MO"
        },
        {
            "Code": "29071",
            "County": "Franklin",
            "State": "MO"
        },
        {
            "Code": "29073",
            "County": "Gasconade",
            "State": "MO"
        },
        {
            "Code": "29075",
            "County": "Gentry",
            "State": "MO"
        },
        {
            "Code": "29077",
            "County": "Greene",
            "State": "MO"
        },
        {
            "Code": "29079",
            "County": "Grundy",
            "State": "MO"
        },
        {
            "Code": "29081",
            "County": "Harrison",
            "State": "MO"
        },
        {
            "Code": "29083",
            "County": "Henry",
            "State": "MO"
        },
        {
            "Code": "29085",
            "County": "Hickory",
            "State": "MO"
        },
        {
            "Code": "29087",
            "County": "Holt",
            "State": "MO"
        },
        {
            "Code": "29089",
            "County": "Howard",
            "State": "MO"
        },
        {
            "Code": "29091",
            "County": "Howell",
            "State": "MO"
        },
        {
            "Code": "29093",
            "County": "Iron",
            "State": "MO"
        },
        {
            "Code": "29095",
            "County": "Jackson",
            "State": "MO"
        },
        {
            "Code": "29097",
            "County": "Jasper",
            "State": "MO"
        },
        {
            "Code": "29099",
            "County": "Jefferson",
            "State": "MO"
        },
        {
            "Code": "29101",
            "County": "Johnson",
            "State": "MO"
        },
        {
            "Code": "29103",
            "County": "Knox",
            "State": "MO"
        },
        {
            "Code": "29105",
            "County": "Laclede",
            "State": "MO"
        },
        {
            "Code": "29107",
            "County": "Lafayette",
            "State": "MO"
        },
        {
            "Code": "29109",
            "County": "Lawrence",
            "State": "MO"
        },
        {
            "Code": "29111",
            "County": "Lewis",
            "State": "MO"
        },
        {
            "Code": "29113",
            "County": "Lincoln",
            "State": "MO"
        },
        {
            "Code": "29115",
            "County": "Linn",
            "State": "MO"
        },
        {
            "Code": "29117",
            "County": "Livingston",
            "State": "MO"
        },
        {
            "Code": "29119",
            "County": "McDonald",
            "State": "MO"
        },
        {
            "Code": "29121",
            "County": "Macon",
            "State": "MO"
        },
        {
            "Code": "29123",
            "County": "Madison",
            "State": "MO"
        },
        {
            "Code": "29125",
            "County": "Maries",
            "State": "MO"
        },
        {
            "Code": "29127",
            "County": "Marion",
            "State": "MO"
        },
        {
            "Code": "29129",
            "County": "Mercer",
            "State": "MO"
        },
        {
            "Code": "29131",
            "County": "Miller",
            "State": "MO"
        },
        {
            "Code": "29133",
            "County": "Mississippi",
            "State": "MO"
        },
        {
            "Code": "29135",
            "County": "Moniteau",
            "State": "MO"
        },
        {
            "Code": "29137",
            "County": "Monroe",
            "State": "MO"
        },
        {
            "Code": "29139",
            "County": "Montgomery",
            "State": "MO"
        },
        {
            "Code": "29141",
            "County": "Morgan",
            "State": "MO"
        },
        {
            "Code": "29143",
            "County": "New Madrid",
            "State": "MO"
        },
        {
            "Code": "29145",
            "County": "Newton",
            "State": "MO"
        },
        {
            "Code": "29147",
            "County": "Nodaway",
            "State": "MO"
        },
        {
            "Code": "29149",
            "County": "Oregon",
            "State": "MO"
        },
        {
            "Code": "29151",
            "County": "Osage",
            "State": "MO"
        },
        {
            "Code": "29153",
            "County": "Ozark",
            "State": "MO"
        },
        {
            "Code": "29155",
            "County": "Pemiscot",
            "State": "MO"
        },
        {
            "Code": "29157",
            "County": "Perry",
            "State": "MO"
        },
        {
            "Code": "29159",
            "County": "Pettis",
            "State": "MO"
        },
        {
            "Code": "29161",
            "County": "Phelps",
            "State": "MO"
        },
        {
            "Code": "29163",
            "County": "Pike",
            "State": "MO"
        },
        {
            "Code": "29165",
            "County": "Platte",
            "State": "MO"
        },
        {
            "Code": "29167",
            "County": "Polk",
            "State": "MO"
        },
        {
            "Code": "29169",
            "County": "Pulaski",
            "State": "MO"
        },
        {
            "Code": "29171",
            "County": "Putnam",
            "State": "MO"
        },
        {
            "Code": "29173",
            "County": "Ralls",
            "State": "MO"
        },
        {
            "Code": "29175",
            "County": "Randolph",
            "State": "MO"
        },
        {
            "Code": "29177",
            "County": "Ray",
            "State": "MO"
        },
        {
            "Code": "29179",
            "County": "Reynolds",
            "State": "MO"
        },
        {
            "Code": "29181",
            "County": "Ripley",
            "State": "MO"
        },
        {
            "Code": "29183",
            "County": "St Charles",
            "State": "MO"
        },
        {
            "Code": "29185",
            "County": "St Clair",
            "State": "MO"
        },
        {
            "Code": "29186",
            "County": "Ste. Genevieve",
            "State": "MO"
        },
        {
            "Code": "29187",
            "County": "St Francois",
            "State": "MO"
        },
        {
            "Code": "29189",
            "County": "St Louis",
            "State": "MO"
        },
        {
            "Code": "29195",
            "County": "Saline",
            "State": "MO"
        },
        {
            "Code": "29197",
            "County": "Schuyler",
            "State": "MO"
        },
        {
            "Code": "29199",
            "County": "Scotland",
            "State": "MO"
        },
        {
            "Code": "29201",
            "County": "Scott",
            "State": "MO"
        },
        {
            "Code": "29203",
            "County": "Shannon",
            "State": "MO"
        },
        {
            "Code": "29205",
            "County": "Shelby",
            "State": "MO"
        },
        {
            "Code": "29207",
            "County": "Stoddard",
            "State": "MO"
        },
        {
            "Code": "29209",
            "County": "Stone",
            "State": "MO"
        },
        {
            "Code": "29211",
            "County": "Sullivan",
            "State": "MO"
        },
        {
            "Code": "29213",
            "County": "Taney",
            "State": "MO"
        },
        {
            "Code": "29215",
            "County": "Texas",
            "State": "MO"
        },
        {
            "Code": "29217",
            "County": "Vernon",
            "State": "MO"
        },
        {
            "Code": "29219",
            "County": "Warren",
            "State": "MO"
        },
        {
            "Code": "29221",
            "County": "Washington",
            "State": "MO"
        },
        {
            "Code": "29223",
            "County": "Wayne",
            "State": "MO"
        },
        {
            "Code": "29225",
            "County": "Webster",
            "State": "MO"
        },
        {
            "Code": "29227",
            "County": "Worth",
            "State": "MO"
        },
        {
            "Code": "29229",
            "County": "Wright",
            "State": "MO"
        },
        {
            "Code": "29510",
            "County": "St Louis City",
            "State": "MO"
        },
        {
            "Code": "30001",
            "County": "Beaverhead",
            "State": "MT"
        },
        {
            "Code": "30003",
            "County": "Big Horn",
            "State": "MT"
        },
        {
            "Code": "30005",
            "County": "Blaine",
            "State": "MT"
        },
        {
            "Code": "30007",
            "County": "Broadwater",
            "State": "MT"
        },
        {
            "Code": "30009",
            "County": "Carbon",
            "State": "MT"
        },
        {
            "Code": "30011",
            "County": "Carter",
            "State": "MT"
        },
        {
            "Code": "30013",
            "County": "Cascade",
            "State": "MT"
        },
        {
            "Code": "30015",
            "County": "Chouteau",
            "State": "MT"
        },
        {
            "Code": "30017",
            "County": "Custer",
            "State": "MT"
        },
        {
            "Code": "30019",
            "County": "Daniels",
            "State": "MT"
        },
        {
            "Code": "30021",
            "County": "Dawson",
            "State": "MT"
        },
        {
            "Code": "30023",
            "County": "Deer Lodge",
            "State": "MT"
        },
        {
            "Code": "30025",
            "County": "Fallon",
            "State": "MT"
        },
        {
            "Code": "30027",
            "County": "Fergus",
            "State": "MT"
        },
        {
            "Code": "30029",
            "County": "Flathead",
            "State": "MT"
        },
        {
            "Code": "30031",
            "County": "Gallatin",
            "State": "MT"
        },
        {
            "Code": "30033",
            "County": "Garfield",
            "State": "MT"
        },
        {
            "Code": "30035",
            "County": "Glacier",
            "State": "MT"
        },
        {
            "Code": "30037",
            "County": "Golden Valley",
            "State": "MT"
        },
        {
            "Code": "30039",
            "County": "Granite",
            "State": "MT"
        },
        {
            "Code": "30041",
            "County": "Hill",
            "State": "MT"
        },
        {
            "Code": "30043",
            "County": "Jefferson",
            "State": "MT"
        },
        {
            "Code": "30045",
            "County": "Judith Basin",
            "State": "MT"
        },
        {
            "Code": "30047",
            "County": "Lake",
            "State": "MT"
        },
        {
            "Code": "30049",
            "County": "Lewis and Clark",
            "State": "MT"
        },
        {
            "Code": "30051",
            "County": "Liberty",
            "State": "MT"
        },
        {
            "Code": "30053",
            "County": "Lincoln",
            "State": "MT"
        },
        {
            "Code": "30055",
            "County": "McCone",
            "State": "MT"
        },
        {
            "Code": "30057",
            "County": "Madison",
            "State": "MT"
        },
        {
            "Code": "30059",
            "County": "Meagher",
            "State": "MT"
        },
        {
            "Code": "30061",
            "County": "Mineral",
            "State": "MT"
        },
        {
            "Code": "30063",
            "County": "Missoula",
            "State": "MT"
        },
        {
            "Code": "30065",
            "County": "Musselshell",
            "State": "MT"
        },
        {
            "Code": "30067",
            "County": "Park",
            "State": "MT"
        },
        {
            "Code": "30069",
            "County": "Petroleum",
            "State": "MT"
        },
        {
            "Code": "30071",
            "County": "Phillips",
            "State": "MT"
        },
        {
            "Code": "30073",
            "County": "Pondera",
            "State": "MT"
        },
        {
            "Code": "30075",
            "County": "Powder River",
            "State": "MT"
        },
        {
            "Code": "30077",
            "County": "Powell",
            "State": "MT"
        },
        {
            "Code": "30079",
            "County": "Prairie",
            "State": "MT"
        },
        {
            "Code": "30081",
            "County": "Ravalli",
            "State": "MT"
        },
        {
            "Code": "30083",
            "County": "Richland",
            "State": "MT"
        },
        {
            "Code": "30085",
            "County": "Roosevelt",
            "State": "MT"
        },
        {
            "Code": "30087",
            "County": "Rosebud",
            "State": "MT"
        },
        {
            "Code": "30089",
            "County": "Sanders",
            "State": "MT"
        },
        {
            "Code": "30091",
            "County": "Sheridan",
            "State": "MT"
        },
        {
            "Code": "30093",
            "County": "Silver Bow",
            "State": "MT"
        },
        {
            "Code": "30095",
            "County": "Stillwater",
            "State": "MT"
        },
        {
            "Code": "30097",
            "County": "Sweet Grass",
            "State": "MT"
        },
        {
            "Code": "30099",
            "County": "Teton",
            "State": "MT"
        },
        {
            "Code": "30101",
            "County": "Toole",
            "State": "MT"
        },
        {
            "Code": "30103",
            "County": "Treasure",
            "State": "MT"
        },
        {
            "Code": "30105",
            "County": "Valley",
            "State": "MT"
        },
        {
            "Code": "30107",
            "County": "Wheatland",
            "State": "MT"
        },
        {
            "Code": "30109",
            "County": "Wibaux",
            "State": "MT"
        },
        {
            "Code": "30111",
            "County": "Yellowstone",
            "State": "MT"
        },
        {
            "Code": "30113",
            "County": "Yellowstone Nat Park",
            "State": "MT"
        },
        {
            "Code": "31001",
            "County": "Adams",
            "State": "NE"
        },
        {
            "Code": "31003",
            "County": "Antelope",
            "State": "NE"
        },
        {
            "Code": "31005",
            "County": "Arthur",
            "State": "NE"
        },
        {
            "Code": "31007",
            "County": "Banner",
            "State": "NE"
        },
        {
            "Code": "31009",
            "County": "Blaine",
            "State": "NE"
        },
        {
            "Code": "31011",
            "County": "Boone",
            "State": "NE"
        },
        {
            "Code": "31013",
            "County": "Box Butte",
            "State": "NE"
        },
        {
            "Code": "31015",
            "County": "Boyd",
            "State": "NE"
        },
        {
            "Code": "31017",
            "County": "Brown",
            "State": "NE"
        },
        {
            "Code": "31019",
            "County": "Buffalo",
            "State": "NE"
        },
        {
            "Code": "31021",
            "County": "Burt",
            "State": "NE"
        },
        {
            "Code": "31023",
            "County": "Butler",
            "State": "NE"
        },
        {
            "Code": "31025",
            "County": "Cass",
            "State": "NE"
        },
        {
            "Code": "31027",
            "County": "Cedar",
            "State": "NE"
        },
        {
            "Code": "31029",
            "County": "Chase",
            "State": "NE"
        },
        {
            "Code": "31031",
            "County": "Cherry",
            "State": "NE"
        },
        {
            "Code": "31033",
            "County": "Cheyenne",
            "State": "NE"
        },
        {
            "Code": "31035",
            "County": "Clay",
            "State": "NE"
        },
        {
            "Code": "31037",
            "County": "Colfax",
            "State": "NE"
        },
        {
            "Code": "31039",
            "County": "Cuming",
            "State": "NE"
        },
        {
            "Code": "31041",
            "County": "Custer",
            "State": "NE"
        },
        {
            "Code": "31043",
            "County": "Dakota",
            "State": "NE"
        },
        {
            "Code": "31045",
            "County": "Dawes",
            "State": "NE"
        },
        {
            "Code": "31047",
            "County": "Dawson",
            "State": "NE"
        },
        {
            "Code": "31049",
            "County": "Deuel",
            "State": "NE"
        },
        {
            "Code": "31051",
            "County": "Dixon",
            "State": "NE"
        },
        {
            "Code": "31053",
            "County": "Dodge",
            "State": "NE"
        },
        {
            "Code": "31055",
            "County": "Douglas",
            "State": "NE"
        },
        {
            "Code": "31057",
            "County": "Dundy",
            "State": "NE"
        },
        {
            "Code": "31059",
            "County": "Fillmore",
            "State": "NE"
        },
        {
            "Code": "31061",
            "County": "Franklin",
            "State": "NE"
        },
        {
            "Code": "31063",
            "County": "Frontier",
            "State": "NE"
        },
        {
            "Code": "31065",
            "County": "Furnas",
            "State": "NE"
        },
        {
            "Code": "31067",
            "County": "Gage",
            "State": "NE"
        },
        {
            "Code": "31069",
            "County": "Garden",
            "State": "NE"
        },
        {
            "Code": "31071",
            "County": "Garfield",
            "State": "NE"
        },
        {
            "Code": "31073",
            "County": "Gosper",
            "State": "NE"
        },
        {
            "Code": "31075",
            "County": "Grant",
            "State": "NE"
        },
        {
            "Code": "31077",
            "County": "Greeley",
            "State": "NE"
        },
        {
            "Code": "31079",
            "County": "Hall",
            "State": "NE"
        },
        {
            "Code": "31081",
            "County": "Hamilton",
            "State": "NE"
        },
        {
            "Code": "31083",
            "County": "Harlan",
            "State": "NE"
        },
        {
            "Code": "31085",
            "County": "Hayes",
            "State": "NE"
        },
        {
            "Code": "31087",
            "County": "Hitchcock",
            "State": "NE"
        },
        {
            "Code": "31089",
            "County": "Holt",
            "State": "NE"
        },
        {
            "Code": "31091",
            "County": "Hooker",
            "State": "NE"
        },
        {
            "Code": "31093",
            "County": "Howard",
            "State": "NE"
        },
        {
            "Code": "31095",
            "County": "Jefferson",
            "State": "NE"
        },
        {
            "Code": "31097",
            "County": "Johnson",
            "State": "NE"
        },
        {
            "Code": "31099",
            "County": "Kearney",
            "State": "NE"
        },
        {
            "Code": "31101",
            "County": "Keith",
            "State": "NE"
        },
        {
            "Code": "31103",
            "County": "Keya Paha",
            "State": "NE"
        },
        {
            "Code": "31105",
            "County": "Kimball",
            "State": "NE"
        },
        {
            "Code": "31107",
            "County": "Knox",
            "State": "NE"
        },
        {
            "Code": "31109",
            "County": "Lancaster",
            "State": "NE"
        },
        {
            "Code": "31111",
            "County": "Lincoln",
            "State": "NE"
        },
        {
            "Code": "31113",
            "County": "Logan",
            "State": "NE"
        },
        {
            "Code": "31115",
            "County": "Loup",
            "State": "NE"
        },
        {
            "Code": "31117",
            "County": "McPherson",
            "State": "NE"
        },
        {
            "Code": "31119",
            "County": "Madison",
            "State": "NE"
        },
        {
            "Code": "31121",
            "County": "Merrick",
            "State": "NE"
        },
        {
            "Code": "31123",
            "County": "Morrill",
            "State": "NE"
        },
        {
            "Code": "31125",
            "County": "Nance",
            "State": "NE"
        },
        {
            "Code": "31127",
            "County": "Nemaha",
            "State": "NE"
        },
        {
            "Code": "31129",
            "County": "Nuckolls",
            "State": "NE"
        },
        {
            "Code": "31131",
            "County": "Otoe",
            "State": "NE"
        },
        {
            "Code": "31133",
            "County": "Pawnee",
            "State": "NE"
        },
        {
            "Code": "31135",
            "County": "Perkins",
            "State": "NE"
        },
        {
            "Code": "31137",
            "County": "Phelps",
            "State": "NE"
        },
        {
            "Code": "31139",
            "County": "Pierce",
            "State": "NE"
        },
        {
            "Code": "31141",
            "County": "Platte",
            "State": "NE"
        },
        {
            "Code": "31143",
            "County": "Polk",
            "State": "NE"
        },
        {
            "Code": "31145",
            "County": "Red Willow",
            "State": "NE"
        },
        {
            "Code": "31147",
            "County": "Richardson",
            "State": "NE"
        },
        {
            "Code": "31149",
            "County": "Rock",
            "State": "NE"
        },
        {
            "Code": "31151",
            "County": "Saline",
            "State": "NE"
        },
        {
            "Code": "31153",
            "County": "Sarpy",
            "State": "NE"
        },
        {
            "Code": "31155",
            "County": "Saunders",
            "State": "NE"
        },
        {
            "Code": "31157",
            "County": "Scotts Bluff",
            "State": "NE"
        },
        {
            "Code": "31159",
            "County": "Seward",
            "State": "NE"
        },
        {
            "Code": "31161",
            "County": "Sheridan",
            "State": "NE"
        },
        {
            "Code": "31163",
            "County": "Sherman",
            "State": "NE"
        },
        {
            "Code": "31165",
            "County": "Sioux",
            "State": "NE"
        },
        {
            "Code": "31167",
            "County": "Stanton",
            "State": "NE"
        },
        {
            "Code": "31169",
            "County": "Thayer",
            "State": "NE"
        },
        {
            "Code": "31171",
            "County": "Thomas",
            "State": "NE"
        },
        {
            "Code": "31173",
            "County": "Thurston",
            "State": "NE"
        },
        {
            "Code": "31175",
            "County": "Valley",
            "State": "NE"
        },
        {
            "Code": "31177",
            "County": "Washington",
            "State": "NE"
        },
        {
            "Code": "31179",
            "County": "Wayne",
            "State": "NE"
        },
        {
            "Code": "31181",
            "County": "Webster",
            "State": "NE"
        },
        {
            "Code": "31183",
            "County": "Wheeler",
            "State": "NE"
        },
        {
            "Code": "31185",
            "County": "York",
            "State": "NE"
        },
        {
            "Code": "32001",
            "County": "Churchill",
            "State": "NV"
        },
        {
            "Code": "32003",
            "County": "Clark",
            "State": "NV"
        },
        {
            "Code": "32005",
            "County": "Douglas",
            "State": "NV"
        },
        {
            "Code": "32007",
            "County": "Elko",
            "State": "NV"
        },
        {
            "Code": "32009",
            "County": "Esmeralda",
            "State": "NV"
        },
        {
            "Code": "32011",
            "County": "Eureka",
            "State": "NV"
        },
        {
            "Code": "32013",
            "County": "Humboldt",
            "State": "NV"
        },
        {
            "Code": "32015",
            "County": "Lander",
            "State": "NV"
        },
        {
            "Code": "32017",
            "County": "Lincoln",
            "State": "NV"
        },
        {
            "Code": "32019",
            "County": "Lyon",
            "State": "NV"
        },
        {
            "Code": "32021",
            "County": "Mineral",
            "State": "NV"
        },
        {
            "Code": "32023",
            "County": "Nye",
            "State": "NV"
        },
        {
            "Code": "32027",
            "County": "Pershing",
            "State": "NV"
        },
        {
            "Code": "32029",
            "County": "Storey",
            "State": "NV"
        },
        {
            "Code": "32031",
            "County": "Washoe",
            "State": "NV"
        },
        {
            "Code": "32033",
            "County": "White Pine",
            "State": "NV"
        },
        {
            "Code": "32510",
            "County": "Carson City",
            "State": "NV"
        },
        {
            "Code": "33001",
            "County": "Belknap",
            "State": "NH"
        },
        {
            "Code": "33003",
            "County": "Carroll",
            "State": "NH"
        },
        {
            "Code": "33005",
            "County": "Cheshire",
            "State": "NH"
        },
        {
            "Code": "33007",
            "County": "Coos",
            "State": "NH"
        },
        {
            "Code": "33009",
            "County": "Grafton",
            "State": "NH"
        },
        {
            "Code": "33011",
            "County": "Hillsborough",
            "State": "NH"
        },
        {
            "Code": "33013",
            "County": "Merrimack",
            "State": "NH"
        },
        {
            "Code": "33015",
            "County": "Rockingham",
            "State": "NH"
        },
        {
            "Code": "33017",
            "County": "Strafford",
            "State": "NH"
        },
        {
            "Code": "33019",
            "County": "Sullivan",
            "State": "NH"
        },
        {
            "Code": "34001",
            "County": "Atlantic",
            "State": "NJ"
        },
        {
            "Code": "34003",
            "County": "Bergen",
            "State": "NJ"
        },
        {
            "Code": "34005",
            "County": "Burlington",
            "State": "NJ"
        },
        {
            "Code": "34007",
            "County": "Camden",
            "State": "NJ"
        },
        {
            "Code": "34009",
            "County": "Cape May",
            "State": "NJ"
        },
        {
            "Code": "34011",
            "County": "Cumberland",
            "State": "NJ"
        },
        {
            "Code": "34013",
            "County": "Essex",
            "State": "NJ"
        },
        {
            "Code": "34015",
            "County": "Gloucester",
            "State": "NJ"
        },
        {
            "Code": "34017",
            "County": "Hudson",
            "State": "NJ"
        },
        {
            "Code": "34019",
            "County": "Hunterdon",
            "State": "NJ"
        },
        {
            "Code": "34021",
            "County": "Mercer",
            "State": "NJ"
        },
        {
            "Code": "34023",
            "County": "Middlesex",
            "State": "NJ"
        },
        {
            "Code": "34025",
            "County": "Monmouth",
            "State": "NJ"
        },
        {
            "Code": "34027",
            "County": "Morris",
            "State": "NJ"
        },
        {
            "Code": "34029",
            "County": "Ocean",
            "State": "NJ"
        },
        {
            "Code": "34031",
            "County": "Passaic",
            "State": "NJ"
        },
        {
            "Code": "34033",
            "County": "Salem",
            "State": "NJ"
        },
        {
            "Code": "34035",
            "County": "Somerset",
            "State": "NJ"
        },
        {
            "Code": "34037",
            "County": "Sussex",
            "State": "NJ"
        },
        {
            "Code": "34039",
            "County": "Union",
            "State": "NJ"
        },
        {
            "Code": "34041",
            "County": "Warren",
            "State": "NJ"
        },
        {
            "Code": "35001",
            "County": "Bernalillo",
            "State": "NM"
        },
        {
            "Code": "35003",
            "County": "Catron",
            "State": "NM"
        },
        {
            "Code": "35005",
            "County": "Chaves",
            "State": "NM"
        },
        {
            "Code": "35006",
            "County": "Cibola",
            "State": "NM"
        },
        {
            "Code": "35007",
            "County": "Colfax",
            "State": "NM"
        },
        {
            "Code": "35009",
            "County": "Curry",
            "State": "NM"
        },
        {
            "Code": "35011",
            "County": "De Baca",
            "State": "NM"
        },
        {
            "Code": "35013",
            "County": "Dona Ana",
            "State": "NM"
        },
        {
            "Code": "35015",
            "County": "Eddy",
            "State": "NM"
        },
        {
            "Code": "35017",
            "County": "Grant",
            "State": "NM"
        },
        {
            "Code": "35019",
            "County": "Guadalupe",
            "State": "NM"
        },
        {
            "Code": "35021",
            "County": "Harding",
            "State": "NM"
        },
        {
            "Code": "35023",
            "County": "Hidalgo",
            "State": "NM"
        },
        {
            "Code": "35025",
            "County": "Lea",
            "State": "NM"
        },
        {
            "Code": "35027",
            "County": "Lincoln",
            "State": "NM"
        },
        {
            "Code": "35028",
            "County": "Los Alamos",
            "State": "NM"
        },
        {
            "Code": "35029",
            "County": "Luna",
            "State": "NM"
        },
        {
            "Code": "35031",
            "County": "McKinley",
            "State": "NM"
        },
        {
            "Code": "35033",
            "County": "Mora",
            "State": "NM"
        },
        {
            "Code": "35035",
            "County": "Otero",
            "State": "NM"
        },
        {
            "Code": "35037",
            "County": "Quay",
            "State": "NM"
        },
        {
            "Code": "35039",
            "County": "Rio Arriba",
            "State": "NM"
        },
        {
            "Code": "35041",
            "County": "Roosevelt",
            "State": "NM"
        },
        {
            "Code": "35043",
            "County": "Sandoval",
            "State": "NM"
        },
        {
            "Code": "35045",
            "County": "San Juan",
            "State": "NM"
        },
        {
            "Code": "35047",
            "County": "San Miguel",
            "State": "NM"
        },
        {
            "Code": "35049",
            "County": "Santa Fe",
            "State": "NM"
        },
        {
            "Code": "35051",
            "County": "Sierra",
            "State": "NM"
        },
        {
            "Code": "35053",
            "County": "Socorro",
            "State": "NM"
        },
        {
            "Code": "35055",
            "County": "Taos",
            "State": "NM"
        },
        {
            "Code": "35057",
            "County": "Torrance",
            "State": "NM"
        },
        {
            "Code": "35059",
            "County": "Union",
            "State": "NM"
        },
        {
            "Code": "35061",
            "County": "Valencia",
            "State": "NM"
        },
        {
            "Code": "36001",
            "County": "Albany",
            "State": "NY"
        },
        {
            "Code": "36003",
            "County": "Allegany",
            "State": "NY"
        },
        {
            "Code": "36005",
            "County": "Bronx",
            "State": "NY"
        },
        {
            "Code": "36007",
            "County": "Broome",
            "State": "NY"
        },
        {
            "Code": "36009",
            "County": "Cattaraugus",
            "State": "NY"
        },
        {
            "Code": "36011",
            "County": "Cayuga",
            "State": "NY"
        },
        {
            "Code": "36013",
            "County": "Chautauqua",
            "State": "NY"
        },
        {
            "Code": "36015",
            "County": "Chemung",
            "State": "NY"
        },
        {
            "Code": "36017",
            "County": "Chenango",
            "State": "NY"
        },
        {
            "Code": "36019",
            "County": "Clinton",
            "State": "NY"
        },
        {
            "Code": "36021",
            "County": "Columbia",
            "State": "NY"
        },
        {
            "Code": "36023",
            "County": "Cortland",
            "State": "NY"
        },
        {
            "Code": "36025",
            "County": "Delaware",
            "State": "NY"
        },
        {
            "Code": "36027",
            "County": "Dutchess",
            "State": "NY"
        },
        {
            "Code": "36029",
            "County": "Erie",
            "State": "NY"
        },
        {
            "Code": "36031",
            "County": "Essex",
            "State": "NY"
        },
        {
            "Code": "36033",
            "County": "Franklin",
            "State": "NY"
        },
        {
            "Code": "36035",
            "County": "Fulton",
            "State": "NY"
        },
        {
            "Code": "36037",
            "County": "Genesee",
            "State": "NY"
        },
        {
            "Code": "36039",
            "County": "Greene",
            "State": "NY"
        },
        {
            "Code": "36041",
            "County": "Hamilton",
            "State": "NY"
        },
        {
            "Code": "36043",
            "County": "Herkimer",
            "State": "NY"
        },
        {
            "Code": "36045",
            "County": "Jefferson",
            "State": "NY"
        },
        {
            "Code": "36047",
            "County": "Kings",
            "State": "NY"
        },
        {
            "Code": "36049",
            "County": "Lewis",
            "State": "NY"
        },
        {
            "Code": "36051",
            "County": "Livingston",
            "State": "NY"
        },
        {
            "Code": "36053",
            "County": "Madison",
            "State": "NY"
        },
        {
            "Code": "36055",
            "County": "Monroe",
            "State": "NY"
        },
        {
            "Code": "36057",
            "County": "Montgomery",
            "State": "NY"
        },
        {
            "Code": "36059",
            "County": "Nassau",
            "State": "NY"
        },
        {
            "Code": "36061",
            "County": "New York",
            "State": "NY"
        },
        {
            "Code": "36063",
            "County": "Niagara",
            "State": "NY"
        },
        {
            "Code": "36065",
            "County": "Oneida",
            "State": "NY"
        },
        {
            "Code": "36067",
            "County": "Onondaga",
            "State": "NY"
        },
        {
            "Code": "36069",
            "County": "Ontario",
            "State": "NY"
        },
        {
            "Code": "36071",
            "County": "Orange",
            "State": "NY"
        },
        {
            "Code": "36073",
            "County": "Orleans",
            "State": "NY"
        },
        {
            "Code": "36075",
            "County": "Oswego",
            "State": "NY"
        },
        {
            "Code": "36077",
            "County": "Otsego",
            "State": "NY"
        },
        {
            "Code": "36079",
            "County": "Putnam",
            "State": "NY"
        },
        {
            "Code": "36081",
            "County": "Queens",
            "State": "NY"
        },
        {
            "Code": "36083",
            "County": "Rensselaer",
            "State": "NY"
        },
        {
            "Code": "36085",
            "County": "Richmond",
            "State": "NY"
        },
        {
            "Code": "36087",
            "County": "Rockland",
            "State": "NY"
        },
        {
            "Code": "36089",
            "County": "St Lawrence",
            "State": "NY"
        },
        {
            "Code": "36091",
            "County": "Saratoga",
            "State": "NY"
        },
        {
            "Code": "36093",
            "County": "Schenectady",
            "State": "NY"
        },
        {
            "Code": "36095",
            "County": "Schoharie",
            "State": "NY"
        },
        {
            "Code": "36097",
            "County": "Schuyler",
            "State": "NY"
        },
        {
            "Code": "36099",
            "County": "Seneca",
            "State": "NY"
        },
        {
            "Code": "36101",
            "County": "Steuben",
            "State": "NY"
        },
        {
            "Code": "36103",
            "County": "Suffolk",
            "State": "NY"
        },
        {
            "Code": "36105",
            "County": "Sullivan",
            "State": "NY"
        },
        {
            "Code": "36107",
            "County": "Tioga",
            "State": "NY"
        },
        {
            "Code": "36109",
            "County": "Tompkins",
            "State": "NY"
        },
        {
            "Code": "36111",
            "County": "Ulster",
            "State": "NY"
        },
        {
            "Code": "36113",
            "County": "Warren",
            "State": "NY"
        },
        {
            "Code": "36115",
            "County": "Washington",
            "State": "NY"
        },
        {
            "Code": "36117",
            "County": "Wayne",
            "State": "NY"
        },
        {
            "Code": "36119",
            "County": "Westchester",
            "State": "NY"
        },
        {
            "Code": "36121",
            "County": "Wyoming",
            "State": "NY"
        },
        {
            "Code": "36123",
            "County": "Yates",
            "State": "NY"
        },
        {
            "Code": "37001",
            "County": "Alamance",
            "State": "NC"
        },
        {
            "Code": "37003",
            "County": "Alexander",
            "State": "NC"
        },
        {
            "Code": "37005",
            "County": "Alleghany",
            "State": "NC"
        },
        {
            "Code": "37007",
            "County": "Anson",
            "State": "NC"
        },
        {
            "Code": "37009",
            "County": "Ashe",
            "State": "NC"
        },
        {
            "Code": "37011",
            "County": "Avery",
            "State": "NC"
        },
        {
            "Code": "37013",
            "County": "Beaufort",
            "State": "NC"
        },
        {
            "Code": "37015",
            "County": "Bertie",
            "State": "NC"
        },
        {
            "Code": "37017",
            "County": "Bladen",
            "State": "NC"
        },
        {
            "Code": "37019",
            "County": "Brunswick",
            "State": "NC"
        },
        {
            "Code": "37021",
            "County": "Buncombe",
            "State": "NC"
        },
        {
            "Code": "37023",
            "County": "Burke",
            "State": "NC"
        },
        {
            "Code": "37025",
            "County": "Cabarrus",
            "State": "NC"
        },
        {
            "Code": "37027",
            "County": "Caldwell",
            "State": "NC"
        },
        {
            "Code": "37029",
            "County": "Camden",
            "State": "NC"
        },
        {
            "Code": "37031",
            "County": "Carteret",
            "State": "NC"
        },
        {
            "Code": "37033",
            "County": "Caswell",
            "State": "NC"
        },
        {
            "Code": "37035",
            "County": "Catawba",
            "State": "NC"
        },
        {
            "Code": "37037",
            "County": "Chatham",
            "State": "NC"
        },
        {
            "Code": "37039",
            "County": "Cherokee",
            "State": "NC"
        },
        {
            "Code": "37041",
            "County": "Chowan",
            "State": "NC"
        },
        {
            "Code": "37043",
            "County": "Clay",
            "State": "NC"
        },
        {
            "Code": "37045",
            "County": "Cleveland",
            "State": "NC"
        },
        {
            "Code": "37047",
            "County": "Columbus",
            "State": "NC"
        },
        {
            "Code": "37049",
            "County": "Craven",
            "State": "NC"
        },
        {
            "Code": "37051",
            "County": "Cumberland",
            "State": "NC"
        },
        {
            "Code": "37053",
            "County": "Currituck",
            "State": "NC"
        },
        {
            "Code": "37055",
            "County": "Dare",
            "State": "NC"
        },
        {
            "Code": "37057",
            "County": "Davidson",
            "State": "NC"
        },
        {
            "Code": "37059",
            "County": "Davie",
            "State": "NC"
        },
        {
            "Code": "37061",
            "County": "Duplin",
            "State": "NC"
        },
        {
            "Code": "37063",
            "County": "Durham",
            "State": "NC"
        },
        {
            "Code": "37065",
            "County": "Edgecombe",
            "State": "NC"
        },
        {
            "Code": "37067",
            "County": "Forsyth",
            "State": "NC"
        },
        {
            "Code": "37069",
            "County": "Franklin",
            "State": "NC"
        },
        {
            "Code": "37071",
            "County": "Gaston",
            "State": "NC"
        },
        {
            "Code": "37073",
            "County": "Gates",
            "State": "NC"
        },
        {
            "Code": "37075",
            "County": "Graham",
            "State": "NC"
        },
        {
            "Code": "37077",
            "County": "Granville",
            "State": "NC"
        },
        {
            "Code": "37079",
            "County": "Greene",
            "State": "NC"
        },
        {
            "Code": "37081",
            "County": "Guilford",
            "State": "NC"
        },
        {
            "Code": "37083",
            "County": "Halifax",
            "State": "NC"
        },
        {
            "Code": "37085",
            "County": "Harnett",
            "State": "NC"
        },
        {
            "Code": "37087",
            "County": "Haywood",
            "State": "NC"
        },
        {
            "Code": "37089",
            "County": "Henderson",
            "State": "NC"
        },
        {
            "Code": "37091",
            "County": "Hertford",
            "State": "NC"
        },
        {
            "Code": "37093",
            "County": "Hoke",
            "State": "NC"
        },
        {
            "Code": "37095",
            "County": "Hyde",
            "State": "NC"
        },
        {
            "Code": "37097",
            "County": "Iredell",
            "State": "NC"
        },
        {
            "Code": "37099",
            "County": "Jackson",
            "State": "NC"
        },
        {
            "Code": "37101",
            "County": "Johnston",
            "State": "NC"
        },
        {
            "Code": "37103",
            "County": "Jones",
            "State": "NC"
        },
        {
            "Code": "37105",
            "County": "Lee",
            "State": "NC"
        },
        {
            "Code": "37107",
            "County": "Lenoir",
            "State": "NC"
        },
        {
            "Code": "37109",
            "County": "Lincoln",
            "State": "NC"
        },
        {
            "Code": "37111",
            "County": "McDowell",
            "State": "NC"
        },
        {
            "Code": "37113",
            "County": "Macon",
            "State": "NC"
        },
        {
            "Code": "37115",
            "County": "Madison",
            "State": "NC"
        },
        {
            "Code": "37117",
            "County": "Martin",
            "State": "NC"
        },
        {
            "Code": "37119",
            "County": "Mecklenburg",
            "State": "NC"
        },
        {
            "Code": "37121",
            "County": "Mitchell",
            "State": "NC"
        },
        {
            "Code": "37123",
            "County": "Montgomery",
            "State": "NC"
        },
        {
            "Code": "37125",
            "County": "Moore",
            "State": "NC"
        },
        {
            "Code": "37127",
            "County": "Nash",
            "State": "NC"
        },
        {
            "Code": "37129",
            "County": "New Hanover",
            "State": "NC"
        },
        {
            "Code": "37131",
            "County": "Northampton",
            "State": "NC"
        },
        {
            "Code": "37133",
            "County": "Onslow",
            "State": "NC"
        },
        {
            "Code": "37135",
            "County": "Orange",
            "State": "NC"
        },
        {
            "Code": "37137",
            "County": "Pamlico",
            "State": "NC"
        },
        {
            "Code": "37139",
            "County": "Pasquotank",
            "State": "NC"
        },
        {
            "Code": "37141",
            "County": "Pender",
            "State": "NC"
        },
        {
            "Code": "37143",
            "County": "Perquimans",
            "State": "NC"
        },
        {
            "Code": "37145",
            "County": "Person",
            "State": "NC"
        },
        {
            "Code": "37147",
            "County": "Pitt",
            "State": "NC"
        },
        {
            "Code": "37149",
            "County": "Polk",
            "State": "NC"
        },
        {
            "Code": "37151",
            "County": "Randolph",
            "State": "NC"
        },
        {
            "Code": "37153",
            "County": "Richmond",
            "State": "NC"
        },
        {
            "Code": "37155",
            "County": "Robeson",
            "State": "NC"
        },
        {
            "Code": "37157",
            "County": "Rockingham",
            "State": "NC"
        },
        {
            "Code": "37159",
            "County": "Rowan",
            "State": "NC"
        },
        {
            "Code": "37161",
            "County": "Rutherford",
            "State": "NC"
        },
        {
            "Code": "37163",
            "County": "Sampson",
            "State": "NC"
        },
        {
            "Code": "37165",
            "County": "Scotland",
            "State": "NC"
        },
        {
            "Code": "37167",
            "County": "Stanly",
            "State": "NC"
        },
        {
            "Code": "37169",
            "County": "Stokes",
            "State": "NC"
        },
        {
            "Code": "37171",
            "County": "Surry",
            "State": "NC"
        },
        {
            "Code": "37173",
            "County": "Swain",
            "State": "NC"
        },
        {
            "Code": "37175",
            "County": "Transylvania",
            "State": "NC"
        },
        {
            "Code": "37177",
            "County": "Tyrrell",
            "State": "NC"
        },
        {
            "Code": "37179",
            "County": "Union",
            "State": "NC"
        },
        {
            "Code": "37181",
            "County": "Vance",
            "State": "NC"
        },
        {
            "Code": "37183",
            "County": "Wake",
            "State": "NC"
        },
        {
            "Code": "37185",
            "County": "Warren",
            "State": "NC"
        },
        {
            "Code": "37187",
            "County": "Washington",
            "State": "NC"
        },
        {
            "Code": "37189",
            "County": "Watauga",
            "State": "NC"
        },
        {
            "Code": "37191",
            "County": "Wayne",
            "State": "NC"
        },
        {
            "Code": "37193",
            "County": "Wilkes",
            "State": "NC"
        },
        {
            "Code": "37195",
            "County": "Wilson",
            "State": "NC"
        },
        {
            "Code": "37197",
            "County": "Yadkin",
            "State": "NC"
        },
        {
            "Code": "37199",
            "County": "Yancey",
            "State": "NC"
        },
        {
            "Code": "38001",
            "County": "Adams",
            "State": "ND"
        },
        {
            "Code": "38003",
            "County": "Barnes",
            "State": "ND"
        },
        {
            "Code": "38005",
            "County": "Benson",
            "State": "ND"
        },
        {
            "Code": "38007",
            "County": "Billings",
            "State": "ND"
        },
        {
            "Code": "38009",
            "County": "Bottineau",
            "State": "ND"
        },
        {
            "Code": "38011",
            "County": "Bowman",
            "State": "ND"
        },
        {
            "Code": "38013",
            "County": "Burke",
            "State": "ND"
        },
        {
            "Code": "38015",
            "County": "Burleigh",
            "State": "ND"
        },
        {
            "Code": "38017",
            "County": "Cass",
            "State": "ND"
        },
        {
            "Code": "38019",
            "County": "Cavalier",
            "State": "ND"
        },
        {
            "Code": "38021",
            "County": "Dickey",
            "State": "ND"
        },
        {
            "Code": "38023",
            "County": "Divide",
            "State": "ND"
        },
        {
            "Code": "38025",
            "County": "Dunn",
            "State": "ND"
        },
        {
            "Code": "38027",
            "County": "Eddy",
            "State": "ND"
        },
        {
            "Code": "38029",
            "County": "Emmons",
            "State": "ND"
        },
        {
            "Code": "38031",
            "County": "Foster",
            "State": "ND"
        },
        {
            "Code": "38033",
            "County": "Golden Valley",
            "State": "ND"
        },
        {
            "Code": "38035",
            "County": "Grand Forks",
            "State": "ND"
        },
        {
            "Code": "38037",
            "County": "Grant",
            "State": "ND"
        },
        {
            "Code": "38039",
            "County": "Griggs",
            "State": "ND"
        },
        {
            "Code": "38041",
            "County": "Hettinger",
            "State": "ND"
        },
        {
            "Code": "38043",
            "County": "Kidder",
            "State": "ND"
        },
        {
            "Code": "38045",
            "County": "La Moure",
            "State": "ND"
        },
        {
            "Code": "38047",
            "County": "Logan",
            "State": "ND"
        },
        {
            "Code": "38049",
            "County": "McHenry",
            "State": "ND"
        },
        {
            "Code": "38051",
            "County": "McIntosh",
            "State": "ND"
        },
        {
            "Code": "38053",
            "County": "McKenzie",
            "State": "ND"
        },
        {
            "Code": "38055",
            "County": "McLean",
            "State": "ND"
        },
        {
            "Code": "38057",
            "County": "Mercer",
            "State": "ND"
        },
        {
            "Code": "38059",
            "County": "Morton",
            "State": "ND"
        },
        {
            "Code": "38061",
            "County": "Mountrail",
            "State": "ND"
        },
        {
            "Code": "38063",
            "County": "Nelson",
            "State": "ND"
        },
        {
            "Code": "38065",
            "County": "Oliver",
            "State": "ND"
        },
        {
            "Code": "38067",
            "County": "Pembina",
            "State": "ND"
        },
        {
            "Code": "38069",
            "County": "Pierce",
            "State": "ND"
        },
        {
            "Code": "38071",
            "County": "Ramsey",
            "State": "ND"
        },
        {
            "Code": "38073",
            "County": "Ransom",
            "State": "ND"
        },
        {
            "Code": "38075",
            "County": "Renville",
            "State": "ND"
        },
        {
            "Code": "38077",
            "County": "Richland",
            "State": "ND"
        },
        {
            "Code": "38079",
            "County": "Rolette",
            "State": "ND"
        },
        {
            "Code": "38081",
            "County": "Sargent",
            "State": "ND"
        },
        {
            "Code": "38083",
            "County": "Sheridan",
            "State": "ND"
        },
        {
            "Code": "38085",
            "County": "Sioux",
            "State": "ND"
        },
        {
            "Code": "38087",
            "County": "Slope",
            "State": "ND"
        },
        {
            "Code": "38089",
            "County": "Stark",
            "State": "ND"
        },
        {
            "Code": "38091",
            "County": "Steele",
            "State": "ND"
        },
        {
            "Code": "38093",
            "County": "Stutsman",
            "State": "ND"
        },
        {
            "Code": "38095",
            "County": "Towner",
            "State": "ND"
        },
        {
            "Code": "38097",
            "County": "Traill",
            "State": "ND"
        },
        {
            "Code": "38099",
            "County": "Walsh",
            "State": "ND"
        },
        {
            "Code": "38101",
            "County": "Ward",
            "State": "ND"
        },
        {
            "Code": "38103",
            "County": "Wells",
            "State": "ND"
        },
        {
            "Code": "38105",
            "County": "Williams",
            "State": "ND"
        },
        {
            "Code": "39001",
            "County": "Adams",
            "State": "OH"
        },
        {
            "Code": "39003",
            "County": "Allen",
            "State": "OH"
        },
        {
            "Code": "39005",
            "County": "Ashland",
            "State": "OH"
        },
        {
            "Code": "39007",
            "County": "Ashtabula",
            "State": "OH"
        },
        {
            "Code": "39009",
            "County": "Athens",
            "State": "OH"
        },
        {
            "Code": "39011",
            "County": "Auglaize",
            "State": "OH"
        },
        {
            "Code": "39013",
            "County": "Belmont",
            "State": "OH"
        },
        {
            "Code": "39015",
            "County": "Brown",
            "State": "OH"
        },
        {
            "Code": "39017",
            "County": "Butler",
            "State": "OH"
        },
        {
            "Code": "39019",
            "County": "Carroll",
            "State": "OH"
        },
        {
            "Code": "39021",
            "County": "Champaign",
            "State": "OH"
        },
        {
            "Code": "39023",
            "County": "Clark",
            "State": "OH"
        },
        {
            "Code": "39025",
            "County": "Clermont",
            "State": "OH"
        },
        {
            "Code": "39027",
            "County": "Clinton",
            "State": "OH"
        },
        {
            "Code": "39029",
            "County": "Columbiana",
            "State": "OH"
        },
        {
            "Code": "39031",
            "County": "Coshocton",
            "State": "OH"
        },
        {
            "Code": "39033",
            "County": "Crawford",
            "State": "OH"
        },
        {
            "Code": "39035",
            "County": "Cuyahoga",
            "State": "OH"
        },
        {
            "Code": "39037",
            "County": "Darke",
            "State": "OH"
        },
        {
            "Code": "39039",
            "County": "Defiance",
            "State": "OH"
        },
        {
            "Code": "39041",
            "County": "Delaware",
            "State": "OH"
        },
        {
            "Code": "39043",
            "County": "Erie",
            "State": "OH"
        },
        {
            "Code": "39045",
            "County": "Fairfield",
            "State": "OH"
        },
        {
            "Code": "39047",
            "County": "Fayette",
            "State": "OH"
        },
        {
            "Code": "39049",
            "County": "Franklin",
            "State": "OH"
        },
        {
            "Code": "39051",
            "County": "Fulton",
            "State": "OH"
        },
        {
            "Code": "39053",
            "County": "Gallia",
            "State": "OH"
        },
        {
            "Code": "39055",
            "County": "Geauga",
            "State": "OH"
        },
        {
            "Code": "39057",
            "County": "Greene",
            "State": "OH"
        },
        {
            "Code": "39059",
            "County": "Guernsey",
            "State": "OH"
        },
        {
            "Code": "39061",
            "County": "Hamilton",
            "State": "OH"
        },
        {
            "Code": "39063",
            "County": "Hancock",
            "State": "OH"
        },
        {
            "Code": "39065",
            "County": "Hardin",
            "State": "OH"
        },
        {
            "Code": "39067",
            "County": "Harrison",
            "State": "OH"
        },
        {
            "Code": "39069",
            "County": "Henry",
            "State": "OH"
        },
        {
            "Code": "39071",
            "County": "Highland",
            "State": "OH"
        },
        {
            "Code": "39073",
            "County": "Hocking",
            "State": "OH"
        },
        {
            "Code": "39075",
            "County": "Holmes",
            "State": "OH"
        },
        {
            "Code": "39077",
            "County": "Huron",
            "State": "OH"
        },
        {
            "Code": "39079",
            "County": "Jackson",
            "State": "OH"
        },
        {
            "Code": "39081",
            "County": "Jefferson",
            "State": "OH"
        },
        {
            "Code": "39083",
            "County": "Knox",
            "State": "OH"
        },
        {
            "Code": "39085",
            "County": "Lake",
            "State": "OH"
        },
        {
            "Code": "39087",
            "County": "Lawrence",
            "State": "OH"
        },
        {
            "Code": "39089",
            "County": "Licking",
            "State": "OH"
        },
        {
            "Code": "39091",
            "County": "Logan",
            "State": "OH"
        },
        {
            "Code": "39093",
            "County": "Lorain",
            "State": "OH"
        },
        {
            "Code": "39095",
            "County": "Lucas",
            "State": "OH"
        },
        {
            "Code": "39097",
            "County": "Madison",
            "State": "OH"
        },
        {
            "Code": "39099",
            "County": "Mahoning",
            "State": "OH"
        },
        {
            "Code": "39101",
            "County": "Marion",
            "State": "OH"
        },
        {
            "Code": "39103",
            "County": "Medina",
            "State": "OH"
        },
        {
            "Code": "39105",
            "County": "Meigs",
            "State": "OH"
        },
        {
            "Code": "39107",
            "County": "Mercer",
            "State": "OH"
        },
        {
            "Code": "39109",
            "County": "Miami",
            "State": "OH"
        },
        {
            "Code": "39111",
            "County": "Monroe",
            "State": "OH"
        },
        {
            "Code": "39113",
            "County": "Montgomery",
            "State": "OH"
        },
        {
            "Code": "39115",
            "County": "Morgan",
            "State": "OH"
        },
        {
            "Code": "39117",
            "County": "Morrow",
            "State": "OH"
        },
        {
            "Code": "39119",
            "County": "Muskingum",
            "State": "OH"
        },
        {
            "Code": "39121",
            "County": "Noble",
            "State": "OH"
        },
        {
            "Code": "39123",
            "County": "Ottawa",
            "State": "OH"
        },
        {
            "Code": "39125",
            "County": "Paulding",
            "State": "OH"
        },
        {
            "Code": "39127",
            "County": "Perry",
            "State": "OH"
        },
        {
            "Code": "39129",
            "County": "Pickaway",
            "State": "OH"
        },
        {
            "Code": "39131",
            "County": "Pike",
            "State": "OH"
        },
        {
            "Code": "39133",
            "County": "Portage",
            "State": "OH"
        },
        {
            "Code": "39135",
            "County": "Preble",
            "State": "OH"
        },
        {
            "Code": "39137",
            "County": "Putnam",
            "State": "OH"
        },
        {
            "Code": "39139",
            "County": "Richland",
            "State": "OH"
        },
        {
            "Code": "39141",
            "County": "Ross",
            "State": "OH"
        },
        {
            "Code": "39143",
            "County": "Sandusky",
            "State": "OH"
        },
        {
            "Code": "39145",
            "County": "Scioto",
            "State": "OH"
        },
        {
            "Code": "39147",
            "County": "Seneca",
            "State": "OH"
        },
        {
            "Code": "39149",
            "County": "Shelby",
            "State": "OH"
        },
        {
            "Code": "39151",
            "County": "Stark",
            "State": "OH"
        },
        {
            "Code": "39153",
            "County": "Summit",
            "State": "OH"
        },
        {
            "Code": "39155",
            "County": "Trumbull",
            "State": "OH"
        },
        {
            "Code": "39157",
            "County": "Tuscarawas",
            "State": "OH"
        },
        {
            "Code": "39159",
            "County": "Union",
            "State": "OH"
        },
        {
            "Code": "39161",
            "County": "Van Wert",
            "State": "OH"
        },
        {
            "Code": "39163",
            "County": "Vinton",
            "State": "OH"
        },
        {
            "Code": "39165",
            "County": "Warren",
            "State": "OH"
        },
        {
            "Code": "39167",
            "County": "Washington",
            "State": "OH"
        },
        {
            "Code": "39169",
            "County": "Wayne",
            "State": "OH"
        },
        {
            "Code": "39171",
            "County": "Williams",
            "State": "OH"
        },
        {
            "Code": "39173",
            "County": "Wood",
            "State": "OH"
        },
        {
            "Code": "39175",
            "County": "Wyandot",
            "State": "OH"
        },
        {
            "Code": "40001",
            "County": "Adair",
            "State": "OK"
        },
        {
            "Code": "40003",
            "County": "Alfalfa",
            "State": "OK"
        },
        {
            "Code": "40005",
            "County": "Atoka",
            "State": "OK"
        },
        {
            "Code": "40007",
            "County": "Beaver",
            "State": "OK"
        },
        {
            "Code": "40009",
            "County": "Beckham",
            "State": "OK"
        },
        {
            "Code": "40011",
            "County": "Blaine",
            "State": "OK"
        },
        {
            "Code": "40013",
            "County": "Bryan",
            "State": "OK"
        },
        {
            "Code": "40015",
            "County": "Caddo",
            "State": "OK"
        },
        {
            "Code": "40017",
            "County": "Canadian",
            "State": "OK"
        },
        {
            "Code": "40019",
            "County": "Carter",
            "State": "OK"
        },
        {
            "Code": "40021",
            "County": "Cherokee",
            "State": "OK"
        },
        {
            "Code": "40023",
            "County": "Choctaw",
            "State": "OK"
        },
        {
            "Code": "40025",
            "County": "Cimarron",
            "State": "OK"
        },
        {
            "Code": "40027",
            "County": "Cleveland",
            "State": "OK"
        },
        {
            "Code": "40029",
            "County": "Coal",
            "State": "OK"
        },
        {
            "Code": "40031",
            "County": "Comanche",
            "State": "OK"
        },
        {
            "Code": "40033",
            "County": "Cotton",
            "State": "OK"
        },
        {
            "Code": "40035",
            "County": "Craig",
            "State": "OK"
        },
        {
            "Code": "40037",
            "County": "Creek",
            "State": "OK"
        },
        {
            "Code": "40039",
            "County": "Custer",
            "State": "OK"
        },
        {
            "Code": "40041",
            "County": "Delaware",
            "State": "OK"
        },
        {
            "Code": "40043",
            "County": "Dewey",
            "State": "OK"
        },
        {
            "Code": "40045",
            "County": "Ellis",
            "State": "OK"
        },
        {
            "Code": "40047",
            "County": "Garfield",
            "State": "OK"
        },
        {
            "Code": "40049",
            "County": "Garvin",
            "State": "OK"
        },
        {
            "Code": "40051",
            "County": "Grady",
            "State": "OK"
        },
        {
            "Code": "40053",
            "County": "Grant",
            "State": "OK"
        },
        {
            "Code": "40055",
            "County": "Greer",
            "State": "OK"
        },
        {
            "Code": "40057",
            "County": "Harmon",
            "State": "OK"
        },
        {
            "Code": "40059",
            "County": "Harper",
            "State": "OK"
        },
        {
            "Code": "40061",
            "County": "Haskell",
            "State": "OK"
        },
        {
            "Code": "40063",
            "County": "Hughes",
            "State": "OK"
        },
        {
            "Code": "40065",
            "County": "Jackson",
            "State": "OK"
        },
        {
            "Code": "40067",
            "County": "Jefferson",
            "State": "OK"
        },
        {
            "Code": "40069",
            "County": "Johnston",
            "State": "OK"
        },
        {
            "Code": "40071",
            "County": "Kay",
            "State": "OK"
        },
        {
            "Code": "40073",
            "County": "Kingfisher",
            "State": "OK"
        },
        {
            "Code": "40075",
            "County": "Kiowa",
            "State": "OK"
        },
        {
            "Code": "40077",
            "County": "Latimer",
            "State": "OK"
        },
        {
            "Code": "40079",
            "County": "Le Flore",
            "State": "OK"
        },
        {
            "Code": "40081",
            "County": "Lincoln",
            "State": "OK"
        },
        {
            "Code": "40083",
            "County": "Logan",
            "State": "OK"
        },
        {
            "Code": "40085",
            "County": "Love",
            "State": "OK"
        },
        {
            "Code": "40087",
            "County": "McClain",
            "State": "OK"
        },
        {
            "Code": "40089",
            "County": "McCurtain",
            "State": "OK"
        },
        {
            "Code": "40091",
            "County": "McIntosh",
            "State": "OK"
        },
        {
            "Code": "40093",
            "County": "Major",
            "State": "OK"
        },
        {
            "Code": "40095",
            "County": "Marshall",
            "State": "OK"
        },
        {
            "Code": "40097",
            "County": "Mayes",
            "State": "OK"
        },
        {
            "Code": "40099",
            "County": "Murray",
            "State": "OK"
        },
        {
            "Code": "40101",
            "County": "Muskogee",
            "State": "OK"
        },
        {
            "Code": "40103",
            "County": "Noble",
            "State": "OK"
        },
        {
            "Code": "40105",
            "County": "Nowata",
            "State": "OK"
        },
        {
            "Code": "40107",
            "County": "Okfuskee",
            "State": "OK"
        },
        {
            "Code": "40109",
            "County": "Oklahoma",
            "State": "OK"
        },
        {
            "Code": "40111",
            "County": "Okmulgee",
            "State": "OK"
        },
        {
            "Code": "40113",
            "County": "Osage",
            "State": "OK"
        },
        {
            "Code": "40115",
            "County": "Ottawa",
            "State": "OK"
        },
        {
            "Code": "40117",
            "County": "Pawnee",
            "State": "OK"
        },
        {
            "Code": "40119",
            "County": "Payne",
            "State": "OK"
        },
        {
            "Code": "40121",
            "County": "Pittsburg",
            "State": "OK"
        },
        {
            "Code": "40123",
            "County": "Pontotoc",
            "State": "OK"
        },
        {
            "Code": "40125",
            "County": "Pottawatomie",
            "State": "OK"
        },
        {
            "Code": "40127",
            "County": "Pushmataha",
            "State": "OK"
        },
        {
            "Code": "40129",
            "County": "Roger Mills",
            "State": "OK"
        },
        {
            "Code": "40131",
            "County": "Rogers",
            "State": "OK"
        },
        {
            "Code": "40133",
            "County": "Seminole",
            "State": "OK"
        },
        {
            "Code": "40135",
            "County": "Sequoyah",
            "State": "OK"
        },
        {
            "Code": "40137",
            "County": "Stephens",
            "State": "OK"
        },
        {
            "Code": "40139",
            "County": "Texas",
            "State": "OK"
        },
        {
            "Code": "40141",
            "County": "Tillman",
            "State": "OK"
        },
        {
            "Code": "40143",
            "County": "Tulsa",
            "State": "OK"
        },
        {
            "Code": "40145",
            "County": "Wagoner",
            "State": "OK"
        },
        {
            "Code": "40147",
            "County": "Washington",
            "State": "OK"
        },
        {
            "Code": "40149",
            "County": "Washita",
            "State": "OK"
        },
        {
            "Code": "40151",
            "County": "Woods",
            "State": "OK"
        },
        {
            "Code": "40153",
            "County": "Woodward",
            "State": "OK"
        },
        {
            "Code": "41001",
            "County": "Baker",
            "State": "OR"
        },
        {
            "Code": "41003",
            "County": "Benton",
            "State": "OR"
        },
        {
            "Code": "41005",
            "County": "Clackamas",
            "State": "OR"
        },
        {
            "Code": "41007",
            "County": "Clatsop",
            "State": "OR"
        },
        {
            "Code": "41009",
            "County": "Columbia",
            "State": "OR"
        },
        {
            "Code": "41011",
            "County": "Coos",
            "State": "OR"
        },
        {
            "Code": "41013",
            "County": "Crook",
            "State": "OR"
        },
        {
            "Code": "41015",
            "County": "Curry",
            "State": "OR"
        },
        {
            "Code": "41017",
            "County": "Deschutes",
            "State": "OR"
        },
        {
            "Code": "41019",
            "County": "Douglas",
            "State": "OR"
        },
        {
            "Code": "41021",
            "County": "Gilliam",
            "State": "OR"
        },
        {
            "Code": "41023",
            "County": "Grant",
            "State": "OR"
        },
        {
            "Code": "41025",
            "County": "Harney",
            "State": "OR"
        },
        {
            "Code": "41027",
            "County": "Hood River",
            "State": "OR"
        },
        {
            "Code": "41029",
            "County": "Jackson",
            "State": "OR"
        },
        {
            "Code": "41031",
            "County": "Jefferson",
            "State": "OR"
        },
        {
            "Code": "41033",
            "County": "Josephine",
            "State": "OR"
        },
        {
            "Code": "41035",
            "County": "Klamath",
            "State": "OR"
        },
        {
            "Code": "41037",
            "County": "Lake",
            "State": "OR"
        },
        {
            "Code": "41039",
            "County": "Lane",
            "State": "OR"
        },
        {
            "Code": "41041",
            "County": "Lincoln",
            "State": "OR"
        },
        {
            "Code": "41043",
            "County": "Linn",
            "State": "OR"
        },
        {
            "Code": "41045",
            "County": "Malheur",
            "State": "OR"
        },
        {
            "Code": "41047",
            "County": "Marion",
            "State": "OR"
        },
        {
            "Code": "41049",
            "County": "Morrow",
            "State": "OR"
        },
        {
            "Code": "41051",
            "County": "Multnomah",
            "State": "OR"
        },
        {
            "Code": "41053",
            "County": "Polk",
            "State": "OR"
        },
        {
            "Code": "41055",
            "County": "Sherman",
            "State": "OR"
        },
        {
            "Code": "41057",
            "County": "Tillamook",
            "State": "OR"
        },
        {
            "Code": "41059",
            "County": "Umatilla",
            "State": "OR"
        },
        {
            "Code": "41061",
            "County": "Union",
            "State": "OR"
        },
        {
            "Code": "41063",
            "County": "Wallowa",
            "State": "OR"
        },
        {
            "Code": "41065",
            "County": "Wasco",
            "State": "OR"
        },
        {
            "Code": "41067",
            "County": "Washington",
            "State": "OR"
        },
        {
            "Code": "41069",
            "County": "Wheeler",
            "State": "OR"
        },
        {
            "Code": "41071",
            "County": "Yamhill",
            "State": "OR"
        },
        {
            "Code": "42001",
            "County": "Adams",
            "State": "PA"
        },
        {
            "Code": "42003",
            "County": "Allegheny",
            "State": "PA"
        },
        {
            "Code": "42005",
            "County": "Armstrong",
            "State": "PA"
        },
        {
            "Code": "42007",
            "County": "Beaver",
            "State": "PA"
        },
        {
            "Code": "42009",
            "County": "Bedford",
            "State": "PA"
        },
        {
            "Code": "42011",
            "County": "Berks",
            "State": "PA"
        },
        {
            "Code": "42013",
            "County": "Blair",
            "State": "PA"
        },
        {
            "Code": "42015",
            "County": "Bradford",
            "State": "PA"
        },
        {
            "Code": "42017",
            "County": "Bucks",
            "State": "PA"
        },
        {
            "Code": "42019",
            "County": "Butler",
            "State": "PA"
        },
        {
            "Code": "42021",
            "County": "Cambria",
            "State": "PA"
        },
        {
            "Code": "42023",
            "County": "Cameron",
            "State": "PA"
        },
        {
            "Code": "42025",
            "County": "Carbon",
            "State": "PA"
        },
        {
            "Code": "42027",
            "County": "Centre",
            "State": "PA"
        },
        {
            "Code": "42029",
            "County": "Chester",
            "State": "PA"
        },
        {
            "Code": "42031",
            "County": "Clarion",
            "State": "PA"
        },
        {
            "Code": "42033",
            "County": "Clearfield",
            "State": "PA"
        },
        {
            "Code": "42035",
            "County": "Clinton",
            "State": "PA"
        },
        {
            "Code": "42037",
            "County": "Columbia",
            "State": "PA"
        },
        {
            "Code": "42039",
            "County": "Crawford",
            "State": "PA"
        },
        {
            "Code": "42041",
            "County": "Cumberland",
            "State": "PA"
        },
        {
            "Code": "42043",
            "County": "Dauphin",
            "State": "PA"
        },
        {
            "Code": "42045",
            "County": "Delaware",
            "State": "PA"
        },
        {
            "Code": "42047",
            "County": "Elk",
            "State": "PA"
        },
        {
            "Code": "42049",
            "County": "Erie",
            "State": "PA"
        },
        {
            "Code": "42051",
            "County": "Fayette",
            "State": "PA"
        },
        {
            "Code": "42053",
            "County": "Forest",
            "State": "PA"
        },
        {
            "Code": "42055",
            "County": "Franklin",
            "State": "PA"
        },
        {
            "Code": "42057",
            "County": "Fulton",
            "State": "PA"
        },
        {
            "Code": "42059",
            "County": "Greene",
            "State": "PA"
        },
        {
            "Code": "42061",
            "County": "Huntingdon",
            "State": "PA"
        },
        {
            "Code": "42063",
            "County": "Indiana",
            "State": "PA"
        },
        {
            "Code": "42065",
            "County": "Jefferson",
            "State": "PA"
        },
        {
            "Code": "42067",
            "County": "Juniata",
            "State": "PA"
        },
        {
            "Code": "42069",
            "County": "Lackawanna",
            "State": "PA"
        },
        {
            "Code": "42071",
            "County": "Lancaster",
            "State": "PA"
        },
        {
            "Code": "42073",
            "County": "Lawrence",
            "State": "PA"
        },
        {
            "Code": "42075",
            "County": "Lebanon",
            "State": "PA"
        },
        {
            "Code": "42077",
            "County": "Lehigh",
            "State": "PA"
        },
        {
            "Code": "42079",
            "County": "Luzerne",
            "State": "PA"
        },
        {
            "Code": "42081",
            "County": "Lycoming",
            "State": "PA"
        },
        {
            "Code": "42083",
            "County": "McKean",
            "State": "PA"
        },
        {
            "Code": "42085",
            "County": "Mercer",
            "State": "PA"
        },
        {
            "Code": "42087",
            "County": "Mifflin",
            "State": "PA"
        },
        {
            "Code": "42089",
            "County": "Monroe",
            "State": "PA"
        },
        {
            "Code": "42091",
            "County": "Montgomery",
            "State": "PA"
        },
        {
            "Code": "42093",
            "County": "Montour",
            "State": "PA"
        },
        {
            "Code": "42095",
            "County": "Northampton",
            "State": "PA"
        },
        {
            "Code": "42097",
            "County": "Northumberland",
            "State": "PA"
        },
        {
            "Code": "42099",
            "County": "Perry",
            "State": "PA"
        },
        {
            "Code": "42101",
            "County": "Philadelphia",
            "State": "PA"
        },
        {
            "Code": "42103",
            "County": "Pike",
            "State": "PA"
        },
        {
            "Code": "42105",
            "County": "Potter",
            "State": "PA"
        },
        {
            "Code": "42107",
            "County": "Schuylkill",
            "State": "PA"
        },
        {
            "Code": "42109",
            "County": "Snyder",
            "State": "PA"
        },
        {
            "Code": "42111",
            "County": "Somerset",
            "State": "PA"
        },
        {
            "Code": "42113",
            "County": "Sullivan",
            "State": "PA"
        },
        {
            "Code": "42115",
            "County": "Susquehanna",
            "State": "PA"
        },
        {
            "Code": "42117",
            "County": "Tioga",
            "State": "PA"
        },
        {
            "Code": "42119",
            "County": "Union",
            "State": "PA"
        },
        {
            "Code": "42121",
            "County": "Venango",
            "State": "PA"
        },
        {
            "Code": "42123",
            "County": "Warren",
            "State": "PA"
        },
        {
            "Code": "42125",
            "County": "Washington",
            "State": "PA"
        },
        {
            "Code": "42127",
            "County": "Wayne",
            "State": "PA"
        },
        {
            "Code": "42129",
            "County": "Westmoreland",
            "State": "PA"
        },
        {
            "Code": "42131",
            "County": "Wyoming",
            "State": "PA"
        },
        {
            "Code": "42133",
            "County": "York",
            "State": "PA"
        },
        {
            "Code": "44001",
            "County": "Bristol",
            "State": "RI"
        },
        {
            "Code": "44003",
            "County": "Kent",
            "State": "RI"
        },
        {
            "Code": "44005",
            "County": "Newport",
            "State": "RI"
        },
        {
            "Code": "44007",
            "County": "Providence",
            "State": "RI"
        },
        {
            "Code": "44009",
            "County": "Washington",
            "State": "RI"
        },
        {
            "Code": "45001",
            "County": "Abbeville",
            "State": "SC"
        },
        {
            "Code": "45003",
            "County": "Aiken",
            "State": "SC"
        },
        {
            "Code": "45005",
            "County": "Allendale",
            "State": "SC"
        },
        {
            "Code": "45007",
            "County": "Anderson",
            "State": "SC"
        },
        {
            "Code": "45009",
            "County": "Bamberg",
            "State": "SC"
        },
        {
            "Code": "45011",
            "County": "Barnwell",
            "State": "SC"
        },
        {
            "Code": "45013",
            "County": "Beaufort",
            "State": "SC"
        },
        {
            "Code": "45015",
            "County": "Berkeley",
            "State": "SC"
        },
        {
            "Code": "45017",
            "County": "Calhoun",
            "State": "SC"
        },
        {
            "Code": "45019",
            "County": "Charleston",
            "State": "SC"
        },
        {
            "Code": "45021",
            "County": "Cherokee",
            "State": "SC"
        },
        {
            "Code": "45023",
            "County": "Chester",
            "State": "SC"
        },
        {
            "Code": "45025",
            "County": "Chesterfield",
            "State": "SC"
        },
        {
            "Code": "45027",
            "County": "Clarendon",
            "State": "SC"
        },
        {
            "Code": "45029",
            "County": "Colleton",
            "State": "SC"
        },
        {
            "Code": "45031",
            "County": "Darlington",
            "State": "SC"
        },
        {
            "Code": "45033",
            "County": "Dillon",
            "State": "SC"
        },
        {
            "Code": "45035",
            "County": "Dorchester",
            "State": "SC"
        },
        {
            "Code": "45037",
            "County": "Edgefield",
            "State": "SC"
        },
        {
            "Code": "45039",
            "County": "Fairfield",
            "State": "SC"
        },
        {
            "Code": "45041",
            "County": "Florence",
            "State": "SC"
        },
        {
            "Code": "45043",
            "County": "Georgetown",
            "State": "SC"
        },
        {
            "Code": "45045",
            "County": "Greenville",
            "State": "SC"
        },
        {
            "Code": "45047",
            "County": "Greenwood",
            "State": "SC"
        },
        {
            "Code": "45049",
            "County": "Hampton",
            "State": "SC"
        },
        {
            "Code": "45051",
            "County": "Horry",
            "State": "SC"
        },
        {
            "Code": "45053",
            "County": "Jasper",
            "State": "SC"
        },
        {
            "Code": "45055",
            "County": "Kershaw",
            "State": "SC"
        },
        {
            "Code": "45057",
            "County": "Lancaster",
            "State": "SC"
        },
        {
            "Code": "45059",
            "County": "Laurens",
            "State": "SC"
        },
        {
            "Code": "45061",
            "County": "Lee",
            "State": "SC"
        },
        {
            "Code": "45063",
            "County": "Lexington",
            "State": "SC"
        },
        {
            "Code": "45065",
            "County": "McCormick",
            "State": "SC"
        },
        {
            "Code": "45067",
            "County": "Marion",
            "State": "SC"
        },
        {
            "Code": "45069",
            "County": "Marlboro",
            "State": "SC"
        },
        {
            "Code": "45071",
            "County": "Newberry",
            "State": "SC"
        },
        {
            "Code": "45073",
            "County": "Oconee",
            "State": "SC"
        },
        {
            "Code": "45075",
            "County": "Orangeburg",
            "State": "SC"
        },
        {
            "Code": "45077",
            "County": "Pickens",
            "State": "SC"
        },
        {
            "Code": "45079",
            "County": "Richland",
            "State": "SC"
        },
        {
            "Code": "45081",
            "County": "Saluda",
            "State": "SC"
        },
        {
            "Code": "45083",
            "County": "Spartanburg",
            "State": "SC"
        },
        {
            "Code": "45085",
            "County": "Sumter",
            "State": "SC"
        },
        {
            "Code": "45087",
            "County": "Union",
            "State": "SC"
        },
        {
            "Code": "45089",
            "County": "Williamsburg",
            "State": "SC"
        },
        {
            "Code": "45091",
            "County": "York",
            "State": "SC"
        },
        {
            "Code": "46003",
            "County": "Aurora",
            "State": "SD"
        },
        {
            "Code": "46005",
            "County": "Beadle",
            "State": "SD"
        },
        {
            "Code": "46007",
            "County": "Bennett",
            "State": "SD"
        },
        {
            "Code": "46009",
            "County": "Bon Homme",
            "State": "SD"
        },
        {
            "Code": "46011",
            "County": "Brookings",
            "State": "SD"
        },
        {
            "Code": "46013",
            "County": "Brown",
            "State": "SD"
        },
        {
            "Code": "46015",
            "County": "Brule",
            "State": "SD"
        },
        {
            "Code": "46017",
            "County": "Buffalo",
            "State": "SD"
        },
        {
            "Code": "46019",
            "County": "Butte",
            "State": "SD"
        },
        {
            "Code": "46021",
            "County": "Campbell",
            "State": "SD"
        },
        {
            "Code": "46023",
            "County": "Charles Mix",
            "State": "SD"
        },
        {
            "Code": "46025",
            "County": "Clark",
            "State": "SD"
        },
        {
            "Code": "46027",
            "County": "Clay",
            "State": "SD"
        },
        {
            "Code": "46029",
            "County": "Codington",
            "State": "SD"
        },
        {
            "Code": "46031",
            "County": "Corson",
            "State": "SD"
        },
        {
            "Code": "46033",
            "County": "Custer",
            "State": "SD"
        },
        {
            "Code": "46035",
            "County": "Davison",
            "State": "SD"
        },
        {
            "Code": "46037",
            "County": "Day",
            "State": "SD"
        },
        {
            "Code": "46039",
            "County": "Deuel",
            "State": "SD"
        },
        {
            "Code": "46041",
            "County": "Dewey",
            "State": "SD"
        },
        {
            "Code": "46043",
            "County": "Douglas",
            "State": "SD"
        },
        {
            "Code": "46045",
            "County": "Edmunds",
            "State": "SD"
        },
        {
            "Code": "46047",
            "County": "Fall River",
            "State": "SD"
        },
        {
            "Code": "46049",
            "County": "Faulk",
            "State": "SD"
        },
        {
            "Code": "46051",
            "County": "Grant",
            "State": "SD"
        },
        {
            "Code": "46053",
            "County": "Gregory",
            "State": "SD"
        },
        {
            "Code": "46055",
            "County": "Haakon",
            "State": "SD"
        },
        {
            "Code": "46057",
            "County": "Hamlin",
            "State": "SD"
        },
        {
            "Code": "46059",
            "County": "Hand",
            "State": "SD"
        },
        {
            "Code": "46061",
            "County": "Hanson",
            "State": "SD"
        },
        {
            "Code": "46063",
            "County": "Harding",
            "State": "SD"
        },
        {
            "Code": "46065",
            "County": "Hughes",
            "State": "SD"
        },
        {
            "Code": "46067",
            "County": "Hutchinson",
            "State": "SD"
        },
        {
            "Code": "46069",
            "County": "Hyde",
            "State": "SD"
        },
        {
            "Code": "46071",
            "County": "Jackson",
            "State": "SD"
        },
        {
            "Code": "46073",
            "County": "Jerauld",
            "State": "SD"
        },
        {
            "Code": "46075",
            "County": "Jones",
            "State": "SD"
        },
        {
            "Code": "46077",
            "County": "Kingsbury",
            "State": "SD"
        },
        {
            "Code": "46079",
            "County": "Lake",
            "State": "SD"
        },
        {
            "Code": "46081",
            "County": "Lawrence",
            "State": "SD"
        },
        {
            "Code": "46083",
            "County": "Lincoln",
            "State": "SD"
        },
        {
            "Code": "46085",
            "County": "Lyman",
            "State": "SD"
        },
        {
            "Code": "46087",
            "County": "McCook",
            "State": "SD"
        },
        {
            "Code": "46089",
            "County": "McPherson",
            "State": "SD"
        },
        {
            "Code": "46091",
            "County": "Marshall",
            "State": "SD"
        },
        {
            "Code": "46093",
            "County": "Meade",
            "State": "SD"
        },
        {
            "Code": "46095",
            "County": "Mellette",
            "State": "SD"
        },
        {
            "Code": "46097",
            "County": "Miner",
            "State": "SD"
        },
        {
            "Code": "46099",
            "County": "Minnehaha",
            "State": "SD"
        },
        {
            "Code": "46101",
            "County": "Moody",
            "State": "SD"
        },
        {
            "Code": "46103",
            "County": "Pennington",
            "State": "SD"
        },
        {
            "Code": "46105",
            "County": "Perkins",
            "State": "SD"
        },
        {
            "Code": "46107",
            "County": "Potter",
            "State": "SD"
        },
        {
            "Code": "46109",
            "County": "Roberts",
            "State": "SD"
        },
        {
            "Code": "46111",
            "County": "Sanborn",
            "State": "SD"
        },
        {
            "Code": "46113",
            "County": "Shannon",
            "State": "SD"
        },
        {
            "Code": "46115",
            "County": "Spink",
            "State": "SD"
        },
        {
            "Code": "46117",
            "County": "Stanley",
            "State": "SD"
        },
        {
            "Code": "46119",
            "County": "Sully",
            "State": "SD"
        },
        {
            "Code": "46121",
            "County": "Todd",
            "State": "SD"
        },
        {
            "Code": "46123",
            "County": "Tripp",
            "State": "SD"
        },
        {
            "Code": "46125",
            "County": "Turner",
            "State": "SD"
        },
        {
            "Code": "46127",
            "County": "Union",
            "State": "SD"
        },
        {
            "Code": "46129",
            "County": "Walworth",
            "State": "SD"
        },
        {
            "Code": "46135",
            "County": "Yankton",
            "State": "SD"
        },
        {
            "Code": "46137",
            "County": "Ziebach",
            "State": "SD"
        },
        {
            "Code": "47001",
            "County": "Anderson",
            "State": "TN"
        },
        {
            "Code": "47003",
            "County": "Bedford",
            "State": "TN"
        },
        {
            "Code": "47005",
            "County": "Benton",
            "State": "TN"
        },
        {
            "Code": "47007",
            "County": "Bledsoe",
            "State": "TN"
        },
        {
            "Code": "47009",
            "County": "Blount",
            "State": "TN"
        },
        {
            "Code": "47011",
            "County": "Bradley",
            "State": "TN"
        },
        {
            "Code": "47013",
            "County": "Campbell",
            "State": "TN"
        },
        {
            "Code": "47015",
            "County": "Cannon",
            "State": "TN"
        },
        {
            "Code": "47017",
            "County": "Carroll",
            "State": "TN"
        },
        {
            "Code": "47019",
            "County": "Carter",
            "State": "TN"
        },
        {
            "Code": "47021",
            "County": "Cheatham",
            "State": "TN"
        },
        {
            "Code": "47023",
            "County": "Chester",
            "State": "TN"
        },
        {
            "Code": "47025",
            "County": "Claiborne",
            "State": "TN"
        },
        {
            "Code": "47027",
            "County": "Clay",
            "State": "TN"
        },
        {
            "Code": "47029",
            "County": "Cocke",
            "State": "TN"
        },
        {
            "Code": "47031",
            "County": "Coffee",
            "State": "TN"
        },
        {
            "Code": "47033",
            "County": "Crockett",
            "State": "TN"
        },
        {
            "Code": "47035",
            "County": "Cumberland",
            "State": "TN"
        },
        {
            "Code": "47037",
            "County": "Davidson",
            "State": "TN"
        },
        {
            "Code": "47039",
            "County": "Decatur",
            "State": "TN"
        },
        {
            "Code": "47041",
            "County": "De Kalb",
            "State": "TN"
        },
        {
            "Code": "47043",
            "County": "Dickson",
            "State": "TN"
        },
        {
            "Code": "47045",
            "County": "Dyer",
            "State": "TN"
        },
        {
            "Code": "47047",
            "County": "Fayette",
            "State": "TN"
        },
        {
            "Code": "47049",
            "County": "Fentress",
            "State": "TN"
        },
        {
            "Code": "47051",
            "County": "Franklin",
            "State": "TN"
        },
        {
            "Code": "47053",
            "County": "Gibson",
            "State": "TN"
        },
        {
            "Code": "47055",
            "County": "Giles",
            "State": "TN"
        },
        {
            "Code": "47057",
            "County": "Grainger",
            "State": "TN"
        },
        {
            "Code": "47059",
            "County": "Greene",
            "State": "TN"
        },
        {
            "Code": "47061",
            "County": "Grundy",
            "State": "TN"
        },
        {
            "Code": "47063",
            "County": "Hamblen",
            "State": "TN"
        },
        {
            "Code": "47065",
            "County": "Hamilton",
            "State": "TN"
        },
        {
            "Code": "47067",
            "County": "Hancock",
            "State": "TN"
        },
        {
            "Code": "47069",
            "County": "Hardeman",
            "State": "TN"
        },
        {
            "Code": "47071",
            "County": "Hardin",
            "State": "TN"
        },
        {
            "Code": "47073",
            "County": "Hawkins",
            "State": "TN"
        },
        {
            "Code": "47075",
            "County": "Haywood",
            "State": "TN"
        },
        {
            "Code": "47077",
            "County": "Henderson",
            "State": "TN"
        },
        {
            "Code": "47079",
            "County": "Henry",
            "State": "TN"
        },
        {
            "Code": "47081",
            "County": "Hickman",
            "State": "TN"
        },
        {
            "Code": "47083",
            "County": "Houston",
            "State": "TN"
        },
        {
            "Code": "47085",
            "County": "Humphreys",
            "State": "TN"
        },
        {
            "Code": "47087",
            "County": "Jackson",
            "State": "TN"
        },
        {
            "Code": "47089",
            "County": "Jefferson",
            "State": "TN"
        },
        {
            "Code": "47091",
            "County": "Johnson",
            "State": "TN"
        },
        {
            "Code": "47093",
            "County": "Knox",
            "State": "TN"
        },
        {
            "Code": "47095",
            "County": "Lake",
            "State": "TN"
        },
        {
            "Code": "47097",
            "County": "Lauderdale",
            "State": "TN"
        },
        {
            "Code": "47099",
            "County": "Lawrence",
            "State": "TN"
        },
        {
            "Code": "47101",
            "County": "Lewis",
            "State": "TN"
        },
        {
            "Code": "47103",
            "County": "Lincoln",
            "State": "TN"
        },
        {
            "Code": "47105",
            "County": "Loudon",
            "State": "TN"
        },
        {
            "Code": "47107",
            "County": "McMinn",
            "State": "TN"
        },
        {
            "Code": "47109",
            "County": "McNairy",
            "State": "TN"
        },
        {
            "Code": "47111",
            "County": "Macon",
            "State": "TN"
        },
        {
            "Code": "47113",
            "County": "Madison",
            "State": "TN"
        },
        {
            "Code": "47115",
            "County": "Marion",
            "State": "TN"
        },
        {
            "Code": "47117",
            "County": "Marshall",
            "State": "TN"
        },
        {
            "Code": "47119",
            "County": "Maury",
            "State": "TN"
        },
        {
            "Code": "47121",
            "County": "Meigs",
            "State": "TN"
        },
        {
            "Code": "47123",
            "County": "Monroe",
            "State": "TN"
        },
        {
            "Code": "47125",
            "County": "Montgomery",
            "State": "TN"
        },
        {
            "Code": "47127",
            "County": "Moore",
            "State": "TN"
        },
        {
            "Code": "47129",
            "County": "Morgan",
            "State": "TN"
        },
        {
            "Code": "47131",
            "County": "Obion",
            "State": "TN"
        },
        {
            "Code": "47133",
            "County": "Overton",
            "State": "TN"
        },
        {
            "Code": "47135",
            "County": "Perry",
            "State": "TN"
        },
        {
            "Code": "47137",
            "County": "Pickett",
            "State": "TN"
        },
        {
            "Code": "47139",
            "County": "Polk",
            "State": "TN"
        },
        {
            "Code": "47141",
            "County": "Putnam",
            "State": "TN"
        },
        {
            "Code": "47143",
            "County": "Rhea",
            "State": "TN"
        },
        {
            "Code": "47145",
            "County": "Roane",
            "State": "TN"
        },
        {
            "Code": "47147",
            "County": "Robertson",
            "State": "TN"
        },
        {
            "Code": "47149",
            "County": "Rutherford",
            "State": "TN"
        },
        {
            "Code": "47151",
            "County": "Scott",
            "State": "TN"
        },
        {
            "Code": "47153",
            "County": "Sequatchie",
            "State": "TN"
        },
        {
            "Code": "47155",
            "County": "Sevier",
            "State": "TN"
        },
        {
            "Code": "47157",
            "County": "Shelby",
            "State": "TN"
        },
        {
            "Code": "47159",
            "County": "Smith",
            "State": "TN"
        },
        {
            "Code": "47161",
            "County": "Stewart",
            "State": "TN"
        },
        {
            "Code": "47163",
            "County": "Sullivan",
            "State": "TN"
        },
        {
            "Code": "47165",
            "County": "Sumner",
            "State": "TN"
        },
        {
            "Code": "47167",
            "County": "Tipton",
            "State": "TN"
        },
        {
            "Code": "47169",
            "County": "Trousdale",
            "State": "TN"
        },
        {
            "Code": "47171",
            "County": "Unicoi",
            "State": "TN"
        },
        {
            "Code": "47173",
            "County": "Union",
            "State": "TN"
        },
        {
            "Code": "47175",
            "County": "Van Buren",
            "State": "TN"
        },
        {
            "Code": "47177",
            "County": "Warren",
            "State": "TN"
        },
        {
            "Code": "47179",
            "County": "Washington",
            "State": "TN"
        },
        {
            "Code": "47181",
            "County": "Wayne",
            "State": "TN"
        },
        {
            "Code": "47183",
            "County": "Weakley",
            "State": "TN"
        },
        {
            "Code": "47185",
            "County": "White",
            "State": "TN"
        },
        {
            "Code": "47187",
            "County": "Williamson",
            "State": "TN"
        },
        {
            "Code": "47189",
            "County": "Wilson",
            "State": "TN"
        },
        {
            "Code": "48001",
            "County": "Anderson",
            "State": "TX"
        },
        {
            "Code": "48003",
            "County": "Andrews",
            "State": "TX"
        },
        {
            "Code": "48005",
            "County": "Angelina",
            "State": "TX"
        },
        {
            "Code": "48007",
            "County": "Aransas",
            "State": "TX"
        },
        {
            "Code": "48009",
            "County": "Archer",
            "State": "TX"
        },
        {
            "Code": "48011",
            "County": "Armstrong",
            "State": "TX"
        },
        {
            "Code": "48013",
            "County": "Atascosa",
            "State": "TX"
        },
        {
            "Code": "48015",
            "County": "Austin",
            "State": "TX"
        },
        {
            "Code": "48017",
            "County": "Bailey",
            "State": "TX"
        },
        {
            "Code": "48019",
            "County": "Bandera",
            "State": "TX"
        },
        {
            "Code": "48021",
            "County": "Bastrop",
            "State": "TX"
        },
        {
            "Code": "48023",
            "County": "Baylor",
            "State": "TX"
        },
        {
            "Code": "48025",
            "County": "Bee",
            "State": "TX"
        },
        {
            "Code": "48027",
            "County": "Bell",
            "State": "TX"
        },
        {
            "Code": "48029",
            "County": "Bexar",
            "State": "TX"
        },
        {
            "Code": "48031",
            "County": "Blanco",
            "State": "TX"
        },
        {
            "Code": "48033",
            "County": "Borden",
            "State": "TX"
        },
        {
            "Code": "48035",
            "County": "Bosque",
            "State": "TX"
        },
        {
            "Code": "48037",
            "County": "Bowie",
            "State": "TX"
        },
        {
            "Code": "48039",
            "County": "Brazoria",
            "State": "TX"
        },
        {
            "Code": "48041",
            "County": "Brazos",
            "State": "TX"
        },
        {
            "Code": "48043",
            "County": "Brewster",
            "State": "TX"
        },
        {
            "Code": "48045",
            "County": "Briscoe",
            "State": "TX"
        },
        {
            "Code": "48047",
            "County": "Brooks",
            "State": "TX"
        },
        {
            "Code": "48049",
            "County": "Brown",
            "State": "TX"
        },
        {
            "Code": "48051",
            "County": "Burleson",
            "State": "TX"
        },
        {
            "Code": "48053",
            "County": "Burnet",
            "State": "TX"
        },
        {
            "Code": "48055",
            "County": "Caldwell",
            "State": "TX"
        },
        {
            "Code": "48057",
            "County": "Calhoun",
            "State": "TX"
        },
        {
            "Code": "48059",
            "County": "Callahan",
            "State": "TX"
        },
        {
            "Code": "48061",
            "County": "Cameron",
            "State": "TX"
        },
        {
            "Code": "48063",
            "County": "Camp",
            "State": "TX"
        },
        {
            "Code": "48065",
            "County": "Carson",
            "State": "TX"
        },
        {
            "Code": "48067",
            "County": "Cass",
            "State": "TX"
        },
        {
            "Code": "48069",
            "County": "Castro",
            "State": "TX"
        },
        {
            "Code": "48071",
            "County": "Chambers",
            "State": "TX"
        },
        {
            "Code": "48073",
            "County": "Cherokee",
            "State": "TX"
        },
        {
            "Code": "48075",
            "County": "Childress",
            "State": "TX"
        },
        {
            "Code": "48077",
            "County": "Clay",
            "State": "TX"
        },
        {
            "Code": "48079",
            "County": "Cochran",
            "State": "TX"
        },
        {
            "Code": "48081",
            "County": "Coke",
            "State": "TX"
        },
        {
            "Code": "48083",
            "County": "Coleman",
            "State": "TX"
        },
        {
            "Code": "48085",
            "County": "Collin",
            "State": "TX"
        },
        {
            "Code": "48087",
            "County": "Collingsworth",
            "State": "TX"
        },
        {
            "Code": "48089",
            "County": "Colorado",
            "State": "TX"
        },
        {
            "Code": "48091",
            "County": "Comal",
            "State": "TX"
        },
        {
            "Code": "48093",
            "County": "Comanche",
            "State": "TX"
        },
        {
            "Code": "48095",
            "County": "Concho",
            "State": "TX"
        },
        {
            "Code": "48097",
            "County": "Cooke",
            "State": "TX"
        },
        {
            "Code": "48099",
            "County": "Coryell",
            "State": "TX"
        },
        {
            "Code": "48101",
            "County": "Cottle",
            "State": "TX"
        },
        {
            "Code": "48103",
            "County": "Crane",
            "State": "TX"
        },
        {
            "Code": "48105",
            "County": "Crockett",
            "State": "TX"
        },
        {
            "Code": "48107",
            "County": "Crosby",
            "State": "TX"
        },
        {
            "Code": "48109",
            "County": "Culberson",
            "State": "TX"
        },
        {
            "Code": "48111",
            "County": "Dallam",
            "State": "TX"
        },
        {
            "Code": "48113",
            "County": "Dallas",
            "State": "TX"
        },
        {
            "Code": "48115",
            "County": "Dawson",
            "State": "TX"
        },
        {
            "Code": "48117",
            "County": "Deaf Smith",
            "State": "TX"
        },
        {
            "Code": "48119",
            "County": "Delta",
            "State": "TX"
        },
        {
            "Code": "48121",
            "County": "Denton",
            "State": "TX"
        },
        {
            "Code": "48123",
            "County": "De Witt",
            "State": "TX"
        },
        {
            "Code": "48125",
            "County": "Dickens",
            "State": "TX"
        },
        {
            "Code": "48127",
            "County": "Dimmit",
            "State": "TX"
        },
        {
            "Code": "48129",
            "County": "Donley",
            "State": "TX"
        },
        {
            "Code": "48131",
            "County": "Duval",
            "State": "TX"
        },
        {
            "Code": "48133",
            "County": "Eastland",
            "State": "TX"
        },
        {
            "Code": "48135",
            "County": "Ector",
            "State": "TX"
        },
        {
            "Code": "48137",
            "County": "Edwards",
            "State": "TX"
        },
        {
            "Code": "48139",
            "County": "Ellis",
            "State": "TX"
        },
        {
            "Code": "48141",
            "County": "El Paso",
            "State": "TX"
        },
        {
            "Code": "48143",
            "County": "Erath",
            "State": "TX"
        },
        {
            "Code": "48145",
            "County": "Falls",
            "State": "TX"
        },
        {
            "Code": "48147",
            "County": "Fannin",
            "State": "TX"
        },
        {
            "Code": "48149",
            "County": "Fayette",
            "State": "TX"
        },
        {
            "Code": "48151",
            "County": "Fisher",
            "State": "TX"
        },
        {
            "Code": "48153",
            "County": "Floyd",
            "State": "TX"
        },
        {
            "Code": "48155",
            "County": "Foard",
            "State": "TX"
        },
        {
            "Code": "48157",
            "County": "Fort Bend",
            "State": "TX"
        },
        {
            "Code": "48159",
            "County": "Franklin",
            "State": "TX"
        },
        {
            "Code": "48161",
            "County": "Freestone",
            "State": "TX"
        },
        {
            "Code": "48163",
            "County": "Frio",
            "State": "TX"
        },
        {
            "Code": "48165",
            "County": "Gaines",
            "State": "TX"
        },
        {
            "Code": "48167",
            "County": "Galveston",
            "State": "TX"
        },
        {
            "Code": "48169",
            "County": "Garza",
            "State": "TX"
        },
        {
            "Code": "48171",
            "County": "Gillespie",
            "State": "TX"
        },
        {
            "Code": "48173",
            "County": "Glasscock",
            "State": "TX"
        },
        {
            "Code": "48175",
            "County": "Goliad",
            "State": "TX"
        },
        {
            "Code": "48177",
            "County": "Gonzales",
            "State": "TX"
        },
        {
            "Code": "48179",
            "County": "Gray",
            "State": "TX"
        },
        {
            "Code": "48181",
            "County": "Grayson",
            "State": "TX"
        },
        {
            "Code": "48183",
            "County": "Gregg",
            "State": "TX"
        },
        {
            "Code": "48185",
            "County": "Grimes",
            "State": "TX"
        },
        {
            "Code": "48187",
            "County": "Guadalupe",
            "State": "TX"
        },
        {
            "Code": "48189",
            "County": "Hale",
            "State": "TX"
        },
        {
            "Code": "48191",
            "County": "Hall",
            "State": "TX"
        },
        {
            "Code": "48193",
            "County": "Hamilton",
            "State": "TX"
        },
        {
            "Code": "48195",
            "County": "Hansford",
            "State": "TX"
        },
        {
            "Code": "48197",
            "County": "Hardeman",
            "State": "TX"
        },
        {
            "Code": "48199",
            "County": "Hardin",
            "State": "TX"
        },
        {
            "Code": "48201",
            "County": "Harris",
            "State": "TX"
        },
        {
            "Code": "48203",
            "County": "Harrison",
            "State": "TX"
        },
        {
            "Code": "48205",
            "County": "Hartley",
            "State": "TX"
        },
        {
            "Code": "48207",
            "County": "Haskell",
            "State": "TX"
        },
        {
            "Code": "48209",
            "County": "Hays",
            "State": "TX"
        },
        {
            "Code": "48211",
            "County": "Hemphill",
            "State": "TX"
        },
        {
            "Code": "48213",
            "County": "Henderson",
            "State": "TX"
        },
        {
            "Code": "48215",
            "County": "Hidalgo",
            "State": "TX"
        },
        {
            "Code": "48217",
            "County": "Hill",
            "State": "TX"
        },
        {
            "Code": "48219",
            "County": "Hockley",
            "State": "TX"
        },
        {
            "Code": "48221",
            "County": "Hood",
            "State": "TX"
        },
        {
            "Code": "48223",
            "County": "Hopkins",
            "State": "TX"
        },
        {
            "Code": "48225",
            "County": "Houston",
            "State": "TX"
        },
        {
            "Code": "48227",
            "County": "Howard",
            "State": "TX"
        },
        {
            "Code": "48229",
            "County": "Hudspeth",
            "State": "TX"
        },
        {
            "Code": "48231",
            "County": "Hunt",
            "State": "TX"
        },
        {
            "Code": "48233",
            "County": "Hutchinson",
            "State": "TX"
        },
        {
            "Code": "48235",
            "County": "Irion",
            "State": "TX"
        },
        {
            "Code": "48237",
            "County": "Jack",
            "State": "TX"
        },
        {
            "Code": "48239",
            "County": "Jackson",
            "State": "TX"
        },
        {
            "Code": "48241",
            "County": "Jasper",
            "State": "TX"
        },
        {
            "Code": "48243",
            "County": "Jeff Davis",
            "State": "TX"
        },
        {
            "Code": "48245",
            "County": "Jefferson",
            "State": "TX"
        },
        {
            "Code": "48247",
            "County": "Jim Hogg",
            "State": "TX"
        },
        {
            "Code": "48249",
            "County": "Jim Wells",
            "State": "TX"
        },
        {
            "Code": "48251",
            "County": "Johnson",
            "State": "TX"
        },
        {
            "Code": "48253",
            "County": "Jones",
            "State": "TX"
        },
        {
            "Code": "48255",
            "County": "Karnes",
            "State": "TX"
        },
        {
            "Code": "48257",
            "County": "Kaufman",
            "State": "TX"
        },
        {
            "Code": "48259",
            "County": "Kendall",
            "State": "TX"
        },
        {
            "Code": "48261",
            "County": "Kenedy",
            "State": "TX"
        },
        {
            "Code": "48263",
            "County": "Kent",
            "State": "TX"
        },
        {
            "Code": "48265",
            "County": "Kerr",
            "State": "TX"
        },
        {
            "Code": "48267",
            "County": "Kimble",
            "State": "TX"
        },
        {
            "Code": "48269",
            "County": "King",
            "State": "TX"
        },
        {
            "Code": "48271",
            "County": "Kinney",
            "State": "TX"
        },
        {
            "Code": "48273",
            "County": "Kleberg",
            "State": "TX"
        },
        {
            "Code": "48275",
            "County": "Knox",
            "State": "TX"
        },
        {
            "Code": "48277",
            "County": "Lamar",
            "State": "TX"
        },
        {
            "Code": "48279",
            "County": "Lamb",
            "State": "TX"
        },
        {
            "Code": "48281",
            "County": "Lampasas",
            "State": "TX"
        },
        {
            "Code": "48283",
            "County": "La Salle",
            "State": "TX"
        },
        {
            "Code": "48285",
            "County": "Lavaca",
            "State": "TX"
        },
        {
            "Code": "48287",
            "County": "Lee",
            "State": "TX"
        },
        {
            "Code": "48289",
            "County": "Leon",
            "State": "TX"
        },
        {
            "Code": "48291",
            "County": "Liberty",
            "State": "TX"
        },
        {
            "Code": "48293",
            "County": "Limestone",
            "State": "TX"
        },
        {
            "Code": "48295",
            "County": "Lipscomb",
            "State": "TX"
        },
        {
            "Code": "48297",
            "County": "Live Oak",
            "State": "TX"
        },
        {
            "Code": "48299",
            "County": "Llano",
            "State": "TX"
        },
        {
            "Code": "48301",
            "County": "Loving",
            "State": "TX"
        },
        {
            "Code": "48303",
            "County": "Lubbock",
            "State": "TX"
        },
        {
            "Code": "48305",
            "County": "Lynn",
            "State": "TX"
        },
        {
            "Code": "48307",
            "County": "McCulloch",
            "State": "TX"
        },
        {
            "Code": "48309",
            "County": "McLennan",
            "State": "TX"
        },
        {
            "Code": "48311",
            "County": "McMullen",
            "State": "TX"
        },
        {
            "Code": "48313",
            "County": "Madison",
            "State": "TX"
        },
        {
            "Code": "48315",
            "County": "Marion",
            "State": "TX"
        },
        {
            "Code": "48317",
            "County": "Martin",
            "State": "TX"
        },
        {
            "Code": "48319",
            "County": "Mason",
            "State": "TX"
        },
        {
            "Code": "48321",
            "County": "Matagorda",
            "State": "TX"
        },
        {
            "Code": "48323",
            "County": "Maverick",
            "State": "TX"
        },
        {
            "Code": "48325",
            "County": "Medina",
            "State": "TX"
        },
        {
            "Code": "48327",
            "County": "Menard",
            "State": "TX"
        },
        {
            "Code": "48329",
            "County": "Midland",
            "State": "TX"
        },
        {
            "Code": "48331",
            "County": "Milam",
            "State": "TX"
        },
        {
            "Code": "48333",
            "County": "Mills",
            "State": "TX"
        },
        {
            "Code": "48335",
            "County": "Mitchell",
            "State": "TX"
        },
        {
            "Code": "48337",
            "County": "Montague",
            "State": "TX"
        },
        {
            "Code": "48339",
            "County": "Montgomery",
            "State": "TX"
        },
        {
            "Code": "48341",
            "County": "Moore",
            "State": "TX"
        },
        {
            "Code": "48343",
            "County": "Morris",
            "State": "TX"
        },
        {
            "Code": "48345",
            "County": "Motley",
            "State": "TX"
        },
        {
            "Code": "48347",
            "County": "Nacogdoches",
            "State": "TX"
        },
        {
            "Code": "48349",
            "County": "Navarro",
            "State": "TX"
        },
        {
            "Code": "48351",
            "County": "Newton",
            "State": "TX"
        },
        {
            "Code": "48353",
            "County": "Nolan",
            "State": "TX"
        },
        {
            "Code": "48355",
            "County": "Nueces",
            "State": "TX"
        },
        {
            "Code": "48357",
            "County": "Ochiltree",
            "State": "TX"
        },
        {
            "Code": "48359",
            "County": "Oldham",
            "State": "TX"
        },
        {
            "Code": "48361",
            "County": "Orange",
            "State": "TX"
        },
        {
            "Code": "48363",
            "County": "Palo Pinto",
            "State": "TX"
        },
        {
            "Code": "48365",
            "County": "Panola",
            "State": "TX"
        },
        {
            "Code": "48367",
            "County": "Parker",
            "State": "TX"
        },
        {
            "Code": "48369",
            "County": "Parmer",
            "State": "TX"
        },
        {
            "Code": "48371",
            "County": "Pecos",
            "State": "TX"
        },
        {
            "Code": "48373",
            "County": "Polk",
            "State": "TX"
        },
        {
            "Code": "48375",
            "County": "Potter",
            "State": "TX"
        },
        {
            "Code": "48377",
            "County": "Presidio",
            "State": "TX"
        },
        {
            "Code": "48379",
            "County": "Rains",
            "State": "TX"
        },
        {
            "Code": "48381",
            "County": "Randall",
            "State": "TX"
        },
        {
            "Code": "48383",
            "County": "Reagan",
            "State": "TX"
        },
        {
            "Code": "48385",
            "County": "Real",
            "State": "TX"
        },
        {
            "Code": "48387",
            "County": "Red River",
            "State": "TX"
        },
        {
            "Code": "48389",
            "County": "Reeves",
            "State": "TX"
        },
        {
            "Code": "48391",
            "County": "Refugio",
            "State": "TX"
        },
        {
            "Code": "48393",
            "County": "Roberts",
            "State": "TX"
        },
        {
            "Code": "48395",
            "County": "Robertson",
            "State": "TX"
        },
        {
            "Code": "48397",
            "County": "Rockwall",
            "State": "TX"
        },
        {
            "Code": "48399",
            "County": "Runnels",
            "State": "TX"
        },
        {
            "Code": "48401",
            "County": "Rusk",
            "State": "TX"
        },
        {
            "Code": "48403",
            "County": "Sabine",
            "State": "TX"
        },
        {
            "Code": "48405",
            "County": "San Augustine",
            "State": "TX"
        },
        {
            "Code": "48407",
            "County": "San Jacinto",
            "State": "TX"
        },
        {
            "Code": "48409",
            "County": "San Patricio",
            "State": "TX"
        },
        {
            "Code": "48411",
            "County": "San Saba",
            "State": "TX"
        },
        {
            "Code": "48413",
            "County": "Schleicher",
            "State": "TX"
        },
        {
            "Code": "48415",
            "County": "Scurry",
            "State": "TX"
        },
        {
            "Code": "48417",
            "County": "Shackelford",
            "State": "TX"
        },
        {
            "Code": "48419",
            "County": "Shelby",
            "State": "TX"
        },
        {
            "Code": "48421",
            "County": "Sherman",
            "State": "TX"
        },
        {
            "Code": "48423",
            "County": "Smith",
            "State": "TX"
        },
        {
            "Code": "48425",
            "County": "Somervell",
            "State": "TX"
        },
        {
            "Code": "48427",
            "County": "Starr",
            "State": "TX"
        },
        {
            "Code": "48429",
            "County": "Stephens",
            "State": "TX"
        },
        {
            "Code": "48431",
            "County": "Sterling",
            "State": "TX"
        },
        {
            "Code": "48433",
            "County": "Stonewall",
            "State": "TX"
        },
        {
            "Code": "48435",
            "County": "Sutton",
            "State": "TX"
        },
        {
            "Code": "48437",
            "County": "Swisher",
            "State": "TX"
        },
        {
            "Code": "48439",
            "County": "Tarrant",
            "State": "TX"
        },
        {
            "Code": "48441",
            "County": "Taylor",
            "State": "TX"
        },
        {
            "Code": "48443",
            "County": "Terrell",
            "State": "TX"
        },
        {
            "Code": "48445",
            "County": "Terry",
            "State": "TX"
        },
        {
            "Code": "48447",
            "County": "Throckmorton",
            "State": "TX"
        },
        {
            "Code": "48449",
            "County": "Titus",
            "State": "TX"
        },
        {
            "Code": "48451",
            "County": "Tom Green",
            "State": "TX"
        },
        {
            "Code": "48453",
            "County": "Travis",
            "State": "TX"
        },
        {
            "Code": "48455",
            "County": "Trinity",
            "State": "TX"
        },
        {
            "Code": "48457",
            "County": "Tyler",
            "State": "TX"
        },
        {
            "Code": "48459",
            "County": "Upshur",
            "State": "TX"
        },
        {
            "Code": "48461",
            "County": "Upton",
            "State": "TX"
        },
        {
            "Code": "48463",
            "County": "Uvalde",
            "State": "TX"
        },
        {
            "Code": "48465",
            "County": "Val Verde",
            "State": "TX"
        },
        {
            "Code": "48467",
            "County": "Van Zandt",
            "State": "TX"
        },
        {
            "Code": "48469",
            "County": "Victoria",
            "State": "TX"
        },
        {
            "Code": "48471",
            "County": "Walker",
            "State": "TX"
        },
        {
            "Code": "48473",
            "County": "Waller",
            "State": "TX"
        },
        {
            "Code": "48475",
            "County": "Ward",
            "State": "TX"
        },
        {
            "Code": "48477",
            "County": "Washington",
            "State": "TX"
        },
        {
            "Code": "48479",
            "County": "Webb",
            "State": "TX"
        },
        {
            "Code": "48481",
            "County": "Wharton",
            "State": "TX"
        },
        {
            "Code": "48483",
            "County": "Wheeler",
            "State": "TX"
        },
        {
            "Code": "48485",
            "County": "Wichita",
            "State": "TX"
        },
        {
            "Code": "48487",
            "County": "Wilbarger",
            "State": "TX"
        },
        {
            "Code": "48489",
            "County": "Willacy",
            "State": "TX"
        },
        {
            "Code": "48491",
            "County": "Williamson",
            "State": "TX"
        },
        {
            "Code": "48493",
            "County": "Wilson",
            "State": "TX"
        },
        {
            "Code": "48495",
            "County": "Winkler",
            "State": "TX"
        },
        {
            "Code": "48497",
            "County": "Wise",
            "State": "TX"
        },
        {
            "Code": "48499",
            "County": "Wood",
            "State": "TX"
        },
        {
            "Code": "48501",
            "County": "Yoakum",
            "State": "TX"
        },
        {
            "Code": "48503",
            "County": "Young",
            "State": "TX"
        },
        {
            "Code": "48505",
            "County": "Zapata",
            "State": "TX"
        },
        {
            "Code": "48507",
            "County": "Zavala",
            "State": "TX"
        },
        {
            "Code": "49001",
            "County": "Beaver",
            "State": "UT"
        },
        {
            "Code": "49003",
            "County": "Box Elder",
            "State": "UT"
        },
        {
            "Code": "49005",
            "County": "Cache",
            "State": "UT"
        },
        {
            "Code": "49007",
            "County": "Carbon",
            "State": "UT"
        },
        {
            "Code": "49009",
            "County": "Daggett",
            "State": "UT"
        },
        {
            "Code": "49011",
            "County": "Davis",
            "State": "UT"
        },
        {
            "Code": "49013",
            "County": "Duchesne",
            "State": "UT"
        },
        {
            "Code": "49015",
            "County": "Emery",
            "State": "UT"
        },
        {
            "Code": "49017",
            "County": "Garfield",
            "State": "UT"
        },
        {
            "Code": "49019",
            "County": "Grand",
            "State": "UT"
        },
        {
            "Code": "49021",
            "County": "Iron",
            "State": "UT"
        },
        {
            "Code": "49023",
            "County": "Juab",
            "State": "UT"
        },
        {
            "Code": "49025",
            "County": "Kane",
            "State": "UT"
        },
        {
            "Code": "49027",
            "County": "Millard",
            "State": "UT"
        },
        {
            "Code": "49029",
            "County": "Morgan",
            "State": "UT"
        },
        {
            "Code": "49031",
            "County": "Piute",
            "State": "UT"
        },
        {
            "Code": "49033",
            "County": "Rich",
            "State": "UT"
        },
        {
            "Code": "49035",
            "County": "Salt Lake",
            "State": "UT"
        },
        {
            "Code": "49037",
            "County": "San Juan",
            "State": "UT"
        },
        {
            "Code": "49039",
            "County": "Sanpete",
            "State": "UT"
        },
        {
            "Code": "49041",
            "County": "Sevier",
            "State": "UT"
        },
        {
            "Code": "49043",
            "County": "Summit",
            "State": "UT"
        },
        {
            "Code": "49045",
            "County": "Tooele",
            "State": "UT"
        },
        {
            "Code": "49047",
            "County": "Uintah",
            "State": "UT"
        },
        {
            "Code": "49049",
            "County": "Utah",
            "State": "UT"
        },
        {
            "Code": "49051",
            "County": "Wasatch",
            "State": "UT"
        },
        {
            "Code": "49053",
            "County": "Washington",
            "State": "UT"
        },
        {
            "Code": "49055",
            "County": "Wayne",
            "State": "UT"
        },
        {
            "Code": "49057",
            "County": "Weber",
            "State": "UT"
        },
        {
            "Code": "50001",
            "County": "Addison",
            "State": "VT"
        },
        {
            "Code": "50003",
            "County": "Bennington",
            "State": "VT"
        },
        {
            "Code": "50005",
            "County": "Caledonia",
            "State": "VT"
        },
        {
            "Code": "50007",
            "County": "Chittenden",
            "State": "VT"
        },
        {
            "Code": "50009",
            "County": "Essex",
            "State": "VT"
        },
        {
            "Code": "50011",
            "County": "Franklin",
            "State": "VT"
        },
        {
            "Code": "50013",
            "County": "Grand Isle",
            "State": "VT"
        },
        {
            "Code": "50015",
            "County": "Lamoille",
            "State": "VT"
        },
        {
            "Code": "50017",
            "County": "Orange",
            "State": "VT"
        },
        {
            "Code": "50019",
            "County": "Orleans",
            "State": "VT"
        },
        {
            "Code": "50021",
            "County": "Rutland",
            "State": "VT"
        },
        {
            "Code": "50023",
            "County": "Washington",
            "State": "VT"
        },
        {
            "Code": "50025",
            "County": "Windham",
            "State": "VT"
        },
        {
            "Code": "50027",
            "County": "Windsor",
            "State": "VT"
        },
        {
            "Code": "51001",
            "County": "Accomack",
            "State": "VA"
        },
        {
            "Code": "51003",
            "County": "Albemarle",
            "State": "VA"
        },
        {
            "Code": "51005",
            "County": "Alleghany",
            "State": "VA"
        },
        {
            "Code": "51007",
            "County": "Amelia",
            "State": "VA"
        },
        {
            "Code": "51009",
            "County": "Amherst",
            "State": "VA"
        },
        {
            "Code": "51011",
            "County": "Appomattox",
            "State": "VA"
        },
        {
            "Code": "51013",
            "County": "Arlington",
            "State": "VA"
        },
        {
            "Code": "51015",
            "County": "Augusta",
            "State": "VA"
        },
        {
            "Code": "51017",
            "County": "Bath",
            "State": "VA"
        },
        {
            "Code": "51019",
            "County": "Bedford",
            "State": "VA"
        },
        {
            "Code": "51021",
            "County": "Bland",
            "State": "VA"
        },
        {
            "Code": "51023",
            "County": "Botetourt",
            "State": "VA"
        },
        {
            "Code": "51025",
            "County": "Brunswick",
            "State": "VA"
        },
        {
            "Code": "51027",
            "County": "Buchanan",
            "State": "VA"
        },
        {
            "Code": "51029",
            "County": "Buckingham",
            "State": "VA"
        },
        {
            "Code": "51031",
            "County": "Campbell",
            "State": "VA"
        },
        {
            "Code": "51033",
            "County": "Caroline",
            "State": "VA"
        },
        {
            "Code": "51035",
            "County": "Carroll",
            "State": "VA"
        },
        {
            "Code": "51036",
            "County": "Charles City",
            "State": "VA"
        },
        {
            "Code": "51037",
            "County": "Charlotte",
            "State": "VA"
        },
        {
            "Code": "51041",
            "County": "Chesterfield",
            "State": "VA"
        },
        {
            "Code": "51043",
            "County": "Clarke",
            "State": "VA"
        },
        {
            "Code": "51045",
            "County": "Craig",
            "State": "VA"
        },
        {
            "Code": "51047",
            "County": "Culpeper",
            "State": "VA"
        },
        {
            "Code": "51049",
            "County": "Cumberland",
            "State": "VA"
        },
        {
            "Code": "51051",
            "County": "Dickenson",
            "State": "VA"
        },
        {
            "Code": "51053",
            "County": "Dinwiddie",
            "State": "VA"
        },
        {
            "Code": "51057",
            "County": "Essex",
            "State": "VA"
        },
        {
            "Code": "51059",
            "County": "Fairfax",
            "State": "VA"
        },
        {
            "Code": "51061",
            "County": "Fauquier",
            "State": "VA"
        },
        {
            "Code": "51063",
            "County": "Floyd",
            "State": "VA"
        },
        {
            "Code": "51065",
            "County": "Fluvanna",
            "State": "VA"
        },
        {
            "Code": "51067",
            "County": "Franklin",
            "State": "VA"
        },
        {
            "Code": "51069",
            "County": "Frederick",
            "State": "VA"
        },
        {
            "Code": "51071",
            "County": "Giles",
            "State": "VA"
        },
        {
            "Code": "51073",
            "County": "Gloucester",
            "State": "VA"
        },
        {
            "Code": "51075",
            "County": "Goochland",
            "State": "VA"
        },
        {
            "Code": "51077",
            "County": "Grayson",
            "State": "VA"
        },
        {
            "Code": "51079",
            "County": "Greene",
            "State": "VA"
        },
        {
            "Code": "51081",
            "County": "Greensville",
            "State": "VA"
        },
        {
            "Code": "51083",
            "County": "Halifax",
            "State": "VA"
        },
        {
            "Code": "51085",
            "County": "Hanover",
            "State": "VA"
        },
        {
            "Code": "51087",
            "County": "Henrico",
            "State": "VA"
        },
        {
            "Code": "51089",
            "County": "Henry",
            "State": "VA"
        },
        {
            "Code": "51091",
            "County": "Highland",
            "State": "VA"
        },
        {
            "Code": "51093",
            "County": "Isle of Wight",
            "State": "VA"
        },
        {
            "Code": "51095",
            "County": "James City",
            "State": "VA"
        },
        {
            "Code": "51097",
            "County": "King and Queen",
            "State": "VA"
        },
        {
            "Code": "51099",
            "County": "King George",
            "State": "VA"
        },
        {
            "Code": "51101",
            "County": "King William",
            "State": "VA"
        },
        {
            "Code": "51103",
            "County": "Lancaster",
            "State": "VA"
        },
        {
            "Code": "51105",
            "County": "Lee",
            "State": "VA"
        },
        {
            "Code": "51107",
            "County": "Loudoun",
            "State": "VA"
        },
        {
            "Code": "51109",
            "County": "Louisa",
            "State": "VA"
        },
        {
            "Code": "51111",
            "County": "Lunenburg",
            "State": "VA"
        },
        {
            "Code": "51113",
            "County": "Madison",
            "State": "VA"
        },
        {
            "Code": "51115",
            "County": "Mathews",
            "State": "VA"
        },
        {
            "Code": "51117",
            "County": "Mecklenburg",
            "State": "VA"
        },
        {
            "Code": "51119",
            "County": "Middlesex",
            "State": "VA"
        },
        {
            "Code": "51121",
            "County": "Montgomery",
            "State": "VA"
        },
        {
            "Code": "51125",
            "County": "Nelson",
            "State": "VA"
        },
        {
            "Code": "51127",
            "County": "New Kent",
            "State": "VA"
        },
        {
            "Code": "51131",
            "County": "Northampton",
            "State": "VA"
        },
        {
            "Code": "51133",
            "County": "Northumberland",
            "State": "VA"
        },
        {
            "Code": "51135",
            "County": "Nottoway",
            "State": "VA"
        },
        {
            "Code": "51137",
            "County": "Orange",
            "State": "VA"
        },
        {
            "Code": "51139",
            "County": "Page",
            "State": "VA"
        },
        {
            "Code": "51141",
            "County": "Patrick",
            "State": "VA"
        },
        {
            "Code": "51143",
            "County": "Pittsylvania",
            "State": "VA"
        },
        {
            "Code": "51145",
            "County": "Powhatan",
            "State": "VA"
        },
        {
            "Code": "51147",
            "County": "Prince Edward",
            "State": "VA"
        },
        {
            "Code": "51149",
            "County": "Prince George",
            "State": "VA"
        },
        {
            "Code": "51153",
            "County": "Prince William",
            "State": "VA"
        },
        {
            "Code": "51155",
            "County": "Pulaski",
            "State": "VA"
        },
        {
            "Code": "51157",
            "County": "Rappahannock",
            "State": "VA"
        },
        {
            "Code": "51159",
            "County": "Richmond",
            "State": "VA"
        },
        {
            "Code": "51161",
            "County": "Roanoke",
            "State": "VA"
        },
        {
            "Code": "51163",
            "County": "Rockbridge",
            "State": "VA"
        },
        {
            "Code": "51165",
            "County": "Rockingham",
            "State": "VA"
        },
        {
            "Code": "51167",
            "County": "Russell",
            "State": "VA"
        },
        {
            "Code": "51169",
            "County": "Scott",
            "State": "VA"
        },
        {
            "Code": "51171",
            "County": "Shenandoah",
            "State": "VA"
        },
        {
            "Code": "51173",
            "County": "Smyth",
            "State": "VA"
        },
        {
            "Code": "51175",
            "County": "Southampton",
            "State": "VA"
        },
        {
            "Code": "51177",
            "County": "Spotsylvania",
            "State": "VA"
        },
        {
            "Code": "51179",
            "County": "Stafford",
            "State": "VA"
        },
        {
            "Code": "51181",
            "County": "Surry",
            "State": "VA"
        },
        {
            "Code": "51183",
            "County": "Sussex",
            "State": "VA"
        },
        {
            "Code": "51185",
            "County": "Tazewell",
            "State": "VA"
        },
        {
            "Code": "51187",
            "County": "Warren",
            "State": "VA"
        },
        {
            "Code": "51191",
            "County": "Washington",
            "State": "VA"
        },
        {
            "Code": "51193",
            "County": "Westmoreland",
            "State": "VA"
        },
        {
            "Code": "51195",
            "County": "Wise",
            "State": "VA"
        },
        {
            "Code": "51197",
            "County": "Wythe",
            "State": "VA"
        },
        {
            "Code": "51199",
            "County": "York",
            "State": "VA"
        },
        {
            "Code": "51510",
            "County": "Alexandria City",
            "State": "VA"
        },
        {
            "Code": "51515",
            "County": "Bedford City",
            "State": "VA"
        },
        {
            "Code": "51520",
            "County": "Bristol City",
            "State": "VA"
        },
        {
            "Code": "51530",
            "County": "Buena Vista City",
            "State": "VA"
        },
        {
            "Code": "51540",
            "County": "Charlottesville City",
            "State": "VA"
        },
        {
            "Code": "51550",
            "County": "Chesapeake City",
            "State": "VA"
        },
        {
            "Code": "51560",
            "County": "Clifton Forge City",
            "State": "VA"
        },
        {
            "Code": "51570",
            "County": "Colonial Heights Cit",
            "State": "VA"
        },
        {
            "Code": "51580",
            "County": "Covington City",
            "State": "VA"
        },
        {
            "Code": "51590",
            "County": "Danville City",
            "State": "VA"
        },
        {
            "Code": "51595",
            "County": "Emporia City",
            "State": "VA"
        },
        {
            "Code": "51600",
            "County": "Fairfax City",
            "State": "VA"
        },
        {
            "Code": "51610",
            "County": "Falls Church City",
            "State": "VA"
        },
        {
            "Code": "51620",
            "County": "Franklin City",
            "State": "VA"
        },
        {
            "Code": "51630",
            "County": "Fredericksburg City",
            "State": "VA"
        },
        {
            "Code": "51640",
            "County": "Galax City",
            "State": "VA"
        },
        {
            "Code": "51650",
            "County": "Hampton City",
            "State": "VA"
        },
        {
            "Code": "51660",
            "County": "Harrisonburg City",
            "State": "VA"
        },
        {
            "Code": "51670",
            "County": "Hopewell City",
            "State": "VA"
        },
        {
            "Code": "51678",
            "County": "Lexington City",
            "State": "VA"
        },
        {
            "Code": "51680",
            "County": "Lynchburg City",
            "State": "VA"
        },
        {
            "Code": "51683",
            "County": "Manassas City",
            "State": "VA"
        },
        {
            "Code": "51685",
            "County": "Manassas Park City",
            "State": "VA"
        },
        {
            "Code": "51690",
            "County": "Martinsville City",
            "State": "VA"
        },
        {
            "Code": "51700",
            "County": "Newport News City",
            "State": "VA"
        },
        {
            "Code": "51710",
            "County": "Norfolk City",
            "State": "VA"
        },
        {
            "Code": "51720",
            "County": "Norton City",
            "State": "VA"
        },
        {
            "Code": "51730",
            "County": "Petersburg City",
            "State": "VA"
        },
        {
            "Code": "51735",
            "County": "Poquoson City",
            "State": "VA"
        },
        {
            "Code": "51740",
            "County": "Portsmouth City",
            "State": "VA"
        },
        {
            "Code": "51750",
            "County": "Radford City",
            "State": "VA"
        },
        {
            "Code": "51760",
            "County": "Richmond City",
            "State": "VA"
        },
        {
            "Code": "51770",
            "County": "Roanoke City",
            "State": "VA"
        },
        {
            "Code": "51775",
            "County": "Salem City",
            "State": "VA"
        },
        {
            "Code": "51780",
            "County": "South Boston City",
            "State": "VA"
        },
        {
            "Code": "51790",
            "County": "Staunton City",
            "State": "VA"
        },
        {
            "Code": "51800",
            "County": "Suffolk City",
            "State": "VA"
        },
        {
            "Code": "51810",
            "County": "Virginia Beach City",
            "State": "VA"
        },
        {
            "Code": "51820",
            "County": "Waynesboro City",
            "State": "VA"
        },
        {
            "Code": "51830",
            "County": "Williamsburg City",
            "State": "VA"
        },
        {
            "Code": "51840",
            "County": "Winchester City",
            "State": "VA"
        },
        {
            "Code": "53001",
            "County": "Adams",
            "State": "WA"
        },
        {
            "Code": "53003",
            "County": "Asotin",
            "State": "WA"
        },
        {
            "Code": "53005",
            "County": "Benton",
            "State": "WA"
        },
        {
            "Code": "53007",
            "County": "Chelan",
            "State": "WA"
        },
        {
            "Code": "53009",
            "County": "Clallam",
            "State": "WA"
        },
        {
            "Code": "53011",
            "County": "Clark",
            "State": "WA"
        },
        {
            "Code": "53013",
            "County": "Columbia",
            "State": "WA"
        },
        {
            "Code": "53015",
            "County": "Cowlitz",
            "State": "WA"
        },
        {
            "Code": "53017",
            "County": "Douglas",
            "State": "WA"
        },
        {
            "Code": "53019",
            "County": "Ferry",
            "State": "WA"
        },
        {
            "Code": "53021",
            "County": "Franklin",
            "State": "WA"
        },
        {
            "Code": "53023",
            "County": "Garfield",
            "State": "WA"
        },
        {
            "Code": "53025",
            "County": "Grant",
            "State": "WA"
        },
        {
            "Code": "53027",
            "County": "Grays Harbor",
            "State": "WA"
        },
        {
            "Code": "53029",
            "County": "Island",
            "State": "WA"
        },
        {
            "Code": "53031",
            "County": "Jefferson",
            "State": "WA"
        },
        {
            "Code": "53033",
            "County": "King",
            "State": "WA"
        },
        {
            "Code": "53035",
            "County": "Kitsap",
            "State": "WA"
        },
        {
            "Code": "53037",
            "County": "Kittitas",
            "State": "WA"
        },
        {
            "Code": "53039",
            "County": "Klickitat",
            "State": "WA"
        },
        {
            "Code": "53041",
            "County": "Lewis",
            "State": "WA"
        },
        {
            "Code": "53043",
            "County": "Lincoln",
            "State": "WA"
        },
        {
            "Code": "53045",
            "County": "Mason",
            "State": "WA"
        },
        {
            "Code": "53047",
            "County": "Okanogan",
            "State": "WA"
        },
        {
            "Code": "53049",
            "County": "Pacific",
            "State": "WA"
        },
        {
            "Code": "53051",
            "County": "Pend Oreille",
            "State": "WA"
        },
        {
            "Code": "53053",
            "County": "Pierce",
            "State": "WA"
        },
        {
            "Code": "53055",
            "County": "San Juan",
            "State": "WA"
        },
        {
            "Code": "53057",
            "County": "Skagit",
            "State": "WA"
        },
        {
            "Code": "53059",
            "County": "Skamania",
            "State": "WA"
        },
        {
            "Code": "53061",
            "County": "Snohomish",
            "State": "WA"
        },
        {
            "Code": "53063",
            "County": "Spokane",
            "State": "WA"
        },
        {
            "Code": "53065",
            "County": "Stevens",
            "State": "WA"
        },
        {
            "Code": "53067",
            "County": "Thurston",
            "State": "WA"
        },
        {
            "Code": "53069",
            "County": "Wahkiakum",
            "State": "WA"
        },
        {
            "Code": "53071",
            "County": "Walla Walla",
            "State": "WA"
        },
        {
            "Code": "53073",
            "County": "Whatcom",
            "State": "WA"
        },
        {
            "Code": "53075",
            "County": "Whitman",
            "State": "WA"
        },
        {
            "Code": "53077",
            "County": "Yakima",
            "State": "WA"
        },
        {
            "Code": "54001",
            "County": "Barbour",
            "State": "WV"
        },
        {
            "Code": "54003",
            "County": "Berkeley",
            "State": "WV"
        },
        {
            "Code": "54005",
            "County": "Boone",
            "State": "WV"
        },
        {
            "Code": "54007",
            "County": "Braxton",
            "State": "WV"
        },
        {
            "Code": "54009",
            "County": "Brooke",
            "State": "WV"
        },
        {
            "Code": "54011",
            "County": "Cabell",
            "State": "WV"
        },
        {
            "Code": "54013",
            "County": "Calhoun",
            "State": "WV"
        },
        {
            "Code": "54015",
            "County": "Clay",
            "State": "WV"
        },
        {
            "Code": "54017",
            "County": "Doddridge",
            "State": "WV"
        },
        {
            "Code": "54019",
            "County": "Fayette",
            "State": "WV"
        },
        {
            "Code": "54021",
            "County": "Gilmer",
            "State": "WV"
        },
        {
            "Code": "54023",
            "County": "Grant",
            "State": "WV"
        },
        {
            "Code": "54025",
            "County": "Greenbrier",
            "State": "WV"
        },
        {
            "Code": "54027",
            "County": "Hampshire",
            "State": "WV"
        },
        {
            "Code": "54029",
            "County": "Hancock",
            "State": "WV"
        },
        {
            "Code": "54031",
            "County": "Hardy",
            "State": "WV"
        },
        {
            "Code": "54033",
            "County": "Harrison",
            "State": "WV"
        },
        {
            "Code": "54035",
            "County": "Jackson",
            "State": "WV"
        },
        {
            "Code": "54037",
            "County": "Jefferson",
            "State": "WV"
        },
        {
            "Code": "54039",
            "County": "Kanawha",
            "State": "WV"
        },
        {
            "Code": "54041",
            "County": "Lewis",
            "State": "WV"
        },
        {
            "Code": "54043",
            "County": "Lincoln",
            "State": "WV"
        },
        {
            "Code": "54045",
            "County": "Logan",
            "State": "WV"
        },
        {
            "Code": "54047",
            "County": "McDowell",
            "State": "WV"
        },
        {
            "Code": "54049",
            "County": "Marion",
            "State": "WV"
        },
        {
            "Code": "54051",
            "County": "Marshall",
            "State": "WV"
        },
        {
            "Code": "54053",
            "County": "Mason",
            "State": "WV"
        },
        {
            "Code": "54055",
            "County": "Mercer",
            "State": "WV"
        },
        {
            "Code": "54057",
            "County": "Mineral",
            "State": "WV"
        },
        {
            "Code": "54059",
            "County": "Mingo",
            "State": "WV"
        },
        {
            "Code": "54061",
            "County": "Monongalia",
            "State": "WV"
        },
        {
            "Code": "54063",
            "County": "Monroe",
            "State": "WV"
        },
        {
            "Code": "54065",
            "County": "Morgan",
            "State": "WV"
        },
        {
            "Code": "54067",
            "County": "Nicholas",
            "State": "WV"
        },
        {
            "Code": "54069",
            "County": "Ohio",
            "State": "WV"
        },
        {
            "Code": "54071",
            "County": "Pendleton",
            "State": "WV"
        },
        {
            "Code": "54073",
            "County": "Pleasants",
            "State": "WV"
        },
        {
            "Code": "54075",
            "County": "Pocahontas",
            "State": "WV"
        },
        {
            "Code": "54077",
            "County": "Preston",
            "State": "WV"
        },
        {
            "Code": "54079",
            "County": "Putnam",
            "State": "WV"
        },
        {
            "Code": "54081",
            "County": "Raleigh",
            "State": "WV"
        },
        {
            "Code": "54083",
            "County": "Randolph",
            "State": "WV"
        },
        {
            "Code": "54085",
            "County": "Ritchie",
            "State": "WV"
        },
        {
            "Code": "54087",
            "County": "Roane",
            "State": "WV"
        },
        {
            "Code": "54089",
            "County": "Summers",
            "State": "WV"
        },
        {
            "Code": "54091",
            "County": "Taylor",
            "State": "WV"
        },
        {
            "Code": "54093",
            "County": "Tucker",
            "State": "WV"
        },
        {
            "Code": "54095",
            "County": "Tyler",
            "State": "WV"
        },
        {
            "Code": "54097",
            "County": "Upshur",
            "State": "WV"
        },
        {
            "Code": "54099",
            "County": "Wayne",
            "State": "WV"
        },
        {
            "Code": "54101",
            "County": "Webster",
            "State": "WV"
        },
        {
            "Code": "54103",
            "County": "Wetzel",
            "State": "WV"
        },
        {
            "Code": "54105",
            "County": "Wirt",
            "State": "WV"
        },
        {
            "Code": "54107",
            "County": "Wood",
            "State": "WV"
        },
        {
            "Code": "54109",
            "County": "Wyoming",
            "State": "WV"
        },
        {
            "Code": "55001",
            "County": "Adams",
            "State": "WI"
        },
        {
            "Code": "55003",
            "County": "Ashland",
            "State": "WI"
        },
        {
            "Code": "55005",
            "County": "Barron",
            "State": "WI"
        },
        {
            "Code": "55007",
            "County": "Bayfield",
            "State": "WI"
        },
        {
            "Code": "55009",
            "County": "Brown",
            "State": "WI"
        },
        {
            "Code": "55011",
            "County": "Buffalo",
            "State": "WI"
        },
        {
            "Code": "55013",
            "County": "Burnett",
            "State": "WI"
        },
        {
            "Code": "55015",
            "County": "Calumet",
            "State": "WI"
        },
        {
            "Code": "55017",
            "County": "Chippewa",
            "State": "WI"
        },
        {
            "Code": "55019",
            "County": "Clark",
            "State": "WI"
        },
        {
            "Code": "55021",
            "County": "Columbia",
            "State": "WI"
        },
        {
            "Code": "55023",
            "County": "Crawford",
            "State": "WI"
        },
        {
            "Code": "55025",
            "County": "Dane",
            "State": "WI"
        },
        {
            "Code": "55027",
            "County": "Dodge",
            "State": "WI"
        },
        {
            "Code": "55029",
            "County": "Door",
            "State": "WI"
        },
        {
            "Code": "55031",
            "County": "Douglas",
            "State": "WI"
        },
        {
            "Code": "55033",
            "County": "Dunn",
            "State": "WI"
        },
        {
            "Code": "55035",
            "County": "Eau Claire",
            "State": "WI"
        },
        {
            "Code": "55037",
            "County": "Florence",
            "State": "WI"
        },
        {
            "Code": "55039",
            "County": "Fond du Lac",
            "State": "WI"
        },
        {
            "Code": "55041",
            "County": "Forest",
            "State": "WI"
        },
        {
            "Code": "55043",
            "County": "Grant",
            "State": "WI"
        },
        {
            "Code": "55045",
            "County": "Green",
            "State": "WI"
        },
        {
            "Code": "55047",
            "County": "Green Lake",
            "State": "WI"
        },
        {
            "Code": "55049",
            "County": "Iowa",
            "State": "WI"
        },
        {
            "Code": "55051",
            "County": "Iron",
            "State": "WI"
        },
        {
            "Code": "55053",
            "County": "Jackson",
            "State": "WI"
        },
        {
            "Code": "55055",
            "County": "Jefferson",
            "State": "WI"
        },
        {
            "Code": "55057",
            "County": "Juneau",
            "State": "WI"
        },
        {
            "Code": "55059",
            "County": "Kenosha",
            "State": "WI"
        },
        {
            "Code": "55061",
            "County": "Kewaunee",
            "State": "WI"
        },
        {
            "Code": "55063",
            "County": "La Crosse",
            "State": "WI"
        },
        {
            "Code": "55065",
            "County": "Lafayette",
            "State": "WI"
        },
        {
            "Code": "55067",
            "County": "Langlade",
            "State": "WI"
        },
        {
            "Code": "55069",
            "County": "Lincoln",
            "State": "WI"
        },
        {
            "Code": "55071",
            "County": "Manitowoc",
            "State": "WI"
        },
        {
            "Code": "55073",
            "County": "Marathon",
            "State": "WI"
        },
        {
            "Code": "55075",
            "County": "Marinette",
            "State": "WI"
        },
        {
            "Code": "55077",
            "County": "Marquette",
            "State": "WI"
        },
        {
            "Code": "55078",
            "County": "Menominee",
            "State": "WI"
        },
        {
            "Code": "55079",
            "County": "Milwaukee",
            "State": "WI"
        },
        {
            "Code": "55081",
            "County": "Monroe",
            "State": "WI"
        },
        {
            "Code": "55083",
            "County": "Oconto",
            "State": "WI"
        },
        {
            "Code": "55085",
            "County": "Oneida",
            "State": "WI"
        },
        {
            "Code": "55087",
            "County": "Outagamie",
            "State": "WI"
        },
        {
            "Code": "55089",
            "County": "Ozaukee",
            "State": "WI"
        },
        {
            "Code": "55091",
            "County": "Pepin",
            "State": "WI"
        },
        {
            "Code": "55093",
            "County": "Pierce",
            "State": "WI"
        },
        {
            "Code": "55095",
            "County": "Polk",
            "State": "WI"
        },
        {
            "Code": "55097",
            "County": "Portage",
            "State": "WI"
        },
        {
            "Code": "55099",
            "County": "Price",
            "State": "WI"
        },
        {
            "Code": "55101",
            "County": "Racine",
            "State": "WI"
        },
        {
            "Code": "55103",
            "County": "Richland",
            "State": "WI"
        },
        {
            "Code": "55105",
            "County": "Rock",
            "State": "WI"
        },
        {
            "Code": "55107",
            "County": "Rusk",
            "State": "WI"
        },
        {
            "Code": "55109",
            "County": "St Croix",
            "State": "WI"
        },
        {
            "Code": "55111",
            "County": "Sauk",
            "State": "WI"
        },
        {
            "Code": "55113",
            "County": "Sawyer",
            "State": "WI"
        },
        {
            "Code": "55115",
            "County": "Shawano",
            "State": "WI"
        },
        {
            "Code": "55117",
            "County": "Sheboygan",
            "State": "WI"
        },
        {
            "Code": "55119",
            "County": "Taylor",
            "State": "WI"
        },
        {
            "Code": "55121",
            "County": "Trempealeau",
            "State": "WI"
        },
        {
            "Code": "55123",
            "County": "Vernon",
            "State": "WI"
        },
        {
            "Code": "55125",
            "County": "Vilas",
            "State": "WI"
        },
        {
            "Code": "55127",
            "County": "Walworth",
            "State": "WI"
        },
        {
            "Code": "55129",
            "County": "Washburn",
            "State": "WI"
        },
        {
            "Code": "55131",
            "County": "Washington",
            "State": "WI"
        },
        {
            "Code": "55133",
            "County": "Waukesha",
            "State": "WI"
        },
        {
            "Code": "55135",
            "County": "Waupaca",
            "State": "WI"
        },
        {
            "Code": "55137",
            "County": "Waushara",
            "State": "WI"
        },
        {
            "Code": "55139",
            "County": "Winnebago",
            "State": "WI"
        },
        {
            "Code": "55141",
            "County": "Wood",
            "State": "WI"
        },
        {
            "Code": "56001",
            "County": "Albany",
            "State": "WY"
        },
        {
            "Code": "56003",
            "County": "Big Horn",
            "State": "WY"
        },
        {
            "Code": "56005",
            "County": "Campbell",
            "State": "WY"
        },
        {
            "Code": "56007",
            "County": "Carbon",
            "State": "WY"
        },
        {
            "Code": "56009",
            "County": "Converse",
            "State": "WY"
        },
        {
            "Code": "56011",
            "County": "Crook",
            "State": "WY"
        },
        {
            "Code": "56013",
            "County": "Fremont",
            "State": "WY"
        },
        {
            "Code": "56015",
            "County": "Goshen",
            "State": "WY"
        },
        {
            "Code": "56017",
            "County": "Hot Springs",
            "State": "WY"
        },
        {
            "Code": "56019",
            "County": "Johnson",
            "State": "WY"
        },
        {
            "Code": "56021",
            "County": "Laramie",
            "State": "WY"
        },
        {
            "Code": "56023",
            "County": "Lincoln",
            "State": "WY"
        },
        {
            "Code": "56025",
            "County": "Natrona",
            "State": "WY"
        },
        {
            "Code": "56027",
            "County": "Niobrara",
            "State": "WY"
        },
        {
            "Code": "56029",
            "County": "Park",
            "State": "WY"
        },
        {
            "Code": "56031",
            "County": "Platte",
            "State": "WY"
        },
        {
            "Code": "56033",
            "County": "Sheridan",
            "State": "WY"
        },
        {
            "Code": "56035",
            "County": "Sublette",
            "State": "WY"
        },
        {
            "Code": "56037",
            "County": "Sweetwater",
            "State": "WY"
        },
        {
            "Code": "56039",
            "County": "Teton",
            "State": "WY"
        },
        {
            "Code": "56041",
            "County": "Uinta",
            "State": "WY"
        },
        {
            "Code": "56043",
            "County": "Washakie",
            "State": "WY"
        },
        {
            "Code": "56045",
            "County": "Weston",
            "State": "WY"
        },
        {
            "Code": "60010",
            "County": "Unknown",
            "State": "AS"
        },
        {
            "Code": "60020",
            "County": "Manua",
            "State": "AS"
        },
        {
            "Code": "60020",
            "County": "Ofu",
            "State": "AS"
        },
        {
            "Code": "60020",
            "County": "Olosega",
            "State": "AS"
        },
        {
            "Code": "60050",
            "County": "Tutuila",
            "State": "AS"
        },
        {
            "Code": "66010",
            "County": "Cocos Island",
            "State": "MP"
        },
        {
            "Code": "66010",
            "County": "Guam",
            "State": "GU"
        },
        {
            "Code": "69100",
            "County": "Rota",
            "State": "MP"
        },
        {
            "Code": "69110",
            "County": "Saipan",
            "State": "MP"
        },
        {
            "Code": "69120",
            "County": "Aguijan",
            "State": "MP"
        },
        {
            "Code": "69120",
            "County": "Tinian",
            "State": "MP"
        },
        {
            "Code": "72001",
            "County": "Adjuntas",
            "State": "PR"
        },
        {
            "Code": "72003",
            "County": "Aguada",
            "State": "PR"
        },
        {
            "Code": "72005",
            "County": "Aguadilla",
            "State": "PR"
        },
        {
            "Code": "72007",
            "County": "Aguas Buenas",
            "State": "PR"
        },
        {
            "Code": "72009",
            "County": "Aibonito",
            "State": "PR"
        },
        {
            "Code": "72011",
            "County": "Anasco",
            "State": "PR"
        },
        {
            "Code": "72013",
            "County": "Arecibo",
            "State": "PR"
        },
        {
            "Code": "72015",
            "County": "Arroyo",
            "State": "PR"
        },
        {
            "Code": "72017",
            "County": "Barceloneta",
            "State": "PR"
        },
        {
            "Code": "72019",
            "County": "Barranquitas",
            "State": "PR"
        },
        {
            "Code": "72021",
            "County": "Bayamon",
            "State": "PR"
        },
        {
            "Code": "72023",
            "County": "Cabo Rojo",
            "State": "PR"
        },
        {
            "Code": "72025",
            "County": "Caguas",
            "State": "PR"
        },
        {
            "Code": "72027",
            "County": "Camuy",
            "State": "PR"
        },
        {
            "Code": "72029",
            "County": "Canovanas",
            "State": "PR"
        },
        {
            "Code": "72031",
            "County": "Carolina",
            "State": "PR"
        },
        {
            "Code": "72033",
            "County": "Catano",
            "State": "PR"
        },
        {
            "Code": "72035",
            "County": "Cayey",
            "State": "PR"
        },
        {
            "Code": "72037",
            "County": "Ceiba",
            "State": "PR"
        },
        {
            "Code": "72041",
            "County": "Cidra",
            "State": "PR"
        },
        {
            "Code": "72043",
            "County": "Coamo",
            "State": "PR"
        },
        {
            "Code": "72045",
            "County": "Comerio",
            "State": "PR"
        },
        {
            "Code": "72047",
            "County": "Corozal",
            "State": "PR"
        },
        {
            "Code": "72049",
            "County": "Culebra",
            "State": "PR"
        },
        {
            "Code": "72051",
            "County": "Dorado",
            "State": "PR"
        },
        {
            "Code": "72053",
            "County": "Fajardo",
            "State": "PR"
        },
        {
            "Code": "72054",
            "County": "Florida",
            "State": "PR"
        },
        {
            "Code": "72055",
            "County": "Guanica",
            "State": "PR"
        },
        {
            "Code": "72057",
            "County": "Guayama",
            "State": "PR"
        },
        {
            "Code": "72059",
            "County": "Guayanilla",
            "State": "PR"
        },
        {
            "Code": "72061",
            "County": "Guaynabo",
            "State": "PR"
        },
        {
            "Code": "72063",
            "County": "Gurabo",
            "State": "PR"
        },
        {
            "Code": "72065",
            "County": "Hatillo",
            "State": "PR"
        },
        {
            "Code": "72067",
            "County": "Hormigueros",
            "State": "PR"
        },
        {
            "Code": "72071",
            "County": "Isabela",
            "State": "PR"
        },
        {
            "Code": "72073",
            "County": "Jayuya",
            "State": "PR"
        },
        {
            "Code": "72075",
            "County": "Juana Diaz",
            "State": "PR"
        },
        {
            "Code": "72077",
            "County": "Juncos",
            "State": "PR"
        },
        {
            "Code": "72079",
            "County": "Lajas",
            "State": "PR"
        },
        {
            "Code": "72081",
            "County": "Lares",
            "State": "PR"
        },
        {
            "Code": "72083",
            "County": "Las Marias",
            "State": "PR"
        },
        {
            "Code": "72085",
            "County": "Las Piedras",
            "State": "PR"
        },
        {
            "Code": "72087",
            "County": "Loiza",
            "State": "PR"
        },
        {
            "Code": "72089",
            "County": "Luquillo",
            "State": "PR"
        },
        {
            "Code": "72091",
            "County": "Manati",
            "State": "PR"
        },
        {
            "Code": "72093",
            "County": "Maricao",
            "State": "PR"
        },
        {
            "Code": "72095",
            "County": "Maunabo",
            "State": "PR"
        },
        {
            "Code": "72097",
            "County": "Mayaguez",
            "State": "PR"
        },
        {
            "Code": "72099",
            "County": "Moca",
            "State": "PR"
        },
        {
            "Code": "72101",
            "County": "Morovis",
            "State": "PR"
        },
        {
            "Code": "72103",
            "County": "Nabuabo",
            "State": "PR"
        },
        {
            "Code": "72105",
            "County": "Naranjito",
            "State": "PR"
        },
        {
            "Code": "72107",
            "County": "Orocovis",
            "State": "PR"
        },
        {
            "Code": "72109",
            "County": "Patillas",
            "State": "PR"
        },
        {
            "Code": "72111",
            "County": "Penuelas",
            "State": "PR"
        },
        {
            "Code": "72113",
            "County": "Ponce",
            "State": "PR"
        },
        {
            "Code": "72115",
            "County": "Quebradillas",
            "State": "PR"
        },
        {
            "Code": "72117",
            "County": "Rincon",
            "State": "PR"
        },
        {
            "Code": "72119",
            "County": "Rio Grande",
            "State": "PR"
        },
        {
            "Code": "72121",
            "County": "Sabana Grande",
            "State": "PR"
        },
        {
            "Code": "72123",
            "County": "Salinas",
            "State": "PR"
        },
        {
            "Code": "72125",
            "County": "San German",
            "State": "PR"
        },
        {
            "Code": "72127",
            "County": "San Juan",
            "State": "PR"
        },
        {
            "Code": "72129",
            "County": "San Lorenzo",
            "State": "PR"
        },
        {
            "Code": "72131",
            "County": "San Sabastian",
            "State": "PR"
        },
        {
            "Code": "72133",
            "County": "Santa Isabel",
            "State": "PR"
        },
        {
            "Code": "72135",
            "County": "Toa Alta",
            "State": "PR"
        },
        {
            "Code": "72137",
            "County": "Toa Baja",
            "State": "PR"
        },
        {
            "Code": "72139",
            "County": "Trujillo Alto",
            "State": "PR"
        },
        {
            "Code": "72141",
            "County": "Utuado",
            "State": "PR"
        },
        {
            "Code": "72143",
            "County": "Vega Alta",
            "State": "PR"
        },
        {
            "Code": "72145",
            "County": "Vega Baja",
            "State": "PR"
        },
        {
            "Code": "72147",
            "County": "Vieques",
            "State": "PR"
        },
        {
            "Code": "72149",
            "County": "Villalba",
            "State": "PR"
        },
        {
            "Code": "72151",
            "County": "Yabucoa",
            "State": "PR"
        },
        {
            "Code": "72153",
            "County": "Yauco",
            "State": "PR"
        },
        {
            "Code": "78010",
            "County": "St. Croix",
            "State": "VI"
        },
        {
            "Code": "78020",
            "County": "St. John",
            "State": "VI"
        },
        {
            "Code": "78030",
            "County": "St. Thomas",
            "State": "VI"
        }
    ];


module.exports.fips = fips;